
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hRi0x", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d0055ad792017042$export$ffb0004e005737fa; }, function (v) { return $d0055ad792017042$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d0055ad792017042$export$34b9dba7ce09269b; }, function (v) { return $d0055ad792017042$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d0055ad792017042$export$25062201e9e25d76; }, function (v) { return $d0055ad792017042$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d0055ad792017042$export$ffb0004e005737fa;
var $d0055ad792017042$export$34b9dba7ce09269b;
var $d0055ad792017042$export$25062201e9e25d76;
"use strict";
parcelRequire("45nop");

var $5KQk5 = parcelRequire("5KQk5");
var $d0055ad792017042$var$g = 60103;
$d0055ad792017042$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $d0055ad792017042$var$h = Symbol.for;
    $d0055ad792017042$var$g = $d0055ad792017042$var$h("react.element");
    $d0055ad792017042$export$ffb0004e005737fa = $d0055ad792017042$var$h("react.fragment");
}
var $d0055ad792017042$var$m = $5KQk5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d0055ad792017042$var$n = Object.prototype.hasOwnProperty, $d0055ad792017042$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d0055ad792017042$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$d0055ad792017042$var$n.call(a, b) && !$d0055ad792017042$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d0055ad792017042$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $d0055ad792017042$var$m.current
    };
}
$d0055ad792017042$export$34b9dba7ce09269b = $d0055ad792017042$var$q;
$d0055ad792017042$export$25062201e9e25d76 = $d0055ad792017042$var$q;

});
parcelRegister("45nop", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $2f99c65fcca112b0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2f99c65fcca112b0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2f99c65fcca112b0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $2f99c65fcca112b0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $2f99c65fcca112b0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $2f99c65fcca112b0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $2f99c65fcca112b0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($2f99c65fcca112b0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($2f99c65fcca112b0$var$getOwnPropertySymbols) {
            symbols = $2f99c65fcca112b0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($2f99c65fcca112b0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("5KQk5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7teDi"));

});
parcelRegister("7teDi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $5706979c38e91847$export$ffb0004e005737fa; }, function (v) { return $5706979c38e91847$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5706979c38e91847$export$5f8d39834fd61797; }, function (v) { return $5706979c38e91847$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $5706979c38e91847$export$e2c29f18771995cb; }, function (v) { return $5706979c38e91847$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $5706979c38e91847$export$74bf444e3cd11ea5; }, function (v) { return $5706979c38e91847$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $5706979c38e91847$export$dca3b0875bd9a954; }, function (v) { return $5706979c38e91847$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5706979c38e91847$export$16fa2f45be04daa8; }, function (v) { return $5706979c38e91847$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5706979c38e91847$export$221d75b3f55bb0bd; }, function (v) { return $5706979c38e91847$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5706979c38e91847$export$ae55be85d98224ed; }, function (v) { return $5706979c38e91847$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5706979c38e91847$export$e530037191fcd5d7; }, function (v) { return $5706979c38e91847$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5706979c38e91847$export$fd42f52fd3ae1109; }, function (v) { return $5706979c38e91847$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5706979c38e91847$export$c8a8987d4410bf2d; }, function (v) { return $5706979c38e91847$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $5706979c38e91847$export$d38cd72104c1f0e9; }, function (v) { return $5706979c38e91847$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $5706979c38e91847$export$7d1e3a5e95ceca43; }, function (v) { return $5706979c38e91847$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5706979c38e91847$export$257a8862b851cb5b; }, function (v) { return $5706979c38e91847$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5706979c38e91847$export$a8257692ac88316c; }, function (v) { return $5706979c38e91847$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5706979c38e91847$export$488013bae63b21da; }, function (v) { return $5706979c38e91847$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5706979c38e91847$export$7c73462e0d25e514; }, function (v) { return $5706979c38e91847$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5706979c38e91847$export$35808ee640e87ca7; }, function (v) { return $5706979c38e91847$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5706979c38e91847$export$fae74005e78b1a27; }, function (v) { return $5706979c38e91847$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5706979c38e91847$export$dc8fbce3eb94dc1e; }, function (v) { return $5706979c38e91847$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $5706979c38e91847$export$6d9c69b0de29b591; }, function (v) { return $5706979c38e91847$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5706979c38e91847$export$d5a552a76deda3c2; }, function (v) { return $5706979c38e91847$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5706979c38e91847$export$e5c5a5f917a5871c; }, function (v) { return $5706979c38e91847$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5706979c38e91847$export$1538c33de8887b59; }, function (v) { return $5706979c38e91847$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $5706979c38e91847$export$13e3392192263954; }, function (v) { return $5706979c38e91847$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5706979c38e91847$export$b8f5890fc79d6aca; }, function (v) { return $5706979c38e91847$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5706979c38e91847$export$60241385465d0a34; }, function (v) { return $5706979c38e91847$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $5706979c38e91847$export$83d89fbfd8236492; }, function (v) { return $5706979c38e91847$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5706979c38e91847$export$ffb0004e005737fa;
var $5706979c38e91847$export$5f8d39834fd61797;
var $5706979c38e91847$export$e2c29f18771995cb;
var $5706979c38e91847$export$74bf444e3cd11ea5;
var $5706979c38e91847$export$dca3b0875bd9a954;
var $5706979c38e91847$export$16fa2f45be04daa8;
var $5706979c38e91847$export$221d75b3f55bb0bd;
var $5706979c38e91847$export$ae55be85d98224ed;
var $5706979c38e91847$export$e530037191fcd5d7;
var $5706979c38e91847$export$fd42f52fd3ae1109;
var $5706979c38e91847$export$c8a8987d4410bf2d;
var $5706979c38e91847$export$d38cd72104c1f0e9;
var $5706979c38e91847$export$7d1e3a5e95ceca43;
var $5706979c38e91847$export$257a8862b851cb5b;
var $5706979c38e91847$export$a8257692ac88316c;
var $5706979c38e91847$export$488013bae63b21da;
var $5706979c38e91847$export$7c73462e0d25e514;
var $5706979c38e91847$export$35808ee640e87ca7;
var $5706979c38e91847$export$fae74005e78b1a27;
var $5706979c38e91847$export$dc8fbce3eb94dc1e;
var $5706979c38e91847$export$6d9c69b0de29b591;
var $5706979c38e91847$export$d5a552a76deda3c2;
var $5706979c38e91847$export$e5c5a5f917a5871c;
var $5706979c38e91847$export$1538c33de8887b59;
var $5706979c38e91847$export$13e3392192263954;
var $5706979c38e91847$export$b8f5890fc79d6aca;
var $5706979c38e91847$export$60241385465d0a34;
var $5706979c38e91847$export$83d89fbfd8236492;
"use strict";

var $45nop = parcelRequire("45nop");
var $5706979c38e91847$var$n = 60103, $5706979c38e91847$var$p = 60106;
$5706979c38e91847$export$ffb0004e005737fa = 60107;
$5706979c38e91847$export$5f8d39834fd61797 = 60108;
$5706979c38e91847$export$e2c29f18771995cb = 60114;
var $5706979c38e91847$var$q = 60109, $5706979c38e91847$var$r = 60110, $5706979c38e91847$var$t = 60112;
$5706979c38e91847$export$74bf444e3cd11ea5 = 60113;
var $5706979c38e91847$var$u = 60115, $5706979c38e91847$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $5706979c38e91847$var$w = Symbol.for;
    $5706979c38e91847$var$n = $5706979c38e91847$var$w("react.element");
    $5706979c38e91847$var$p = $5706979c38e91847$var$w("react.portal");
    $5706979c38e91847$export$ffb0004e005737fa = $5706979c38e91847$var$w("react.fragment");
    $5706979c38e91847$export$5f8d39834fd61797 = $5706979c38e91847$var$w("react.strict_mode");
    $5706979c38e91847$export$e2c29f18771995cb = $5706979c38e91847$var$w("react.profiler");
    $5706979c38e91847$var$q = $5706979c38e91847$var$w("react.provider");
    $5706979c38e91847$var$r = $5706979c38e91847$var$w("react.context");
    $5706979c38e91847$var$t = $5706979c38e91847$var$w("react.forward_ref");
    $5706979c38e91847$export$74bf444e3cd11ea5 = $5706979c38e91847$var$w("react.suspense");
    $5706979c38e91847$var$u = $5706979c38e91847$var$w("react.memo");
    $5706979c38e91847$var$v = $5706979c38e91847$var$w("react.lazy");
}
var $5706979c38e91847$var$x = "function" === typeof Symbol && Symbol.iterator;
function $5706979c38e91847$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5706979c38e91847$var$x && a[$5706979c38e91847$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $5706979c38e91847$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5706979c38e91847$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5706979c38e91847$var$B = {};
function $5706979c38e91847$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $5706979c38e91847$var$B;
    this.updater = c || $5706979c38e91847$var$A;
}
$5706979c38e91847$var$C.prototype.isReactComponent = {};
$5706979c38e91847$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($5706979c38e91847$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$5706979c38e91847$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $5706979c38e91847$var$D() {}
$5706979c38e91847$var$D.prototype = $5706979c38e91847$var$C.prototype;
function $5706979c38e91847$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $5706979c38e91847$var$B;
    this.updater = c || $5706979c38e91847$var$A;
}
var $5706979c38e91847$var$F = $5706979c38e91847$var$E.prototype = new $5706979c38e91847$var$D;
$5706979c38e91847$var$F.constructor = $5706979c38e91847$var$E;
$45nop($5706979c38e91847$var$F, $5706979c38e91847$var$C.prototype);
$5706979c38e91847$var$F.isPureReactComponent = !0;
var $5706979c38e91847$var$G = {
    current: null
}, $5706979c38e91847$var$H = Object.prototype.hasOwnProperty, $5706979c38e91847$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $5706979c38e91847$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$5706979c38e91847$var$H.call(b, e) && !$5706979c38e91847$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $5706979c38e91847$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $5706979c38e91847$var$G.current
    };
}
function $5706979c38e91847$var$K(a, b) {
    return {
        $$typeof: $5706979c38e91847$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $5706979c38e91847$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5706979c38e91847$var$n;
}
function $5706979c38e91847$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $5706979c38e91847$var$M = /\/+/g;
function $5706979c38e91847$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $5706979c38e91847$var$escape("" + a.key) : b.toString(36);
}
function $5706979c38e91847$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $5706979c38e91847$var$n:
                case $5706979c38e91847$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $5706979c38e91847$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($5706979c38e91847$var$M, "$&/") + "/"), $5706979c38e91847$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($5706979c38e91847$var$L(d) && (d = $5706979c38e91847$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($5706979c38e91847$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $5706979c38e91847$var$N(k, g);
        h += $5706979c38e91847$var$O(k, b, c, f, d);
    }
    else if (f = $5706979c38e91847$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $5706979c38e91847$var$N(k, g++), h += $5706979c38e91847$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($5706979c38e91847$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $5706979c38e91847$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $5706979c38e91847$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $5706979c38e91847$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $5706979c38e91847$var$R = {
    current: null
};
function $5706979c38e91847$var$S() {
    var a = $5706979c38e91847$var$R.current;
    if (null === a) throw Error($5706979c38e91847$var$z(321));
    return a;
}
var $5706979c38e91847$var$T = {
    ReactCurrentDispatcher: $5706979c38e91847$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $5706979c38e91847$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $45nop
};
$5706979c38e91847$export$dca3b0875bd9a954 = {
    map: $5706979c38e91847$var$P,
    forEach: function(a, b, c) {
        $5706979c38e91847$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $5706979c38e91847$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $5706979c38e91847$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$5706979c38e91847$var$L(a)) throw Error($5706979c38e91847$var$z(143));
        return a;
    }
};
$5706979c38e91847$export$16fa2f45be04daa8 = $5706979c38e91847$var$C;
$5706979c38e91847$export$221d75b3f55bb0bd = $5706979c38e91847$var$E;
$5706979c38e91847$export$ae55be85d98224ed = $5706979c38e91847$var$T;
$5706979c38e91847$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($5706979c38e91847$var$z(267, a));
    var e = $45nop({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $5706979c38e91847$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$5706979c38e91847$var$H.call(b, f) && !$5706979c38e91847$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $5706979c38e91847$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$5706979c38e91847$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $5706979c38e91847$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $5706979c38e91847$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$5706979c38e91847$export$c8a8987d4410bf2d = $5706979c38e91847$var$J;
$5706979c38e91847$export$d38cd72104c1f0e9 = function(a) {
    var b = $5706979c38e91847$var$J.bind(null, a);
    b.type = a;
    return b;
};
$5706979c38e91847$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5706979c38e91847$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $5706979c38e91847$var$t,
        render: a
    };
};
$5706979c38e91847$export$a8257692ac88316c = $5706979c38e91847$var$L;
$5706979c38e91847$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $5706979c38e91847$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $5706979c38e91847$var$Q
    };
};
$5706979c38e91847$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $5706979c38e91847$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$5706979c38e91847$export$35808ee640e87ca7 = function(a, b) {
    return $5706979c38e91847$var$S().useCallback(a, b);
};
$5706979c38e91847$export$fae74005e78b1a27 = function(a, b) {
    return $5706979c38e91847$var$S().useContext(a, b);
};
$5706979c38e91847$export$dc8fbce3eb94dc1e = function() {};
$5706979c38e91847$export$6d9c69b0de29b591 = function(a, b) {
    return $5706979c38e91847$var$S().useEffect(a, b);
};
$5706979c38e91847$export$d5a552a76deda3c2 = function(a, b, c) {
    return $5706979c38e91847$var$S().useImperativeHandle(a, b, c);
};
$5706979c38e91847$export$e5c5a5f917a5871c = function(a, b) {
    return $5706979c38e91847$var$S().useLayoutEffect(a, b);
};
$5706979c38e91847$export$1538c33de8887b59 = function(a, b) {
    return $5706979c38e91847$var$S().useMemo(a, b);
};
$5706979c38e91847$export$13e3392192263954 = function(a, b, c) {
    return $5706979c38e91847$var$S().useReducer(a, b, c);
};
$5706979c38e91847$export$b8f5890fc79d6aca = function(a) {
    return $5706979c38e91847$var$S().useRef(a);
};
$5706979c38e91847$export$60241385465d0a34 = function(a) {
    return $5706979c38e91847$var$S().useState(a);
};
$5706979c38e91847$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("aM9lk", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $5KQk5 = parcelRequire("5KQk5");

var $45nop = parcelRequire("45nop");

var $b5zR8 = parcelRequire("b5zR8");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$5KQk5) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $5KQk5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $45nop({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $5KQk5.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $45nop({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $45nop({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $45nop({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $b5zR8.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $b5zR8.unstable_scheduleCallback($b5zR8.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $b5zR8.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $b5zR8.unstable_UserBlockingPriority, ed = $b5zR8.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $45nop(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $45nop({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $45nop({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $45nop({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $45nop({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $45nop({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $45nop({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $45nop({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $45nop({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $45nop({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $45nop({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $45nop({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $45nop({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $45nop({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $b5zR8.unstable_runWithPriority, Of = $b5zR8.unstable_scheduleCallback, Pf = $b5zR8.unstable_cancelCallback, Qf = $b5zR8.unstable_shouldYield, Rf = $b5zR8.unstable_requestPaint, Sf = $b5zR8.unstable_now, Tf = $b5zR8.unstable_getCurrentPriorityLevel, Uf = $b5zR8.unstable_ImmediatePriority, Vf = $b5zR8.unstable_UserBlockingPriority, Wf = $b5zR8.unstable_NormalPriority, Xf = $b5zR8.unstable_LowPriority, Yf = $b5zR8.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $45nop({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $45nop({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $5KQk5.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $45nop({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $45nop({}, e, {
                    value: void 0
                });
                d = $45nop({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $45nop({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("b5zR8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9Uf1t"));

});
parcelRegister("9Uf1t", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $7364ff348f426d5c$export$c4744153514ff05d; }, function (v) { return $7364ff348f426d5c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $7364ff348f426d5c$export$b5836b71941fa3ed; }, function (v) { return $7364ff348f426d5c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $7364ff348f426d5c$export$d66a1c1c77bd778b; }, function (v) { return $7364ff348f426d5c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $7364ff348f426d5c$export$3e506c1ccc9cc1a7; }, function (v) { return $7364ff348f426d5c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $7364ff348f426d5c$export$e26fe2ed2fa76875; }, function (v) { return $7364ff348f426d5c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $7364ff348f426d5c$export$502329bbf4b505b1; }, function (v) { return $7364ff348f426d5c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $7364ff348f426d5c$export$6e3807111c4874c4; }, function (v) { return $7364ff348f426d5c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $7364ff348f426d5c$export$c27134553091fb3a; }, function (v) { return $7364ff348f426d5c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $7364ff348f426d5c$export$33ee1acdc04fd2a2; }, function (v) { return $7364ff348f426d5c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $7364ff348f426d5c$export$b00a404bbd5edef2; }, function (v) { return $7364ff348f426d5c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $7364ff348f426d5c$export$8352ce38b91d0c62; }, function (v) { return $7364ff348f426d5c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $7364ff348f426d5c$export$d3dfb8e4810cb555; }, function (v) { return $7364ff348f426d5c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $7364ff348f426d5c$export$839f9183b0465a69; }, function (v) { return $7364ff348f426d5c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $7364ff348f426d5c$export$72fdf0e06517287b; }, function (v) { return $7364ff348f426d5c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $7364ff348f426d5c$export$4b844e58a3e414b4; }, function (v) { return $7364ff348f426d5c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $7364ff348f426d5c$export$816d2913ae6b83b1; }, function (v) { return $7364ff348f426d5c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $7364ff348f426d5c$export$61bcfe829111a1d0; }, function (v) { return $7364ff348f426d5c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $7364ff348f426d5c$export$7ee8c9beb337bc3f; }, function (v) { return $7364ff348f426d5c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $7364ff348f426d5c$export$cf845f2c119da08a; }, function (v) { return $7364ff348f426d5c$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7364ff348f426d5c$export$c4744153514ff05d;
var $7364ff348f426d5c$export$b5836b71941fa3ed;
var $7364ff348f426d5c$export$d66a1c1c77bd778b;
var $7364ff348f426d5c$export$3e506c1ccc9cc1a7;
var $7364ff348f426d5c$export$e26fe2ed2fa76875;
var $7364ff348f426d5c$export$502329bbf4b505b1;
var $7364ff348f426d5c$export$6e3807111c4874c4;
var $7364ff348f426d5c$export$c27134553091fb3a;
var $7364ff348f426d5c$export$33ee1acdc04fd2a2;
var $7364ff348f426d5c$export$b00a404bbd5edef2;
var $7364ff348f426d5c$export$8352ce38b91d0c62;
var $7364ff348f426d5c$export$d3dfb8e4810cb555;
var $7364ff348f426d5c$export$839f9183b0465a69;
var $7364ff348f426d5c$export$72fdf0e06517287b;
var $7364ff348f426d5c$export$4b844e58a3e414b4;
var $7364ff348f426d5c$export$816d2913ae6b83b1;
var $7364ff348f426d5c$export$61bcfe829111a1d0;
var $7364ff348f426d5c$export$7ee8c9beb337bc3f;
var $7364ff348f426d5c$export$cf845f2c119da08a;
"use strict";
var $7364ff348f426d5c$var$f, $7364ff348f426d5c$var$g, $7364ff348f426d5c$var$h, $7364ff348f426d5c$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7364ff348f426d5c$var$l = performance;
    $7364ff348f426d5c$export$c4744153514ff05d = function() {
        return $7364ff348f426d5c$var$l.now();
    };
} else {
    var $7364ff348f426d5c$var$p = Date, $7364ff348f426d5c$var$q = $7364ff348f426d5c$var$p.now();
    $7364ff348f426d5c$export$c4744153514ff05d = function() {
        return $7364ff348f426d5c$var$p.now() - $7364ff348f426d5c$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $7364ff348f426d5c$var$t = null, $7364ff348f426d5c$var$u = null, $7364ff348f426d5c$var$w = function() {
        if (null !== $7364ff348f426d5c$var$t) try {
            var a = $7364ff348f426d5c$export$c4744153514ff05d();
            $7364ff348f426d5c$var$t(!0, a);
            $7364ff348f426d5c$var$t = null;
        } catch (b) {
            throw setTimeout($7364ff348f426d5c$var$w, 0), b;
        }
    };
    $7364ff348f426d5c$var$f = function(a) {
        null !== $7364ff348f426d5c$var$t ? setTimeout($7364ff348f426d5c$var$f, 0, a) : ($7364ff348f426d5c$var$t = a, setTimeout($7364ff348f426d5c$var$w, 0));
    };
    $7364ff348f426d5c$var$g = function(a, b) {
        $7364ff348f426d5c$var$u = setTimeout(a, b);
    };
    $7364ff348f426d5c$var$h = function() {
        clearTimeout($7364ff348f426d5c$var$u);
    };
    $7364ff348f426d5c$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $7364ff348f426d5c$var$k = $7364ff348f426d5c$export$d66a1c1c77bd778b = function() {};
} else {
    var $7364ff348f426d5c$var$x = window.setTimeout, $7364ff348f426d5c$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $7364ff348f426d5c$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $7364ff348f426d5c$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $7364ff348f426d5c$var$A = !1, $7364ff348f426d5c$var$B = null, $7364ff348f426d5c$var$C = -1, $7364ff348f426d5c$var$D = 5, $7364ff348f426d5c$var$E = 0;
    $7364ff348f426d5c$export$b5836b71941fa3ed = function() {
        return $7364ff348f426d5c$export$c4744153514ff05d() >= $7364ff348f426d5c$var$E;
    };
    $7364ff348f426d5c$var$k = function() {};
    $7364ff348f426d5c$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7364ff348f426d5c$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $7364ff348f426d5c$var$F = new MessageChannel, $7364ff348f426d5c$var$G = $7364ff348f426d5c$var$F.port2;
    $7364ff348f426d5c$var$F.port1.onmessage = function() {
        if (null !== $7364ff348f426d5c$var$B) {
            var a = $7364ff348f426d5c$export$c4744153514ff05d();
            $7364ff348f426d5c$var$E = a + $7364ff348f426d5c$var$D;
            try {
                $7364ff348f426d5c$var$B(!0, a) ? $7364ff348f426d5c$var$G.postMessage(null) : ($7364ff348f426d5c$var$A = !1, $7364ff348f426d5c$var$B = null);
            } catch (b) {
                throw $7364ff348f426d5c$var$G.postMessage(null), b;
            }
        } else $7364ff348f426d5c$var$A = !1;
    };
    $7364ff348f426d5c$var$f = function(a) {
        $7364ff348f426d5c$var$B = a;
        $7364ff348f426d5c$var$A || ($7364ff348f426d5c$var$A = !0, $7364ff348f426d5c$var$G.postMessage(null));
    };
    $7364ff348f426d5c$var$g = function(a, b) {
        $7364ff348f426d5c$var$C = $7364ff348f426d5c$var$x(function() {
            a($7364ff348f426d5c$export$c4744153514ff05d());
        }, b);
    };
    $7364ff348f426d5c$var$h = function() {
        $7364ff348f426d5c$var$y($7364ff348f426d5c$var$C);
        $7364ff348f426d5c$var$C = -1;
    };
}
function $7364ff348f426d5c$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $7364ff348f426d5c$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $7364ff348f426d5c$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $7364ff348f426d5c$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $7364ff348f426d5c$var$I(n, c)) void 0 !== r && 0 > $7364ff348f426d5c$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $7364ff348f426d5c$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $7364ff348f426d5c$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $7364ff348f426d5c$var$L = [], $7364ff348f426d5c$var$M = [], $7364ff348f426d5c$var$N = 1, $7364ff348f426d5c$var$O = null, $7364ff348f426d5c$var$P = 3, $7364ff348f426d5c$var$Q = !1, $7364ff348f426d5c$var$R = !1, $7364ff348f426d5c$var$S = !1;
function $7364ff348f426d5c$var$T(a) {
    for(var b = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$M); null !== b;){
        if (null === b.callback) $7364ff348f426d5c$var$K($7364ff348f426d5c$var$M);
        else if (b.startTime <= a) $7364ff348f426d5c$var$K($7364ff348f426d5c$var$M), b.sortIndex = b.expirationTime, $7364ff348f426d5c$var$H($7364ff348f426d5c$var$L, b);
        else break;
        b = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$M);
    }
}
function $7364ff348f426d5c$var$U(a) {
    $7364ff348f426d5c$var$S = !1;
    $7364ff348f426d5c$var$T(a);
    if (!$7364ff348f426d5c$var$R) {
        if (null !== $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L)) $7364ff348f426d5c$var$R = !0, $7364ff348f426d5c$var$f($7364ff348f426d5c$var$V);
        else {
            var b = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$M);
            null !== b && $7364ff348f426d5c$var$g($7364ff348f426d5c$var$U, b.startTime - a);
        }
    }
}
function $7364ff348f426d5c$var$V(a, b) {
    $7364ff348f426d5c$var$R = !1;
    $7364ff348f426d5c$var$S && ($7364ff348f426d5c$var$S = !1, $7364ff348f426d5c$var$h());
    $7364ff348f426d5c$var$Q = !0;
    var c = $7364ff348f426d5c$var$P;
    try {
        $7364ff348f426d5c$var$T(b);
        for($7364ff348f426d5c$var$O = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L); null !== $7364ff348f426d5c$var$O && (!($7364ff348f426d5c$var$O.expirationTime > b) || a && !$7364ff348f426d5c$export$b5836b71941fa3ed());){
            var d = $7364ff348f426d5c$var$O.callback;
            if ("function" === typeof d) {
                $7364ff348f426d5c$var$O.callback = null;
                $7364ff348f426d5c$var$P = $7364ff348f426d5c$var$O.priorityLevel;
                var e = d($7364ff348f426d5c$var$O.expirationTime <= b);
                b = $7364ff348f426d5c$export$c4744153514ff05d();
                "function" === typeof e ? $7364ff348f426d5c$var$O.callback = e : $7364ff348f426d5c$var$O === $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L) && $7364ff348f426d5c$var$K($7364ff348f426d5c$var$L);
                $7364ff348f426d5c$var$T(b);
            } else $7364ff348f426d5c$var$K($7364ff348f426d5c$var$L);
            $7364ff348f426d5c$var$O = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L);
        }
        if (null !== $7364ff348f426d5c$var$O) var m = !0;
        else {
            var n = $7364ff348f426d5c$var$J($7364ff348f426d5c$var$M);
            null !== n && $7364ff348f426d5c$var$g($7364ff348f426d5c$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $7364ff348f426d5c$var$O = null, $7364ff348f426d5c$var$P = c, $7364ff348f426d5c$var$Q = !1;
    }
}
var $7364ff348f426d5c$var$W = $7364ff348f426d5c$var$k;
$7364ff348f426d5c$export$3e506c1ccc9cc1a7 = 5;
$7364ff348f426d5c$export$e26fe2ed2fa76875 = 1;
$7364ff348f426d5c$export$502329bbf4b505b1 = 4;
$7364ff348f426d5c$export$6e3807111c4874c4 = 3;
$7364ff348f426d5c$export$c27134553091fb3a = null;
$7364ff348f426d5c$export$33ee1acdc04fd2a2 = 2;
$7364ff348f426d5c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$7364ff348f426d5c$export$8352ce38b91d0c62 = function() {
    $7364ff348f426d5c$var$R || $7364ff348f426d5c$var$Q || ($7364ff348f426d5c$var$R = !0, $7364ff348f426d5c$var$f($7364ff348f426d5c$var$V));
};
$7364ff348f426d5c$export$d3dfb8e4810cb555 = function() {
    return $7364ff348f426d5c$var$P;
};
$7364ff348f426d5c$export$839f9183b0465a69 = function() {
    return $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L);
};
$7364ff348f426d5c$export$72fdf0e06517287b = function(a) {
    switch($7364ff348f426d5c$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $7364ff348f426d5c$var$P;
    }
    var c = $7364ff348f426d5c$var$P;
    $7364ff348f426d5c$var$P = b;
    try {
        return a();
    } finally{
        $7364ff348f426d5c$var$P = c;
    }
};
$7364ff348f426d5c$export$4b844e58a3e414b4 = function() {};
$7364ff348f426d5c$export$816d2913ae6b83b1 = $7364ff348f426d5c$var$W;
$7364ff348f426d5c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $7364ff348f426d5c$var$P;
    $7364ff348f426d5c$var$P = a;
    try {
        return b();
    } finally{
        $7364ff348f426d5c$var$P = c;
    }
};
$7364ff348f426d5c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $7364ff348f426d5c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $7364ff348f426d5c$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $7364ff348f426d5c$var$H($7364ff348f426d5c$var$M, a), null === $7364ff348f426d5c$var$J($7364ff348f426d5c$var$L) && a === $7364ff348f426d5c$var$J($7364ff348f426d5c$var$M) && ($7364ff348f426d5c$var$S ? $7364ff348f426d5c$var$h() : $7364ff348f426d5c$var$S = !0, $7364ff348f426d5c$var$g($7364ff348f426d5c$var$U, c - d))) : (a.sortIndex = e, $7364ff348f426d5c$var$H($7364ff348f426d5c$var$L, a), $7364ff348f426d5c$var$R || $7364ff348f426d5c$var$Q || ($7364ff348f426d5c$var$R = !0, $7364ff348f426d5c$var$f($7364ff348f426d5c$var$V)));
    return a;
};
$7364ff348f426d5c$export$cf845f2c119da08a = function(a) {
    var b = $7364ff348f426d5c$var$P;
    return function() {
        var c = $7364ff348f426d5c$var$P;
        $7364ff348f426d5c$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $7364ff348f426d5c$var$P = c;
        }
    };
};

});



parcelRegister("jIl6h", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $e5a27e78bedb4e89$export$2b8d127b894957b9; }, function (v) { return $e5a27e78bedb4e89$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $e5a27e78bedb4e89$export$cea3a54a6425200c; }, function (v) { return $e5a27e78bedb4e89$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $e5a27e78bedb4e89$export$a7c73072b1a182ae; }, function (v) { return $e5a27e78bedb4e89$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e5a27e78bedb4e89$export$9f27bc3417b4524d; }, function (v) { return $e5a27e78bedb4e89$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e5a27e78bedb4e89$export$db77ccec0bb4ccac; }, function (v) { return $e5a27e78bedb4e89$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e5a27e78bedb4e89$export$8392c0c9d3dcbd35; }, function (v) { return $e5a27e78bedb4e89$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e5a27e78bedb4e89$export$ffb0004e005737fa; }, function (v) { return $e5a27e78bedb4e89$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e5a27e78bedb4e89$export$b624eff549462981; }, function (v) { return $e5a27e78bedb4e89$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e5a27e78bedb4e89$export$7897aa7841a5380c; }, function (v) { return $e5a27e78bedb4e89$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e5a27e78bedb4e89$export$602eac185826482c; }, function (v) { return $e5a27e78bedb4e89$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e5a27e78bedb4e89$export$e2c29f18771995cb; }, function (v) { return $e5a27e78bedb4e89$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e5a27e78bedb4e89$export$5f8d39834fd61797; }, function (v) { return $e5a27e78bedb4e89$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e5a27e78bedb4e89$export$74bf444e3cd11ea5; }, function (v) { return $e5a27e78bedb4e89$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e5a27e78bedb4e89$export$92387174baf9b227; }, function (v) { return $e5a27e78bedb4e89$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e5a27e78bedb4e89$export$ec112efeb987d9c6; }, function (v) { return $e5a27e78bedb4e89$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e5a27e78bedb4e89$export$b706b080d889d2c9; }, function (v) { return $e5a27e78bedb4e89$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e5a27e78bedb4e89$export$5be5a87408f70ddc; }, function (v) { return $e5a27e78bedb4e89$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e5a27e78bedb4e89$export$45a5e7f76e0caa8d; }, function (v) { return $e5a27e78bedb4e89$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e5a27e78bedb4e89$export$455c2e768291efa6; }, function (v) { return $e5a27e78bedb4e89$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e5a27e78bedb4e89$export$9522e17588c12572; }, function (v) { return $e5a27e78bedb4e89$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e5a27e78bedb4e89$export$2110ac352bb060b9; }, function (v) { return $e5a27e78bedb4e89$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e5a27e78bedb4e89$export$56885ab8b9c456ab; }, function (v) { return $e5a27e78bedb4e89$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e5a27e78bedb4e89$export$d927fcb6adf8f9de; }, function (v) { return $e5a27e78bedb4e89$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e5a27e78bedb4e89$export$b82d16f27459e05a; }, function (v) { return $e5a27e78bedb4e89$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e5a27e78bedb4e89$export$522c17b4f5e123e8; }, function (v) { return $e5a27e78bedb4e89$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e5a27e78bedb4e89$export$1aabd8a0274ecfd6; }, function (v) { return $e5a27e78bedb4e89$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e5a27e78bedb4e89$export$9b621391a187a31a; }, function (v) { return $e5a27e78bedb4e89$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e5a27e78bedb4e89$export$f5bbd400c2f4426f; }, function (v) { return $e5a27e78bedb4e89$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5a27e78bedb4e89$export$2b8d127b894957b9;
var $e5a27e78bedb4e89$export$cea3a54a6425200c;
var $e5a27e78bedb4e89$export$a7c73072b1a182ae;
var $e5a27e78bedb4e89$export$9f27bc3417b4524d;
var $e5a27e78bedb4e89$export$db77ccec0bb4ccac;
var $e5a27e78bedb4e89$export$8392c0c9d3dcbd35;
var $e5a27e78bedb4e89$export$ffb0004e005737fa;
var $e5a27e78bedb4e89$export$b624eff549462981;
var $e5a27e78bedb4e89$export$7897aa7841a5380c;
var $e5a27e78bedb4e89$export$602eac185826482c;
var $e5a27e78bedb4e89$export$e2c29f18771995cb;
var $e5a27e78bedb4e89$export$5f8d39834fd61797;
var $e5a27e78bedb4e89$export$74bf444e3cd11ea5;
var $e5a27e78bedb4e89$export$92387174baf9b227;
var $e5a27e78bedb4e89$export$ec112efeb987d9c6;
var $e5a27e78bedb4e89$export$b706b080d889d2c9;
var $e5a27e78bedb4e89$export$5be5a87408f70ddc;
var $e5a27e78bedb4e89$export$45a5e7f76e0caa8d;
var $e5a27e78bedb4e89$export$455c2e768291efa6;
var $e5a27e78bedb4e89$export$9522e17588c12572;
var $e5a27e78bedb4e89$export$2110ac352bb060b9;
var $e5a27e78bedb4e89$export$56885ab8b9c456ab;
var $e5a27e78bedb4e89$export$d927fcb6adf8f9de;
var $e5a27e78bedb4e89$export$b82d16f27459e05a;
var $e5a27e78bedb4e89$export$522c17b4f5e123e8;
var $e5a27e78bedb4e89$export$1aabd8a0274ecfd6;
var $e5a27e78bedb4e89$export$9b621391a187a31a;
var $e5a27e78bedb4e89$export$f5bbd400c2f4426f;
"use strict";
var $e5a27e78bedb4e89$var$b = "function" === typeof Symbol && Symbol.for, $e5a27e78bedb4e89$var$c = $e5a27e78bedb4e89$var$b ? Symbol.for("react.element") : 60103, $e5a27e78bedb4e89$var$d = $e5a27e78bedb4e89$var$b ? Symbol.for("react.portal") : 60106, $e5a27e78bedb4e89$var$e = $e5a27e78bedb4e89$var$b ? Symbol.for("react.fragment") : 60107, $e5a27e78bedb4e89$var$f = $e5a27e78bedb4e89$var$b ? Symbol.for("react.strict_mode") : 60108, $e5a27e78bedb4e89$var$g = $e5a27e78bedb4e89$var$b ? Symbol.for("react.profiler") : 60114, $e5a27e78bedb4e89$var$h = $e5a27e78bedb4e89$var$b ? Symbol.for("react.provider") : 60109, $e5a27e78bedb4e89$var$k = $e5a27e78bedb4e89$var$b ? Symbol.for("react.context") : 60110, $e5a27e78bedb4e89$var$l = $e5a27e78bedb4e89$var$b ? Symbol.for("react.async_mode") : 60111, $e5a27e78bedb4e89$var$m = $e5a27e78bedb4e89$var$b ? Symbol.for("react.concurrent_mode") : 60111, $e5a27e78bedb4e89$var$n = $e5a27e78bedb4e89$var$b ? Symbol.for("react.forward_ref") : 60112, $e5a27e78bedb4e89$var$p = $e5a27e78bedb4e89$var$b ? Symbol.for("react.suspense") : 60113, $e5a27e78bedb4e89$var$q = $e5a27e78bedb4e89$var$b ? Symbol.for("react.suspense_list") : 60120, $e5a27e78bedb4e89$var$r = $e5a27e78bedb4e89$var$b ? Symbol.for("react.memo") : 60115, $e5a27e78bedb4e89$var$t = $e5a27e78bedb4e89$var$b ? Symbol.for("react.lazy") : 60116, $e5a27e78bedb4e89$var$v = $e5a27e78bedb4e89$var$b ? Symbol.for("react.block") : 60121, $e5a27e78bedb4e89$var$w = $e5a27e78bedb4e89$var$b ? Symbol.for("react.fundamental") : 60117, $e5a27e78bedb4e89$var$x = $e5a27e78bedb4e89$var$b ? Symbol.for("react.responder") : 60118, $e5a27e78bedb4e89$var$y = $e5a27e78bedb4e89$var$b ? Symbol.for("react.scope") : 60119;
function $e5a27e78bedb4e89$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $e5a27e78bedb4e89$var$c:
                switch(a = a.type, a){
                    case $e5a27e78bedb4e89$var$l:
                    case $e5a27e78bedb4e89$var$m:
                    case $e5a27e78bedb4e89$var$e:
                    case $e5a27e78bedb4e89$var$g:
                    case $e5a27e78bedb4e89$var$f:
                    case $e5a27e78bedb4e89$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e5a27e78bedb4e89$var$k:
                            case $e5a27e78bedb4e89$var$n:
                            case $e5a27e78bedb4e89$var$t:
                            case $e5a27e78bedb4e89$var$r:
                            case $e5a27e78bedb4e89$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $e5a27e78bedb4e89$var$d:
                return u;
        }
    }
}
function $e5a27e78bedb4e89$var$A(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$m;
}
$e5a27e78bedb4e89$export$2b8d127b894957b9 = $e5a27e78bedb4e89$var$l;
$e5a27e78bedb4e89$export$cea3a54a6425200c = $e5a27e78bedb4e89$var$m;
$e5a27e78bedb4e89$export$a7c73072b1a182ae = $e5a27e78bedb4e89$var$k;
$e5a27e78bedb4e89$export$9f27bc3417b4524d = $e5a27e78bedb4e89$var$h;
$e5a27e78bedb4e89$export$db77ccec0bb4ccac = $e5a27e78bedb4e89$var$c;
$e5a27e78bedb4e89$export$8392c0c9d3dcbd35 = $e5a27e78bedb4e89$var$n;
$e5a27e78bedb4e89$export$ffb0004e005737fa = $e5a27e78bedb4e89$var$e;
$e5a27e78bedb4e89$export$b624eff549462981 = $e5a27e78bedb4e89$var$t;
$e5a27e78bedb4e89$export$7897aa7841a5380c = $e5a27e78bedb4e89$var$r;
$e5a27e78bedb4e89$export$602eac185826482c = $e5a27e78bedb4e89$var$d;
$e5a27e78bedb4e89$export$e2c29f18771995cb = $e5a27e78bedb4e89$var$g;
$e5a27e78bedb4e89$export$5f8d39834fd61797 = $e5a27e78bedb4e89$var$f;
$e5a27e78bedb4e89$export$74bf444e3cd11ea5 = $e5a27e78bedb4e89$var$p;
$e5a27e78bedb4e89$export$92387174baf9b227 = function(a) {
    return $e5a27e78bedb4e89$var$A(a) || $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$l;
};
$e5a27e78bedb4e89$export$ec112efeb987d9c6 = $e5a27e78bedb4e89$var$A;
$e5a27e78bedb4e89$export$b706b080d889d2c9 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$k;
};
$e5a27e78bedb4e89$export$5be5a87408f70ddc = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$h;
};
$e5a27e78bedb4e89$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e5a27e78bedb4e89$var$c;
};
$e5a27e78bedb4e89$export$455c2e768291efa6 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$n;
};
$e5a27e78bedb4e89$export$9522e17588c12572 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$e;
};
$e5a27e78bedb4e89$export$2110ac352bb060b9 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$t;
};
$e5a27e78bedb4e89$export$56885ab8b9c456ab = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$r;
};
$e5a27e78bedb4e89$export$d927fcb6adf8f9de = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$d;
};
$e5a27e78bedb4e89$export$b82d16f27459e05a = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$g;
};
$e5a27e78bedb4e89$export$522c17b4f5e123e8 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$f;
};
$e5a27e78bedb4e89$export$1aabd8a0274ecfd6 = function(a) {
    return $e5a27e78bedb4e89$var$z(a) === $e5a27e78bedb4e89$var$p;
};
$e5a27e78bedb4e89$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e5a27e78bedb4e89$var$e || a === $e5a27e78bedb4e89$var$m || a === $e5a27e78bedb4e89$var$g || a === $e5a27e78bedb4e89$var$f || a === $e5a27e78bedb4e89$var$p || a === $e5a27e78bedb4e89$var$q || "object" === typeof a && null !== a && (a.$$typeof === $e5a27e78bedb4e89$var$t || a.$$typeof === $e5a27e78bedb4e89$var$r || a.$$typeof === $e5a27e78bedb4e89$var$h || a.$$typeof === $e5a27e78bedb4e89$var$k || a.$$typeof === $e5a27e78bedb4e89$var$n || a.$$typeof === $e5a27e78bedb4e89$var$w || a.$$typeof === $e5a27e78bedb4e89$var$x || a.$$typeof === $e5a27e78bedb4e89$var$y || a.$$typeof === $e5a27e78bedb4e89$var$v);
};
$e5a27e78bedb4e89$export$f5bbd400c2f4426f = $e5a27e78bedb4e89$var$z;

});

parcelRegister("fGHuV", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $8JsGL = parcelRequire("8JsGL");

var $6HanM = parcelRequire("6HanM");

var $diwL4 = parcelRequire("diwL4");

var $9k0e1 = parcelRequire("9k0e1");

var $5WgVA = parcelRequire("5WgVA");

var $drIlR = parcelRequire("drIlR");

var $4gGez = parcelRequire("4gGez");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += join(value[i], " ");
    }
    else cssValue = join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $5WgVA.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $drIlR.default)((0, $drIlR.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8JsGL.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $9k0e1.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $8JsGL.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $8JsGL.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $8JsGL.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $5WgVA.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8JsGL.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $8JsGL.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $8JsGL.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $8JsGL.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $4gGez.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $9k0e1.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $6HanM.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $8JsGL.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $8JsGL.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $8JsGL.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $diwL4.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $diwL4.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $9k0e1.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $b6bc85069b504727$export$2e2bcd8739ae039 = index;

});
parcelRegister("8JsGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b8c7b07accfb9d$export$2e2bcd8739ae039; });
function $65b8c7b07accfb9d$export$2e2bcd8739ae039() {
    $65b8c7b07accfb9d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $65b8c7b07accfb9d$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("6HanM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dfed000f4301104$export$2e2bcd8739ae039; });
var $4dfed000f4301104$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $4dfed000f4301104$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $4dfed000f4301104$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $4dfed000f4301104$var$_typeof(document)) === "object" && document.nodeType === 9;
var $4dfed000f4301104$export$2e2bcd8739ae039 = $4dfed000f4301104$export$4e09c449d6c407f7;

});

parcelRegister("diwL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae65de9d2b749a2$export$2e2bcd8739ae039; });
var $9ae65de9d2b749a2$var$isProduction = true;
function $9ae65de9d2b749a2$var$warning(condition, message) {
    if (!$9ae65de9d2b749a2$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $9ae65de9d2b749a2$export$2e2bcd8739ae039 = $9ae65de9d2b749a2$var$warning;

});

parcelRegister("9k0e1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c962800a32a0af0$export$2e2bcd8739ae039; });

var $hi1AZ = parcelRequire("hi1AZ");
function $6c962800a32a0af0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $hi1AZ.default)(descriptor.key), descriptor);
    }
}
function $6c962800a32a0af0$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $6c962800a32a0af0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c962800a32a0af0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("hi1AZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9655af7c38617b0$export$2e2bcd8739ae039; });

var $6TQKm = parcelRequire("6TQKm");

var $1PWcS = parcelRequire("1PWcS");
function $c9655af7c38617b0$export$2e2bcd8739ae039(t) {
    var i = (0, $1PWcS.default)(t, "string");
    return "symbol" == (0, $6TQKm.default)(i) ? i : i + "";
}

});
parcelRegister("6TQKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5060cb8380c63b0d$export$2e2bcd8739ae039; });
function $5060cb8380c63b0d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5060cb8380c63b0d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5060cb8380c63b0d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1PWcS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1567b482e9191473$export$2e2bcd8739ae039; });

var $6TQKm = parcelRequire("6TQKm");
function $1567b482e9191473$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6TQKm.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6TQKm.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("5WgVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $452f800f69eb0ef4$export$2e2bcd8739ae039; });

var $39seI = parcelRequire("39seI");
function $452f800f69eb0ef4$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $39seI.default)(subClass, superClass);
}

});
parcelRegister("39seI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24b81d8455b82d36$export$2e2bcd8739ae039; });
function $24b81d8455b82d36$export$2e2bcd8739ae039(o, p) {
    $24b81d8455b82d36$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $24b81d8455b82d36$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("drIlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca0334a72ac6d6f$export$2e2bcd8739ae039; });
function $9ca0334a72ac6d6f$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("4gGez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b96ad8c2fdd251$export$2e2bcd8739ae039; });
function $31b96ad8c2fdd251$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("3saO8", function(module, exports) {
"use strict";
// This file describes the messages that the Client can send to the Server
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SelectGameMessage = module.exports.ContestantSubmission = module.exports.ContestantWager = module.exports.ContestantSpectate = module.exports.ContestantJoin = module.exports.ContestantBuzzIn = module.exports.ContestantRemoveMessage = module.exports.RevealMessage = module.exports.CloseSubmissionsMessage = module.exports.CloseWagersMessage = module.exports.OpenBuzzer = module.exports.CloseClueMessage = module.exports.SetScoreMessage = module.exports.ModifyScoreMessage = module.exports.SelectClueMessage = module.exports.StartGameMessage = module.exports.TrebekJoinMessage = module.exports.ClientMessage = module.exports.ClientMessageType = void 0;
var $283c5ec7d05b6ffb$var$ClientMessageType;
(function(ClientMessageType) {
    ClientMessageType[ClientMessageType["START_GAME"] = 0] = "START_GAME";
    ClientMessageType[ClientMessageType["SELECT_CLUE"] = 1] = "SELECT_CLUE";
    ClientMessageType[ClientMessageType["TREBEK_JOIN"] = 2] = "TREBEK_JOIN";
    ClientMessageType[ClientMessageType["MODIFY_SCORE"] = 3] = "MODIFY_SCORE";
    ClientMessageType[ClientMessageType["SET_SCORE"] = 4] = "SET_SCORE";
    ClientMessageType[ClientMessageType["CONTESTANT_JOIN"] = 5] = "CONTESTANT_JOIN";
    ClientMessageType[ClientMessageType["CONTESTANT_BUZZ"] = 6] = "CONTESTANT_BUZZ";
    ClientMessageType[ClientMessageType["CONTESTANT_WAGER"] = 7] = "CONTESTANT_WAGER";
    ClientMessageType[ClientMessageType["CONTESTANT_SPECTATE"] = 8] = "CONTESTANT_SPECTATE";
    ClientMessageType[ClientMessageType["CONTESTANT_SUBMISSION"] = 9] = "CONTESTANT_SUBMISSION";
    ClientMessageType[ClientMessageType["CONTESTANT_REMOVE"] = 10] = "CONTESTANT_REMOVE";
    ClientMessageType[ClientMessageType["CLOSE_CLUE"] = 11] = "CLOSE_CLUE";
    ClientMessageType[ClientMessageType["CLOSE_SUBMISSIONS"] = 12] = "CLOSE_SUBMISSIONS";
    ClientMessageType[ClientMessageType["CLOSE_WAGERING"] = 13] = "CLOSE_WAGERING";
    ClientMessageType[ClientMessageType["OPEN_BUZZER"] = 14] = "OPEN_BUZZER";
    ClientMessageType[ClientMessageType["REVEAL"] = 15] = "REVEAL";
    ClientMessageType[ClientMessageType["SELECT_GAME"] = 16] = "SELECT_GAME";
})($283c5ec7d05b6ffb$var$ClientMessageType || (module.exports.ClientMessageType = $283c5ec7d05b6ffb$var$ClientMessageType = {}));
class $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        this.id = id;
    }
}
module.exports.ClientMessage = $283c5ec7d05b6ffb$var$ClientMessage;
/* ====================== Trebek Side ================== */ class $283c5ec7d05b6ffb$var$TrebekJoinMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.TREBEK_JOIN;
    }
}
module.exports.TrebekJoinMessage = $283c5ec7d05b6ffb$var$TrebekJoinMessage;
// Tells the server to make a new game with game id <id>
class $283c5ec7d05b6ffb$var$StartGameMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, airdate){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.START_GAME;
        this.airdate = airdate;
    }
}
module.exports.StartGameMessage = $283c5ec7d05b6ffb$var$StartGameMessage;
// Tells the server to transition a clue on a jeopardy board to the INPLAY state
class $283c5ec7d05b6ffb$var$SelectClueMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, clueId){
        super(id);
        this.clueId = clueId;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.SELECT_CLUE;
    }
}
module.exports.SelectClueMessage = $283c5ec7d05b6ffb$var$SelectClueMessage;
// Modify Score
class $283c5ec7d05b6ffb$var$ModifyScoreMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, scoreDelta, teamName){
        super(id);
        this.teamName = teamName;
        this.scoreDelta = scoreDelta;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.MODIFY_SCORE;
    }
}
module.exports.ModifyScoreMessage = $283c5ec7d05b6ffb$var$ModifyScoreMessage;
// Set Score
class $283c5ec7d05b6ffb$var$SetScoreMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, newScore, teamName){
        super(id);
        this.teamName = teamName;
        this.newScore = newScore;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.SET_SCORE;
    }
}
module.exports.SetScoreMessage = $283c5ec7d05b6ffb$var$SetScoreMessage;
// Close Clue
class $283c5ec7d05b6ffb$var$CloseClueMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CLOSE_CLUE;
    }
}
module.exports.CloseClueMessage = $283c5ec7d05b6ffb$var$CloseClueMessage;
// Trebek allows contestants to buzz in
class $283c5ec7d05b6ffb$var$OpenBuzzer extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.OPEN_BUZZER;
    }
}
module.exports.OpenBuzzer = $283c5ec7d05b6ffb$var$OpenBuzzer;
// End current wagering period
class $283c5ec7d05b6ffb$var$CloseWagersMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CLOSE_WAGERING;
    }
}
module.exports.CloseWagersMessage = $283c5ec7d05b6ffb$var$CloseWagersMessage;
// End period where contestants submit responses
class $283c5ec7d05b6ffb$var$CloseSubmissionsMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CLOSE_SUBMISSIONS;
    }
}
module.exports.CloseSubmissionsMessage = $283c5ec7d05b6ffb$var$CloseSubmissionsMessage;
class $283c5ec7d05b6ffb$var$RevealMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName){
        super(id);
        this.teamName = teamName;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.REVEAL;
    }
}
module.exports.RevealMessage = $283c5ec7d05b6ffb$var$RevealMessage;
// Remove a contestant from a Jeopardy session
class $283c5ec7d05b6ffb$var$ContestantRemoveMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName){
        super(id);
        this.teamName = teamName;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_REMOVE;
    }
}
module.exports.ContestantRemoveMessage = $283c5ec7d05b6ffb$var$ContestantRemoveMessage;
/* ==================== Contestant Side ============================ */ class $283c5ec7d05b6ffb$var$ContestantBuzzIn extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName, timeToBuzz){
        super(id);
        this.teamName = teamName;
        this.timeToBuzz = timeToBuzz;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_BUZZ;
    }
}
module.exports.ContestantBuzzIn = $283c5ec7d05b6ffb$var$ContestantBuzzIn;
class $283c5ec7d05b6ffb$var$ContestantJoin extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName, playerName){
        super(id);
        this.teamName = teamName;
        this.playerName = playerName;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_JOIN;
    }
}
module.exports.ContestantJoin = $283c5ec7d05b6ffb$var$ContestantJoin;
class $283c5ec7d05b6ffb$var$ContestantSpectate extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id){
        super(id);
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_SPECTATE;
    }
}
module.exports.ContestantSpectate = $283c5ec7d05b6ffb$var$ContestantSpectate;
class $283c5ec7d05b6ffb$var$ContestantWager extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName, wager){
        super(id);
        this.wager = wager;
        this.teamName = teamName;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_WAGER;
    }
}
module.exports.ContestantWager = $283c5ec7d05b6ffb$var$ContestantWager;
class $283c5ec7d05b6ffb$var$ContestantSubmission extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, teamName, submission){
        super(id);
        this.teamName = teamName;
        this.submission = submission;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.CONTESTANT_SUBMISSION;
    }
}
module.exports.ContestantSubmission = $283c5ec7d05b6ffb$var$ContestantSubmission;
class $283c5ec7d05b6ffb$var$SelectGameMessage extends $283c5ec7d05b6ffb$var$ClientMessage {
    constructor(id, gameName){
        super(id);
        this.gameName = gameName;
        this.type = $283c5ec7d05b6ffb$var$ClientMessageType.SELECT_GAME;
    }
}
module.exports.SelectGameMessage = $283c5ec7d05b6ffb$var$SelectGameMessage;

});

parcelRegister("dtO8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GamesListMessage = module.exports.ErrorMessage = module.exports.DailyDoubleWagerMessage = module.exports.OpenBuzzerMessage = module.exports.StateUpdateMessage = module.exports.ServerMessage = module.exports.ServerMessageType = void 0;
var $9d04defc97672341$var$ServerMessageType;
(function(ServerMessageType) {
    ServerMessageType[ServerMessageType["OPEN_BUZZER"] = 0] = "OPEN_BUZZER";
    ServerMessageType[ServerMessageType["STATE_UPDATE"] = 1] = "STATE_UPDATE";
    ServerMessageType[ServerMessageType["DAILY_DOUBLE_WAGER"] = 2] = "DAILY_DOUBLE_WAGER";
    ServerMessageType[ServerMessageType["ERROR"] = 3] = "ERROR";
    ServerMessageType[ServerMessageType["GAMES_LIST"] = 4] = "GAMES_LIST";
})($9d04defc97672341$var$ServerMessageType || (module.exports.ServerMessageType = $9d04defc97672341$var$ServerMessageType = {}));
class $9d04defc97672341$var$ServerMessage {
    constructor(type){
        this.type = type;
    }
}
module.exports.ServerMessage = $9d04defc97672341$var$ServerMessage;
class $9d04defc97672341$var$StateUpdateMessage extends $9d04defc97672341$var$ServerMessage {
    constructor(newState){
        super($9d04defc97672341$var$ServerMessageType.STATE_UPDATE);
        this.newState = newState;
    }
}
module.exports.StateUpdateMessage = $9d04defc97672341$var$StateUpdateMessage;
class $9d04defc97672341$var$OpenBuzzerMessage extends $9d04defc97672341$var$ServerMessage {
    constructor(newState){
        super($9d04defc97672341$var$ServerMessageType.OPEN_BUZZER);
        this.newState = newState;
    }
}
module.exports.OpenBuzzerMessage = $9d04defc97672341$var$OpenBuzzerMessage;
class $9d04defc97672341$var$DailyDoubleWagerMessage extends $9d04defc97672341$var$ServerMessage {
    constructor(newState){
        super($9d04defc97672341$var$ServerMessageType.DAILY_DOUBLE_WAGER);
        this.newState = newState;
    }
}
module.exports.DailyDoubleWagerMessage = $9d04defc97672341$var$DailyDoubleWagerMessage;
class $9d04defc97672341$var$ErrorMessage extends $9d04defc97672341$var$ServerMessage {
    constructor(message){
        super($9d04defc97672341$var$ServerMessageType.ERROR);
        this.error = message;
    }
}
module.exports.ErrorMessage = $9d04defc97672341$var$ErrorMessage;
class $9d04defc97672341$var$GamesListMessage extends $9d04defc97672341$var$ServerMessage {
    constructor(games){
        super($9d04defc97672341$var$ServerMessageType.GAMES_LIST);
        this.games = games;
    }
}
module.exports.GamesListMessage = $9d04defc97672341$var$GamesListMessage;

});

parcelRegister("ft5wW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GUIUserType = module.exports.NO_FINAL_JEOPARDY_SUBMISSION = module.exports.NO_FINAL_JEOPARDY_WAGER = module.exports.NO_DAILY_DOUBLE_WAGER = module.exports.NO_BUZZ_IN_TIME = module.exports.NO_QUESTION = module.exports.Status = module.exports.Round = void 0;
var $b42ddaabb59c187b$var$Round;
(function(Round) {
    Round[Round["SINGLE"] = 0] = "SINGLE";
    Round[Round["DOUBLE"] = 1] = "DOUBLE";
    Round[Round["FINAL"] = 2] = "FINAL";
    Round[Round["DONE"] = 3] = "DONE";
})($b42ddaabb59c187b$var$Round || (module.exports.Round = $b42ddaabb59c187b$var$Round = {}));
var $b42ddaabb59c187b$var$Status;
(function(Status) {
    Status[Status["UNPLAYED"] = 0] = "UNPLAYED";
    Status[Status["INPLAY"] = 1] = "INPLAY";
    Status[Status["PLAYED"] = 2] = "PLAYED";
})($b42ddaabb59c187b$var$Status || (module.exports.Status = $b42ddaabb59c187b$var$Status = {}));
module.exports.NO_QUESTION = -1;
module.exports.NO_BUZZ_IN_TIME = -1;
module.exports.NO_DAILY_DOUBLE_WAGER = -1;
module.exports.NO_FINAL_JEOPARDY_WAGER = -1;
module.exports.NO_FINAL_JEOPARDY_SUBMISSION = "___no submission yet___";
var $b42ddaabb59c187b$var$GUIUserType;
(function(GUIUserType) {
    GUIUserType[GUIUserType["UNDEFINED"] = 0] = "UNDEFINED";
    GUIUserType[GUIUserType["ADMIN"] = 1] = "ADMIN";
    GUIUserType[GUIUserType["PLAYER"] = 2] = "PLAYER";
    GUIUserType[GUIUserType["OBSERVER"] = 3] = "OBSERVER";
})($b42ddaabb59c187b$var$GUIUserType || (module.exports.GUIUserType = $b42ddaabb59c187b$var$GUIUserType = {}));

});

parcelRegister("jY4In", function(module, exports) {

var $18sFW = parcelRequire("18sFW");
var $e8974731944f9b11$var$wordList = [
    // Borrowed from xkcd password generator which borrowed it from wherever
    "ability",
    "able",
    "aboard",
    "about",
    "above",
    "accept",
    "accident",
    "according",
    "account",
    "accurate",
    "acres",
    "across",
    "act",
    "action",
    "active",
    "activity",
    "actual",
    "actually",
    "add",
    "addition",
    "additional",
    "adjective",
    "adult",
    "adventure",
    "advice",
    "affect",
    "afraid",
    "after",
    "afternoon",
    "again",
    "against",
    "age",
    "ago",
    "agree",
    "ahead",
    "aid",
    "air",
    "airplane",
    "alike",
    "alive",
    "all",
    "allow",
    "almost",
    "alone",
    "along",
    "aloud",
    "alphabet",
    "already",
    "also",
    "although",
    "am",
    "among",
    "amount",
    "ancient",
    "angle",
    "angry",
    "animal",
    "announced",
    "another",
    "answer",
    "ants",
    "any",
    "anybody",
    "anyone",
    "anything",
    "anyway",
    "anywhere",
    "apart",
    "apartment",
    "appearance",
    "apple",
    "applied",
    "appropriate",
    "are",
    "area",
    "arm",
    "army",
    "around",
    "arrange",
    "arrangement",
    "arrive",
    "arrow",
    "art",
    "article",
    "as",
    "aside",
    "ask",
    "asleep",
    "at",
    "ate",
    "atmosphere",
    "atom",
    "atomic",
    "attached",
    "attack",
    "attempt",
    "attention",
    "audience",
    "author",
    "automobile",
    "available",
    "average",
    "avoid",
    "aware",
    "away",
    "baby",
    "back",
    "bad",
    "badly",
    "bag",
    "balance",
    "ball",
    "balloon",
    "band",
    "bank",
    "bar",
    "bare",
    "bark",
    "barn",
    "base",
    "baseball",
    "basic",
    "basis",
    "basket",
    "bat",
    "battle",
    "be",
    "bean",
    "bear",
    "beat",
    "beautiful",
    "beauty",
    "became",
    "because",
    "become",
    "becoming",
    "bee",
    "been",
    "before",
    "began",
    "beginning",
    "begun",
    "behavior",
    "behind",
    "being",
    "believed",
    "bell",
    "belong",
    "below",
    "belt",
    "bend",
    "beneath",
    "bent",
    "beside",
    "best",
    "bet",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bigger",
    "biggest",
    "bill",
    "birds",
    "birth",
    "birthday",
    "bit",
    "bite",
    "black",
    "blank",
    "blanket",
    "blew",
    "blind",
    "block",
    "blood",
    "blow",
    "blue",
    "board",
    "boat",
    "body",
    "bone",
    "book",
    "border",
    "born",
    "both",
    "bottle",
    "bottom",
    "bound",
    "bow",
    "bowl",
    "box",
    "boy",
    "brain",
    "branch",
    "brass",
    "brave",
    "bread",
    "break",
    "breakfast",
    "breath",
    "breathe",
    "breathing",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "broad",
    "broke",
    "broken",
    "brother",
    "brought",
    "brown",
    "brush",
    "buffalo",
    "build",
    "building",
    "built",
    "buried",
    "burn",
    "burst",
    "bus",
    "bush",
    "business",
    "busy",
    "but",
    "butter",
    "buy",
    "by",
    "cabin",
    "cage",
    "cake",
    "call",
    "calm",
    "came",
    "camera",
    "camp",
    "can",
    "canal",
    "cannot",
    "cap",
    "capital",
    "captain",
    "captured",
    "car",
    "carbon",
    "card",
    "care",
    "careful",
    "carefully",
    "carried",
    "carry",
    "case",
    "cast",
    "castle",
    "cat",
    "catch",
    "cattle",
    "caught",
    "cause",
    "cave",
    "cell",
    "cent",
    "center",
    "central",
    "century",
    "certain",
    "certainly",
    "chain",
    "chair",
    "chamber",
    "chance",
    "change",
    "changing",
    "chapter",
    "character",
    "characteristic",
    "charge",
    "chart",
    "check",
    "cheese",
    "chemical",
    "chest",
    "chicken",
    "chief",
    "child",
    "children",
    "choice",
    "choose",
    "chose",
    "chosen",
    "church",
    "circle",
    "circus",
    "citizen",
    "city",
    "class",
    "classroom",
    "claws",
    "clay",
    "clean",
    "clear",
    "clearly",
    "climate",
    "climb",
    "clock",
    "close",
    "closely",
    "closer",
    "cloth",
    "clothes",
    "clothing",
    "cloud",
    "club",
    "coach",
    "coal",
    "coast",
    "coat",
    "coffee",
    "cold",
    "collect",
    "college",
    "colony",
    "color",
    "column",
    "combination",
    "combine",
    "come",
    "comfortable",
    "coming",
    "command",
    "common",
    "community",
    "company",
    "compare",
    "compass",
    "complete",
    "completely",
    "complex",
    "composed",
    "composition",
    "compound",
    "concerned",
    "condition",
    "congress",
    "connected",
    "consider",
    "consist",
    "consonant",
    "constantly",
    "construction",
    "contain",
    "continent",
    "continued",
    "contrast",
    "control",
    "conversation",
    "cook",
    "cookies",
    "cool",
    "copper",
    "copy",
    "corn",
    "corner",
    "correct",
    "correctly",
    "cost",
    "cotton",
    "could",
    "count",
    "country",
    "couple",
    "courage",
    "course",
    "court",
    "cover",
    "cow",
    "cowboy",
    "crack",
    "cream",
    "create",
    "creature",
    "crew",
    "crop",
    "cross",
    "crowd",
    "cry",
    "cup",
    "curious",
    "current",
    "curve",
    "customs",
    "cut",
    "cutting",
    "daily",
    "damage",
    "dance",
    "danger",
    "dangerous",
    "dark",
    "darkness",
    "date",
    "daughter",
    "dawn",
    "day",
    "dead",
    "deal",
    "dear",
    "death",
    "decide",
    "declared",
    "deep",
    "deeply",
    "deer",
    "definition",
    "degree",
    "depend",
    "depth",
    "describe",
    "desert",
    "design",
    "desk",
    "detail",
    "determine",
    "develop",
    "development",
    "diagram",
    "diameter",
    "did",
    "die",
    "differ",
    "difference",
    "different",
    "difficult",
    "difficulty",
    "dig",
    "dinner",
    "direct",
    "direction",
    "directly",
    "dirt",
    "dirty",
    "disappear",
    "discover",
    "discovery",
    "discuss",
    "discussion",
    "disease",
    "dish",
    "distance",
    "distant",
    "divide",
    "division",
    "do",
    "doctor",
    "does",
    "dog",
    "doing",
    "doll",
    "dollar",
    "done",
    "donkey",
    "door",
    "dot",
    "double",
    "doubt",
    "down",
    "dozen",
    "draw",
    "drawn",
    "dream",
    "dress",
    "drew",
    "dried",
    "drink",
    "drive",
    "driven",
    "driver",
    "driving",
    "drop",
    "dropped",
    "drove",
    "dry",
    "duck",
    "due",
    "dug",
    "dull",
    "during",
    "dust",
    "duty",
    "each",
    "eager",
    "ear",
    "earlier",
    "early",
    "earn",
    "earth",
    "easier",
    "easily",
    "east",
    "easy",
    "eat",
    "eaten",
    "edge",
    "education",
    "effect",
    "effort",
    "egg",
    "eight",
    "either",
    "electric",
    "electricity",
    "element",
    "elephant",
    "eleven",
    "else",
    "empty",
    "end",
    "enemy",
    "energy",
    "engine",
    "engineer",
    "enjoy",
    "enough",
    "enter",
    "entire",
    "entirely",
    "environment",
    "equal",
    "equally",
    "equator",
    "equipment",
    "escape",
    "especially",
    "essential",
    "establish",
    "even",
    "evening",
    "event",
    "eventually",
    "ever",
    "every",
    "everybody",
    "everyone",
    "everything",
    "everywhere",
    "evidence",
    "exact",
    "exactly",
    "examine",
    "example",
    "excellent",
    "except",
    "exchange",
    "excited",
    "excitement",
    "exciting",
    "exclaimed",
    "exercise",
    "exist",
    "expect",
    "experience",
    "experiment",
    "explain",
    "explanation",
    "explore",
    "express",
    "expression",
    "extra",
    "eye",
    "face",
    "facing",
    "fact",
    "factor",
    "factory",
    "failed",
    "fair",
    "fairly",
    "fall",
    "fallen",
    "familiar",
    "family",
    "famous",
    "far",
    "farm",
    "farmer",
    "farther",
    "fast",
    "fastened",
    "faster",
    "fat",
    "father",
    "favorite",
    "fear",
    "feathers",
    "feature",
    "fed",
    "feed",
    "feel",
    "feet",
    "fell",
    "fellow",
    "felt",
    "fence",
    "few",
    "fewer",
    "field",
    "fierce",
    "fifteen",
    "fifth",
    "fifty",
    "fight",
    "fighting",
    "figure",
    "fill",
    "film",
    "final",
    "finally",
    "find",
    "fine",
    "finest",
    "finger",
    "finish",
    "fire",
    "fireplace",
    "firm",
    "first",
    "fish",
    "five",
    "fix",
    "flag",
    "flame",
    "flat",
    "flew",
    "flies",
    "flight",
    "floating",
    "floor",
    "flow",
    "flower",
    "fly",
    "fog",
    "folks",
    "follow",
    "food",
    "foot",
    "football",
    "for",
    "force",
    "foreign",
    "forest",
    "forget",
    "forgot",
    "forgotten",
    "form",
    "former",
    "fort",
    "forth",
    "forty",
    "forward",
    "fought",
    "found",
    "four",
    "fourth",
    "fox",
    "frame",
    "free",
    "freedom",
    "frequently",
    "fresh",
    "friend",
    "friendly",
    "frighten",
    "frog",
    "from",
    "front",
    "frozen",
    "fruit",
    "fuel",
    "full",
    "fully",
    "fun",
    "function",
    "funny",
    "fur",
    "furniture",
    "further",
    "future",
    "gain",
    "game",
    "garage",
    "garden",
    "gas",
    "gasoline",
    "gate",
    "gather",
    "gave",
    "general",
    "generally",
    "gentle",
    "gently",
    "get",
    "getting",
    "giant",
    "gift",
    "girl",
    "give",
    "given",
    "giving",
    "glad",
    "glass",
    "globe",
    "go",
    "goes",
    "gold",
    "golden",
    "gone",
    "good",
    "goose",
    "got",
    "government",
    "grabbed",
    "grade",
    "gradually",
    "grain",
    "grandfather",
    "grandmother",
    "graph",
    "grass",
    "gravity",
    "gray",
    "great",
    "greater",
    "greatest",
    "greatly",
    "green",
    "grew",
    "ground",
    "group",
    "grow",
    "grown",
    "growth",
    "guard",
    "guess",
    "guide",
    "gulf",
    "gun",
    "habit",
    "had",
    "hair",
    "half",
    "halfway",
    "hall",
    "hand",
    "handle",
    "handsome",
    "hang",
    "happen",
    "happened",
    "happily",
    "happy",
    "harbor",
    "hard",
    "harder",
    "hardly",
    "has",
    "hat",
    "have",
    "having",
    "hay",
    "he",
    "headed",
    "heading",
    "health",
    "heard",
    "hearing",
    "heart",
    "heat",
    "heavy",
    "height",
    "held",
    "hello",
    "help",
    "helpful",
    "her",
    "herd",
    "here",
    "herself",
    "hidden",
    "hide",
    "high",
    "higher",
    "highest",
    "highway",
    "hill",
    "him",
    "himself",
    "his",
    "history",
    "hit",
    "hold",
    "hole",
    "hollow",
    "home",
    "honor",
    "hope",
    "horn",
    "horse",
    "hospital",
    "hot",
    "hour",
    "house",
    "how",
    "however",
    "huge",
    "human",
    "hundred",
    "hung",
    "hungry",
    "hunt",
    "hunter",
    "hurried",
    "hurry",
    "hurt",
    "husband",
    "ice",
    "idea",
    "identity",
    "if",
    "ill",
    "image",
    "imagine",
    "immediately",
    "importance",
    "important",
    "impossible",
    "improve",
    "in",
    "inch",
    "include",
    "including",
    "income",
    "increase",
    "indeed",
    "independent",
    "indicate",
    "individual",
    "industrial",
    "industry",
    "influence",
    "information",
    "inside",
    "instance",
    "instant",
    "instead",
    "instrument",
    "interest",
    "interior",
    "into",
    "introduced",
    "invented",
    "involved",
    "iron",
    "is",
    "island",
    "it",
    "its",
    "itself",
    "jack",
    "jar",
    "jet",
    "job",
    "join",
    "joined",
    "journey",
    "joy",
    "judge",
    "jump",
    "jungle",
    "just",
    "keep",
    "kept",
    "key",
    "kids",
    "kill",
    "kind",
    "kitchen",
    "knew",
    "knife",
    "know",
    "knowledge",
    "known",
    "label",
    "labor",
    "lack",
    "lady",
    "laid",
    "lake",
    "lamp",
    "land",
    "language",
    "large",
    "larger",
    "largest",
    "last",
    "late",
    "later",
    "laugh",
    "law",
    "lay",
    "layers",
    "lead",
    "leader",
    "leaf",
    "learn",
    "least",
    "leather",
    "leave",
    "leaving",
    "led",
    "left",
    "leg",
    "length",
    "lesson",
    "let",
    "letter",
    "level",
    "library",
    "lie",
    "life",
    "lift",
    "light",
    "like",
    "likely",
    "limited",
    "line",
    "lion",
    "lips",
    "liquid",
    "list",
    "listen",
    "little",
    "live",
    "living",
    "load",
    "local",
    "locate",
    "location",
    "log",
    "lonely",
    "long",
    "longer",
    "look",
    "loose",
    "lose",
    "loss",
    "lost",
    "lot",
    "loud",
    "love",
    "lovely",
    "low",
    "lower",
    "luck",
    "lucky",
    "lunch",
    "lungs",
    "lying",
    "machine",
    "machinery",
    "mad",
    "made",
    "magic",
    "magnet",
    "mail",
    "main",
    "mainly",
    "major",
    "make",
    "making",
    "man",
    "managed",
    "manner",
    "manufacturing",
    "many",
    "map",
    "mark",
    "market",
    "married",
    "mass",
    "massage",
    "master",
    "material",
    "mathematics",
    "matter",
    "may",
    "maybe",
    "me",
    "meal",
    "mean",
    "means",
    "meant",
    "measure",
    "meat",
    "medicine",
    "meet",
    "melted",
    "member",
    "memory",
    "men",
    "mental",
    "merely",
    "met",
    "metal",
    "method",
    "mice",
    "middle",
    "might",
    "mighty",
    "mile",
    "military",
    "milk",
    "mill",
    "mind",
    "mine",
    "minerals",
    "minute",
    "mirror",
    "missing",
    "mission",
    "mistake",
    "mix",
    "mixture",
    "model",
    "modern",
    "molecular",
    "moment",
    "money",
    "monkey",
    "month",
    "mood",
    "moon",
    "more",
    "morning",
    "most",
    "mostly",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "mouth",
    "move",
    "movement",
    "movie",
    "moving",
    "mud",
    "muscle",
    "music",
    "musical",
    "must",
    "my",
    "myself",
    "mysterious",
    "nails",
    "name",
    "nation",
    "national",
    "native",
    "natural",
    "naturally",
    "nature",
    "near",
    "nearby",
    "nearer",
    "nearest",
    "nearly",
    "necessary",
    "neck",
    "needed",
    "needle",
    "needs",
    "negative",
    "neighbor",
    "neighborhood",
    "nervous",
    "nest",
    "never",
    "new",
    "news",
    "newspaper",
    "next",
    "nice",
    "night",
    "nine",
    "no",
    "nobody",
    "nodded",
    "noise",
    "none",
    "noon",
    "nor",
    "north",
    "nose",
    "not",
    "note",
    "noted",
    "nothing",
    "notice",
    "noun",
    "now",
    "number",
    "numeral",
    "nuts",
    "object",
    "observe",
    "obtain",
    "occasionally",
    "occur",
    "ocean",
    "of",
    "off",
    "offer",
    "office",
    "officer",
    "official",
    "oil",
    "old",
    "older",
    "oldest",
    "on",
    "once",
    "one",
    "only",
    "onto",
    "open",
    "operation",
    "opinion",
    "opportunity",
    "opposite",
    "or",
    "orange",
    "orbit",
    "order",
    "ordinary",
    "organization",
    "organized",
    "origin",
    "original",
    "other",
    "ought",
    "our",
    "ourselves",
    "out",
    "outer",
    "outline",
    "outside",
    "over",
    "own",
    "owner",
    "oxygen",
    "pack",
    "package",
    "page",
    "paid",
    "pain",
    "paint",
    "pair",
    "palace",
    "pale",
    "pan",
    "paper",
    "paragraph",
    "parallel",
    "parent",
    "park",
    "part",
    "particles",
    "particular",
    "particularly",
    "partly",
    "parts",
    "party",
    "pass",
    "passage",
    "past",
    "path",
    "pattern",
    "pay",
    "peace",
    "pen",
    "pencil",
    "people",
    "per",
    "percent",
    "perfect",
    "perfectly",
    "perhaps",
    "period",
    "person",
    "personal",
    "pet",
    "phrase",
    "physical",
    "piano",
    "pick",
    "picture",
    "pictured",
    "pie",
    "piece",
    "pig",
    "pile",
    "pilot",
    "pine",
    "pink",
    "pipe",
    "pitch",
    "place",
    "plain",
    "plan",
    "plane",
    "planet",
    "planned",
    "planning",
    "plant",
    "plastic",
    "plate",
    "plates",
    "play",
    "pleasant",
    "please",
    "pleasure",
    "plenty",
    "plural",
    "plus",
    "pocket",
    "poem",
    "poet",
    "poetry",
    "point",
    "pole",
    "police",
    "policeman",
    "political",
    "pond",
    "pony",
    "pool",
    "poor",
    "popular",
    "population",
    "porch",
    "port",
    "position",
    "positive",
    "possible",
    "possibly",
    "post",
    "pot",
    "potatoes",
    "pound",
    "pour",
    "powder",
    "power",
    "powerful",
    "practical",
    "practice",
    "prepare",
    "present",
    "president",
    "press",
    "pressure",
    "pretty",
    "prevent",
    "previous",
    "price",
    "pride",
    "primitive",
    "principal",
    "principle",
    "printed",
    "private",
    "prize",
    "probably",
    "problem",
    "process",
    "produce",
    "product",
    "production",
    "program",
    "progress",
    "promised",
    "proper",
    "properly",
    "property",
    "protection",
    "proud",
    "prove",
    "provide",
    "public",
    "pull",
    "pupil",
    "pure",
    "purple",
    "purpose",
    "push",
    "put",
    "putting",
    "quarter",
    "queen",
    "question",
    "quick",
    "quickly",
    "quiet",
    "quietly",
    "quite",
    "rabbit",
    "race",
    "radio",
    "railroad",
    "rain",
    "raise",
    "ran",
    "ranch",
    "range",
    "rapidly",
    "rate",
    "rather",
    "raw",
    "rays",
    "reach",
    "read",
    "reader",
    "ready",
    "real",
    "realize",
    "rear",
    "reason",
    "recall",
    "receive",
    "recent",
    "recently",
    "recognize",
    "record",
    "red",
    "refer",
    "refused",
    "region",
    "regular",
    "related",
    "relationship",
    "religious",
    "remain",
    "remarkable",
    "remember",
    "remove",
    "repeat",
    "replace",
    "replied",
    "report",
    "represent",
    "require",
    "research",
    "respect",
    "rest",
    "result",
    "return",
    "review",
    "rhyme",
    "rhythm",
    "rice",
    "rich",
    "ride",
    "riding",
    "right",
    "ring",
    "rise",
    "rising",
    "river",
    "road",
    "roar",
    "rock",
    "rocket",
    "rocky",
    "rod",
    "roll",
    "roof",
    "room",
    "root",
    "rope",
    "rose",
    "rough",
    "round",
    "route",
    "row",
    "rubbed",
    "rubber",
    "rule",
    "ruler",
    "run",
    "running",
    "rush",
    "sad",
    "saddle",
    "safe",
    "safety",
    "said",
    "sail",
    "sale",
    "salmon",
    "salt",
    "same",
    "sand",
    "sang",
    "sat",
    "satellites",
    "satisfied",
    "save",
    "saved",
    "saw",
    "say",
    "scale",
    "scared",
    "scene",
    "school",
    "science",
    "scientific",
    "scientist",
    "score",
    "screen",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "see",
    "seed",
    "seeing",
    "seems",
    "seen",
    "seldom",
    "select",
    "selection",
    "sell",
    "send",
    "sense",
    "sent",
    "sentence",
    "separate",
    "series",
    "serious",
    "serve",
    "service",
    "sets",
    "setting",
    "settle",
    "settlers",
    "seven",
    "several",
    "shade",
    "shadow",
    "shake",
    "shaking",
    "shall",
    "shallow",
    "shape",
    "share",
    "sharp",
    "she",
    "sheep",
    "sheet",
    "shelf",
    "shells",
    "shelter",
    "shine",
    "shinning",
    "ship",
    "shirt",
    "shoe",
    "shoot",
    "shop",
    "shore",
    "short",
    "shorter",
    "shot",
    "should",
    "shoulder",
    "shout",
    "show",
    "shown",
    "shut",
    "sick",
    "sides",
    "sight",
    "sign",
    "signal",
    "silence",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "simplest",
    "simply",
    "since",
    "sing",
    "single",
    "sink",
    "sister",
    "sit",
    "sitting",
    "situation",
    "six",
    "size",
    "skill",
    "skin",
    "sky",
    "slabs",
    "slave",
    "sleep",
    "slept",
    "slide",
    "slight",
    "slightly",
    "slip",
    "slipped",
    "slope",
    "slow",
    "slowly",
    "small",
    "smaller",
    "smallest",
    "smell",
    "smile",
    "smoke",
    "smooth",
    "snake",
    "snow",
    "so",
    "soap",
    "social",
    "society",
    "soft",
    "softly",
    "soil",
    "solar",
    "sold",
    "soldier",
    "solid",
    "solution",
    "solve",
    "some",
    "somebody",
    "somehow",
    "someone",
    "something",
    "sometime",
    "somewhere",
    "son",
    "song",
    "soon",
    "sort",
    "sound",
    "source",
    "south",
    "southern",
    "space",
    "speak",
    "special",
    "species",
    "specific",
    "speech",
    "speed",
    "spell",
    "spend",
    "spent",
    "spider",
    "spin",
    "spirit",
    "spite",
    "split",
    "spoken",
    "sport",
    "spread",
    "spring",
    "square",
    "stage",
    "stairs",
    "stand",
    "standard",
    "star",
    "stared",
    "start",
    "state",
    "statement",
    "station",
    "stay",
    "steady",
    "steam",
    "steel",
    "steep",
    "stems",
    "step",
    "stepped",
    "stick",
    "stiff",
    "still",
    "stock",
    "stomach",
    "stone",
    "stood",
    "stop",
    "stopped",
    "store",
    "storm",
    "story",
    "stove",
    "straight",
    "strange",
    "stranger",
    "straw",
    "stream",
    "street",
    "strength",
    "stretch",
    "strike",
    "string",
    "strip",
    "strong",
    "stronger",
    "struck",
    "structure",
    "struggle",
    "stuck",
    "student",
    "studied",
    "studying",
    "subject",
    "substance",
    "success",
    "successful",
    "such",
    "sudden",
    "suddenly",
    "sugar",
    "suggest",
    "suit",
    "sum",
    "summer",
    "sun",
    "sunlight",
    "supper",
    "supply",
    "support",
    "suppose",
    "sure",
    "surface",
    "surprise",
    "surrounded",
    "swam",
    "sweet",
    "swept",
    "swim",
    "swimming",
    "swing",
    "swung",
    "syllable",
    "symbol",
    "system",
    "table",
    "tail",
    "take",
    "taken",
    "tales",
    "talk",
    "tall",
    "tank",
    "tape",
    "task",
    "taste",
    "taught",
    "tax",
    "tea",
    "teach",
    "teacher",
    "team",
    "tears",
    "teeth",
    "telephone",
    "television",
    "tell",
    "temperature",
    "ten",
    "tent",
    "term",
    "terrible",
    "test",
    "than",
    "thank",
    "that",
    "thee",
    "them",
    "themselves",
    "then",
    "theory",
    "there",
    "therefore",
    "these",
    "they",
    "thick",
    "thin",
    "thing",
    "think",
    "third",
    "thirty",
    "this",
    "those",
    "thou",
    "though",
    "thought",
    "thousand",
    "thread",
    "three",
    "threw",
    "throat",
    "through",
    "throughout",
    "throw",
    "thrown",
    "thumb",
    "thus",
    "thy",
    "tide",
    "tie",
    "tight",
    "tightly",
    "till",
    "time",
    "tin",
    "tiny",
    "tip",
    "tired",
    "title",
    "to",
    "tobacco",
    "today",
    "together",
    "told",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "too",
    "took",
    "tool",
    "top",
    "topic",
    "torn",
    "total",
    "touch",
    "toward",
    "tower",
    "town",
    "toy",
    "trace",
    "track",
    "trade",
    "traffic",
    "trail",
    "train",
    "transportation",
    "trap",
    "travel",
    "treated",
    "tree",
    "triangle",
    "tribe",
    "trick",
    "tried",
    "trip",
    "troops",
    "tropical",
    "trouble",
    "truck",
    "trunk",
    "truth",
    "try",
    "tube",
    "tune",
    "turn",
    "twelve",
    "twenty",
    "twice",
    "two",
    "type",
    "typical",
    "uncle",
    "under",
    "underline",
    "understanding",
    "unhappy",
    "union",
    "unit",
    "universe",
    "unknown",
    "unless",
    "until",
    "unusual",
    "up",
    "upon",
    "upper",
    "upward",
    "us",
    "use",
    "useful",
    "using",
    "usual",
    "usually",
    "valley",
    "valuable",
    "value",
    "vapor",
    "variety",
    "various",
    "vast",
    "vegetable",
    "verb",
    "vertical",
    "very",
    "vessels",
    "victory",
    "view",
    "village",
    "visit",
    "visitor",
    "voice",
    "volume",
    "vote",
    "vowel",
    "voyage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "want",
    "war",
    "warm",
    "warn",
    "was",
    "wash",
    "waste",
    "watch",
    "water",
    "wave",
    "way",
    "we",
    "weak",
    "wealth",
    "wear",
    "weather",
    "week",
    "weigh",
    "weight",
    "welcome",
    "well",
    "went",
    "were",
    "west",
    "western",
    "wet",
    "whale",
    "what",
    "whatever",
    "wheat",
    "wheel",
    "when",
    "whenever",
    "where",
    "wherever",
    "whether",
    "which",
    "while",
    "whispered",
    "whistle",
    "white",
    "who",
    "whole",
    "whom",
    "whose",
    "why",
    "wide",
    "widely",
    "wife",
    "wild",
    "will",
    "willing",
    "win",
    "wind",
    "window",
    "wing",
    "winter",
    "wire",
    "wise",
    "wish",
    "with",
    "within",
    "without",
    "wolf",
    "women",
    "won",
    "wonder",
    "wonderful",
    "wood",
    "wooden",
    "wool",
    "word",
    "wore",
    "work",
    "worker",
    "world",
    "worried",
    "worry",
    "worse",
    "worth",
    "would",
    "wrapped",
    "write",
    "writer",
    "writing",
    "written",
    "wrong",
    "wrote",
    "yard",
    "year",
    "yellow",
    "yes",
    "yesterday",
    "yet",
    "you",
    "young",
    "younger",
    "your",
    "yourself",
    "youth",
    "zero",
    "zebra",
    "zipper",
    "zoo",
    "zulu"
];
function $e8974731944f9b11$var$words(options) {
    // initalize random number generator for words if options.seed is provided
    const random = (options === null || options === void 0 ? void 0 : options.seed) ? new $18sFW(options.seed) : null;
    function word() {
        if (options && options.maxLength > 1) return generateWordWithMaxLength();
        else return generateRandomWord();
    }
    function generateWordWithMaxLength() {
        var rightSize = false;
        var wordUsed;
        while(!rightSize){
            wordUsed = generateRandomWord();
            if (wordUsed.length <= options.maxLength) rightSize = true;
        }
        return wordUsed;
    }
    function generateRandomWord() {
        return $e8974731944f9b11$var$wordList[randInt($e8974731944f9b11$var$wordList.length)];
    }
    // random int as seeded by options.seed if applicable, or Math.random() otherwise
    function randInt(lessThan) {
        const r = random ? random() : Math.random();
        return Math.floor(r * lessThan);
    }
    // No arguments = generate one word
    if (typeof options === "undefined") return word();
    // Just a number = return that many words
    if (typeof options === "number") options = {
        exactly: options
    };
    // options supported: exactly, min, max, join
    if (options.exactly) {
        options.min = options.exactly;
        options.max = options.exactly;
    }
    // not a number = one word par string
    if (typeof options.wordsPerString !== "number") options.wordsPerString = 1;
    //not a function = returns the raw word
    if (typeof options.formatter !== "function") options.formatter = (word)=>word;
    //not a string = separator is a space
    if (typeof options.separator !== "string") options.separator = " ";
    var total = options.min + randInt(options.max + 1 - options.min);
    var results = [];
    var token = "";
    var relativeIndex = 0;
    for(var i = 0; i < total * options.wordsPerString; i++){
        if (relativeIndex === options.wordsPerString - 1) token += options.formatter(word(), relativeIndex);
        else token += options.formatter(word(), relativeIndex) + options.separator;
        relativeIndex++;
        if ((i + 1) % options.wordsPerString === 0) {
            results.push(token);
            token = "";
            relativeIndex = 0;
        }
    }
    if (typeof options.join === "string") results = results.join(options.join);
    return results;
}
module.exports = $e8974731944f9b11$var$words;
// Export the word list as it is often useful
$e8974731944f9b11$var$words.wordList = $e8974731944f9b11$var$wordList;

});
parcelRegister("18sFW", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $5FJvA = parcelRequire("5FJvA");

var $r1Plo = parcelRequire("r1Plo");

var $cikzk = parcelRequire("cikzk");

var $keayp = parcelRequire("keayp");

var $1Ef4q = parcelRequire("1Ef4q");

var $8nizx = parcelRequire("8nizx");

var $1nLBK = parcelRequire("1nLBK");
$1nLBK.alea = $5FJvA;
$1nLBK.xor128 = $r1Plo;
$1nLBK.xorwow = $cikzk;
$1nLBK.xorshift7 = $keayp;
$1nLBK.xor4096 = $1Ef4q;
$1nLBK.tychei = $8nizx;
module.exports = $1nLBK;

});
parcelRegister("5FJvA", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("r1Plo", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("cikzk", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("keayp", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("1Ef4q", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\0";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("8nizx", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("1nLBK", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\0";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("3Z5AP"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});
parcelRegister("3Z5AP", function(module, exports) {
"use strict";

});




parcelRegister("7bqxg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $6pM8C.default;
    }
});

var $6pM8C = parcelRequire("6pM8C");

});
parcelRegister("6pM8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aba6b105cc0fbac$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");

var $9wOP6 = parcelRequire("9wOP6");
function $4aba6b105cc0fbac$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement((0, $9wOP6.default), (0, $8JsGL.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $9wOP6.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).forwardRef(Component));
}

});
parcelRegister("9wOP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6efe86a39a5415b4$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");

var $f0yL6 = parcelRequire("f0yL6");
var $6efe86a39a5415b4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $6efe86a39a5415b4$var$SvgIcon = /*#__PURE__*/ $5KQk5.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $f0yL6.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $f0yL6.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $5KQk5.createElement("title", null, titleAccess) : null);
});
$6efe86a39a5415b4$var$SvgIcon.muiName = "SvgIcon";
var $6efe86a39a5415b4$export$2e2bcd8739ae039 = (0, $3VtpS.default)($6efe86a39a5415b4$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($6efe86a39a5415b4$var$SvgIcon);

});
parcelRegister("S2OIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a273aad3f4ac2c4$export$2e2bcd8739ae039; });

var $4gGez = parcelRequire("4gGez");
function $0a273aad3f4ac2c4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $4gGez.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});

parcelRegister("6479q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46a8a9db457a9753$export$2e2bcd8739ae039; });
function $46a8a9db457a9753$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $46a8a9db457a9753$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $46a8a9db457a9753$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $46a8a9db457a9753$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $46a8a9db457a9753$export$2e2bcd8739ae039 = $46a8a9db457a9753$export$4f5d2d50c9deca37;

});

parcelRegister("3VtpS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dbd83750950fadf$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $d63Yp = parcelRequire("d63Yp");

var $1M7cg = parcelRequire("1M7cg");
function $2dbd83750950fadf$var$withStyles(stylesOrCreator, options) {
    return (0, $d63Yp.default)(stylesOrCreator, (0, $8JsGL.default)({
        defaultTheme: (0, $1M7cg.default)
    }, options));
}
var $2dbd83750950fadf$export$2e2bcd8739ae039 = $2dbd83750950fadf$var$withStyles;

});
parcelRegister("d63Yp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $988eeaec3aa72319$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $dPh4j = parcelRequire("dPh4j");


var $jeCqG = parcelRequire("jeCqG");

var $7K7iU = parcelRequire("7K7iU");

var $eV3HM = parcelRequire("eV3HM");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $988eeaec3aa72319$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $S2OIO.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $jeCqG.default)(stylesOrCreator, (0, $8JsGL.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $S2OIO.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $8JsGL.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $eV3HM.default)() || defaultTheme;
                if (name) more = (0, $7K7iU.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement(Component, (0, $8JsGL.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dPh4j)))(WithStyles, Component);
        return WithStyles;
    };
};
var $988eeaec3aa72319$export$2e2bcd8739ae039 = $988eeaec3aa72319$var$withStyles;

});
parcelRegister("dPh4j", function(module, exports) {
"use strict";

var $jSuLF = parcelRequire("jSuLF");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a10d473f7a30e4e6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a10d473f7a30e4e6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a10d473f7a30e4e6$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $a10d473f7a30e4e6$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $a10d473f7a30e4e6$var$TYPE_STATICS = {};
$a10d473f7a30e4e6$var$TYPE_STATICS[$jSuLF.ForwardRef] = $a10d473f7a30e4e6$var$FORWARD_REF_STATICS;
$a10d473f7a30e4e6$var$TYPE_STATICS[$jSuLF.Memo] = $a10d473f7a30e4e6$var$MEMO_STATICS;
function $a10d473f7a30e4e6$var$getStatics(component) {
    // React v16.11 and below
    if ($jSuLF.isMemo(component)) return $a10d473f7a30e4e6$var$MEMO_STATICS;
     // React v16.12 and above
    return $a10d473f7a30e4e6$var$TYPE_STATICS[component["$$typeof"]] || $a10d473f7a30e4e6$var$REACT_STATICS;
}
var $a10d473f7a30e4e6$var$defineProperty = Object.defineProperty;
var $a10d473f7a30e4e6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a10d473f7a30e4e6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a10d473f7a30e4e6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a10d473f7a30e4e6$var$getPrototypeOf = Object.getPrototypeOf;
var $a10d473f7a30e4e6$var$objectPrototype = Object.prototype;
function $a10d473f7a30e4e6$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($a10d473f7a30e4e6$var$objectPrototype) {
            var inheritedComponent = $a10d473f7a30e4e6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a10d473f7a30e4e6$var$objectPrototype) $a10d473f7a30e4e6$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a10d473f7a30e4e6$var$getOwnPropertyNames(sourceComponent);
        if ($a10d473f7a30e4e6$var$getOwnPropertySymbols) keys = keys.concat($a10d473f7a30e4e6$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $a10d473f7a30e4e6$var$getStatics(targetComponent);
        var sourceStatics = $a10d473f7a30e4e6$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a10d473f7a30e4e6$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $a10d473f7a30e4e6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $a10d473f7a30e4e6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $a10d473f7a30e4e6$var$hoistNonReactStatics;

});
parcelRegister("jSuLF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jIl6h"));

});


parcelRegister("jeCqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e00d22637c739009$export$2e2bcd8739ae039; });

var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");

var $fGHuV = parcelRequire("fGHuV");

var $iCPvQ = parcelRequire("iCPvQ");

var $cIfca = parcelRequire("cIfca");

var $eV3HM = parcelRequire("eV3HM");

var $de7ih = parcelRequire("de7ih");

var $3WDhO = parcelRequire("3WDhO");

var $2dgeO = parcelRequire("2dgeO");

var $isuHo = parcelRequire("isuHo");
function $e00d22637c739009$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $iCPvQ.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $e00d22637c739009$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $cIfca.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $cIfca.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $8JsGL.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $cIfca.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $8JsGL.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $cIfca.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $fGHuV.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $8JsGL.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $iCPvQ.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $e00d22637c739009$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $e00d22637c739009$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $cIfca.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $cIfca.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $e00d22637c739009$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $e00d22637c739009$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $isuHo.default) : _options$defaultTheme, stylesOptions2 = (0, $S2OIO.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $2dgeO.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $3WDhO.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $eV3HM.default)() || defaultTheme;
        var stylesOptions = (0, $8JsGL.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useContext((0, $de7ih.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useRef();
        $e00d22637c739009$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $e00d22637c739009$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $e00d22637c739009$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useEffect(function() {
            if (shouldUpdate.current) $e00d22637c739009$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $e00d22637c739009$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("iCPvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8f3bbf0d8efbf6c$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

function $d8f3bbf0d8efbf6c$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $8JsGL.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("cIfca", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94156190c6157838$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $94156190c6157838$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $94156190c6157838$export$2e2bcd8739ae039 = $94156190c6157838$var$multiKeyStore;

});

parcelRegister("eV3HM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adc94353ee86bb25$export$2e2bcd8739ae039; });

var $5KQk5 = parcelRequire("5KQk5");

var $1RDt7 = parcelRequire("1RDt7");
function $adc94353ee86bb25$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useContext((0, $1RDt7.default));
    return theme;
}

});
parcelRegister("1RDt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b95b55ec0a2c4d$export$2e2bcd8739ae039; });

var $5KQk5 = parcelRequire("5KQk5");
var $15b95b55ec0a2c4d$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createContext(null);
var $15b95b55ec0a2c4d$export$2e2bcd8739ae039 = $15b95b55ec0a2c4d$var$ThemeContext;

});


parcelRegister("de7ih", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $9a123d9788c32c0a$export$f4de434b269fe487; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");



var $f5RQf = parcelRequire("f5RQf");

var $fGHuV = parcelRequire("fGHuV");

var $lPrNI = parcelRequire("lPrNI");
var $9a123d9788c32c0a$var$jss = (0, $fGHuV.create)((0, $lPrNI.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $9a123d9788c32c0a$var$generateClassName = (0, $f5RQf.default)(); // Exported for test purposes
var $9a123d9788c32c0a$export$70a8aea9ff58d1cd = new Map();
var $9a123d9788c32c0a$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $9a123d9788c32c0a$var$generateClassName,
    jss: $9a123d9788c32c0a$var$jss,
    sheetsCache: null,
    sheetsManager: $9a123d9788c32c0a$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $9a123d9788c32c0a$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createContext($9a123d9788c32c0a$var$defaultOptions);
var $9a123d9788c32c0a$var$injectFirstNode;
function $9a123d9788c32c0a$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $S2OIO.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useContext($9a123d9788c32c0a$export$f4de434b269fe487);
    var context = (0, $8JsGL.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$9a123d9788c32c0a$var$injectFirstNode) {
            var head = document.head;
            $9a123d9788c32c0a$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($9a123d9788c32c0a$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $fGHuV.create)({
            plugins: (0, $lPrNI.default)().plugins,
            insertionPoint: $9a123d9788c32c0a$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement($9a123d9788c32c0a$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("f5RQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afd116778c293d67$export$2e2bcd8739ae039; });

var $150Me = parcelRequire("150Me");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $afd116778c293d67$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $afd116778c293d67$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($afd116778c293d67$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $150Me.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("150Me", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c96dc5edaf9aeb7$export$2e2bcd8739ae039; });
var $0c96dc5edaf9aeb7$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $0c96dc5edaf9aeb7$export$2e2bcd8739ae039 = $0c96dc5edaf9aeb7$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("lPrNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe43ed1492393fd9$export$2e2bcd8739ae039; });

var $6Ck88 = parcelRequire("6Ck88");

var $8qEsI = parcelRequire("8qEsI");

var $c9xRh = parcelRequire("c9xRh");

var $KUI1j = parcelRequire("KUI1j");

var $4RONw = parcelRequire("4RONw");

var $4WKIg = parcelRequire("4WKIg");

var $fWEP2 = parcelRequire("fWEP2");
function $fe43ed1492393fd9$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $6Ck88.default)(),
            (0, $8qEsI.default)(),
            (0, $c9xRh.default)(),
            (0, $KUI1j.default)(),
            (0, $4RONw.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $4WKIg.default)(),
            (0, $fWEP2.default)()
        ]
    };
}

});
parcelRegister("6Ck88", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d15e8236c329137$export$2e2bcd8739ae039; });


var $fGHuV = parcelRequire("fGHuV");
var $4d15e8236c329137$var$now = Date.now();
var $4d15e8236c329137$var$fnValuesNs = "fnValues" + $4d15e8236c329137$var$now;
var $4d15e8236c329137$var$fnRuleNs = "fnStyle" + ++$4d15e8236c329137$var$now;
var $4d15e8236c329137$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $fGHuV.createRule)(name, {}, options);
            rule[$4d15e8236c329137$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($4d15e8236c329137$var$fnValuesNs in rule || $4d15e8236c329137$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$4d15e8236c329137$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$4d15e8236c329137$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$4d15e8236c329137$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $4d15e8236c329137$export$2e2bcd8739ae039 = $4d15e8236c329137$var$functionPlugin;

});

parcelRegister("8qEsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62302362188ece76$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $fGHuV = parcelRequire("fGHuV");
var $62302362188ece76$var$at = "@global";
var $62302362188ece76$var$atPrefix = "@global ";
var $62302362188ece76$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $62302362188ece76$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $fGHuV.RuleList)((0, $8JsGL.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $62302362188ece76$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $62302362188ece76$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($62302362188ece76$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $8JsGL.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $62302362188ece76$var$separatorRegExp = /\s*,\s*/g;
function $62302362188ece76$var$addScope(selector, scope) {
    var parts = selector.split($62302362188ece76$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $62302362188ece76$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$62302362188ece76$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $8JsGL.default)({}, options, {
        selector: $62302362188ece76$var$addScope(name, rule.selector)
    }));
    delete style[$62302362188ece76$var$at];
}
function $62302362188ece76$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $62302362188ece76$var$at.length) !== $62302362188ece76$var$at) continue;
        var selector = $62302362188ece76$var$addScope(prop.substr($62302362188ece76$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $8JsGL.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $62302362188ece76$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $62302362188ece76$var$at) return new $62302362188ece76$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $62302362188ece76$var$atPrefix.length) === $62302362188ece76$var$atPrefix) return new $62302362188ece76$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $62302362188ece76$var$handleNestedGlobalContainerRule(rule, sheet);
        $62302362188ece76$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $62302362188ece76$export$2e2bcd8739ae039 = $62302362188ece76$var$jssGlobal;

});

parcelRegister("c9xRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9096dde59c45be$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $8d9096dde59c45be$var$separatorRegExp = /\s*,\s*/g;
var $8d9096dde59c45be$var$parentRegExp = /&/g;
var $8d9096dde59c45be$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $8d9096dde59c45be$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($8d9096dde59c45be$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($8d9096dde59c45be$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($8d9096dde59c45be$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $8JsGL.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $8JsGL.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($8d9096dde59c45be$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $8JsGL.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $8JsGL.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $8d9096dde59c45be$export$2e2bcd8739ae039 = $8d9096dde59c45be$var$jssNested;

});

parcelRegister("KUI1j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08d049380ba44fd2$export$2e2bcd8739ae039; });

var $eCYDG = parcelRequire("eCYDG");
/**
 * Convert camel cased property names to dash separated.
 */ function $08d049380ba44fd2$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $eCYDG.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($08d049380ba44fd2$var$convertCase);
        else converted.fallbacks = $08d049380ba44fd2$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $08d049380ba44fd2$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $08d049380ba44fd2$var$convertCase(style[index]);
            return style;
        }
        return $08d049380ba44fd2$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $eCYDG.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $08d049380ba44fd2$export$2e2bcd8739ae039 = $08d049380ba44fd2$var$camelCase;

});
parcelRegister("eCYDG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa63a6f59f988ace$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $aa63a6f59f988ace$var$uppercasePattern = /[A-Z]/g;
var $aa63a6f59f988ace$var$msPattern = /^ms-/;
var $aa63a6f59f988ace$var$cache = {};
function $aa63a6f59f988ace$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $aa63a6f59f988ace$var$hyphenateStyleName(name) {
    if ($aa63a6f59f988ace$var$cache.hasOwnProperty(name)) return $aa63a6f59f988ace$var$cache[name];
    var hName = name.replace($aa63a6f59f988ace$var$uppercasePattern, $aa63a6f59f988ace$var$toHyphenLower);
    return $aa63a6f59f988ace$var$cache[name] = $aa63a6f59f988ace$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $aa63a6f59f988ace$export$2e2bcd8739ae039 = $aa63a6f59f988ace$var$hyphenateStyleName;

});


parcelRegister("4RONw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38b3840c2329fbcb$export$2e2bcd8739ae039; });

var $fGHuV = parcelRequire("fGHuV");
var $38b3840c2329fbcb$var$px = (0, $fGHuV.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $38b3840c2329fbcb$var$ms = (0, $fGHuV.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $38b3840c2329fbcb$var$percent = (0, $fGHuV.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $38b3840c2329fbcb$var$defaultUnits = {
    // Animation properties
    "animation-delay": $38b3840c2329fbcb$var$ms,
    "animation-duration": $38b3840c2329fbcb$var$ms,
    // Background properties
    "background-position": $38b3840c2329fbcb$var$px,
    "background-position-x": $38b3840c2329fbcb$var$px,
    "background-position-y": $38b3840c2329fbcb$var$px,
    "background-size": $38b3840c2329fbcb$var$px,
    // Border Properties
    border: $38b3840c2329fbcb$var$px,
    "border-bottom": $38b3840c2329fbcb$var$px,
    "border-bottom-left-radius": $38b3840c2329fbcb$var$px,
    "border-bottom-right-radius": $38b3840c2329fbcb$var$px,
    "border-bottom-width": $38b3840c2329fbcb$var$px,
    "border-left": $38b3840c2329fbcb$var$px,
    "border-left-width": $38b3840c2329fbcb$var$px,
    "border-radius": $38b3840c2329fbcb$var$px,
    "border-right": $38b3840c2329fbcb$var$px,
    "border-right-width": $38b3840c2329fbcb$var$px,
    "border-top": $38b3840c2329fbcb$var$px,
    "border-top-left-radius": $38b3840c2329fbcb$var$px,
    "border-top-right-radius": $38b3840c2329fbcb$var$px,
    "border-top-width": $38b3840c2329fbcb$var$px,
    "border-width": $38b3840c2329fbcb$var$px,
    "border-block": $38b3840c2329fbcb$var$px,
    "border-block-end": $38b3840c2329fbcb$var$px,
    "border-block-end-width": $38b3840c2329fbcb$var$px,
    "border-block-start": $38b3840c2329fbcb$var$px,
    "border-block-start-width": $38b3840c2329fbcb$var$px,
    "border-block-width": $38b3840c2329fbcb$var$px,
    "border-inline": $38b3840c2329fbcb$var$px,
    "border-inline-end": $38b3840c2329fbcb$var$px,
    "border-inline-end-width": $38b3840c2329fbcb$var$px,
    "border-inline-start": $38b3840c2329fbcb$var$px,
    "border-inline-start-width": $38b3840c2329fbcb$var$px,
    "border-inline-width": $38b3840c2329fbcb$var$px,
    "border-start-start-radius": $38b3840c2329fbcb$var$px,
    "border-start-end-radius": $38b3840c2329fbcb$var$px,
    "border-end-start-radius": $38b3840c2329fbcb$var$px,
    "border-end-end-radius": $38b3840c2329fbcb$var$px,
    // Margin properties
    margin: $38b3840c2329fbcb$var$px,
    "margin-bottom": $38b3840c2329fbcb$var$px,
    "margin-left": $38b3840c2329fbcb$var$px,
    "margin-right": $38b3840c2329fbcb$var$px,
    "margin-top": $38b3840c2329fbcb$var$px,
    "margin-block": $38b3840c2329fbcb$var$px,
    "margin-block-end": $38b3840c2329fbcb$var$px,
    "margin-block-start": $38b3840c2329fbcb$var$px,
    "margin-inline": $38b3840c2329fbcb$var$px,
    "margin-inline-end": $38b3840c2329fbcb$var$px,
    "margin-inline-start": $38b3840c2329fbcb$var$px,
    // Padding properties
    padding: $38b3840c2329fbcb$var$px,
    "padding-bottom": $38b3840c2329fbcb$var$px,
    "padding-left": $38b3840c2329fbcb$var$px,
    "padding-right": $38b3840c2329fbcb$var$px,
    "padding-top": $38b3840c2329fbcb$var$px,
    "padding-block": $38b3840c2329fbcb$var$px,
    "padding-block-end": $38b3840c2329fbcb$var$px,
    "padding-block-start": $38b3840c2329fbcb$var$px,
    "padding-inline": $38b3840c2329fbcb$var$px,
    "padding-inline-end": $38b3840c2329fbcb$var$px,
    "padding-inline-start": $38b3840c2329fbcb$var$px,
    // Mask properties
    "mask-position-x": $38b3840c2329fbcb$var$px,
    "mask-position-y": $38b3840c2329fbcb$var$px,
    "mask-size": $38b3840c2329fbcb$var$px,
    // Width and height properties
    height: $38b3840c2329fbcb$var$px,
    width: $38b3840c2329fbcb$var$px,
    "min-height": $38b3840c2329fbcb$var$px,
    "max-height": $38b3840c2329fbcb$var$px,
    "min-width": $38b3840c2329fbcb$var$px,
    "max-width": $38b3840c2329fbcb$var$px,
    // Position properties
    bottom: $38b3840c2329fbcb$var$px,
    left: $38b3840c2329fbcb$var$px,
    top: $38b3840c2329fbcb$var$px,
    right: $38b3840c2329fbcb$var$px,
    inset: $38b3840c2329fbcb$var$px,
    "inset-block": $38b3840c2329fbcb$var$px,
    "inset-block-end": $38b3840c2329fbcb$var$px,
    "inset-block-start": $38b3840c2329fbcb$var$px,
    "inset-inline": $38b3840c2329fbcb$var$px,
    "inset-inline-end": $38b3840c2329fbcb$var$px,
    "inset-inline-start": $38b3840c2329fbcb$var$px,
    // Shadow properties
    "box-shadow": $38b3840c2329fbcb$var$px,
    "text-shadow": $38b3840c2329fbcb$var$px,
    // Column properties
    "column-gap": $38b3840c2329fbcb$var$px,
    "column-rule": $38b3840c2329fbcb$var$px,
    "column-rule-width": $38b3840c2329fbcb$var$px,
    "column-width": $38b3840c2329fbcb$var$px,
    // Font and text properties
    "font-size": $38b3840c2329fbcb$var$px,
    "font-size-delta": $38b3840c2329fbcb$var$px,
    "letter-spacing": $38b3840c2329fbcb$var$px,
    "text-decoration-thickness": $38b3840c2329fbcb$var$px,
    "text-indent": $38b3840c2329fbcb$var$px,
    "text-stroke": $38b3840c2329fbcb$var$px,
    "text-stroke-width": $38b3840c2329fbcb$var$px,
    "word-spacing": $38b3840c2329fbcb$var$px,
    // Motion properties
    motion: $38b3840c2329fbcb$var$px,
    "motion-offset": $38b3840c2329fbcb$var$px,
    // Outline properties
    outline: $38b3840c2329fbcb$var$px,
    "outline-offset": $38b3840c2329fbcb$var$px,
    "outline-width": $38b3840c2329fbcb$var$px,
    // Perspective properties
    perspective: $38b3840c2329fbcb$var$px,
    "perspective-origin-x": $38b3840c2329fbcb$var$percent,
    "perspective-origin-y": $38b3840c2329fbcb$var$percent,
    // Transform properties
    "transform-origin": $38b3840c2329fbcb$var$percent,
    "transform-origin-x": $38b3840c2329fbcb$var$percent,
    "transform-origin-y": $38b3840c2329fbcb$var$percent,
    "transform-origin-z": $38b3840c2329fbcb$var$percent,
    // Transition properties
    "transition-delay": $38b3840c2329fbcb$var$ms,
    "transition-duration": $38b3840c2329fbcb$var$ms,
    // Alignment properties
    "vertical-align": $38b3840c2329fbcb$var$px,
    "flex-basis": $38b3840c2329fbcb$var$px,
    // Some random properties
    "shape-margin": $38b3840c2329fbcb$var$px,
    size: $38b3840c2329fbcb$var$px,
    gap: $38b3840c2329fbcb$var$px,
    // Grid properties
    grid: $38b3840c2329fbcb$var$px,
    "grid-gap": $38b3840c2329fbcb$var$px,
    "row-gap": $38b3840c2329fbcb$var$px,
    "grid-row-gap": $38b3840c2329fbcb$var$px,
    "grid-column-gap": $38b3840c2329fbcb$var$px,
    "grid-template-rows": $38b3840c2329fbcb$var$px,
    "grid-template-columns": $38b3840c2329fbcb$var$px,
    "grid-auto-rows": $38b3840c2329fbcb$var$px,
    "grid-auto-columns": $38b3840c2329fbcb$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $38b3840c2329fbcb$var$px,
    "box-shadow-y": $38b3840c2329fbcb$var$px,
    "box-shadow-blur": $38b3840c2329fbcb$var$px,
    "box-shadow-spread": $38b3840c2329fbcb$var$px,
    "font-line-height": $38b3840c2329fbcb$var$px,
    "text-shadow-x": $38b3840c2329fbcb$var$px,
    "text-shadow-y": $38b3840c2329fbcb$var$px,
    "text-shadow-blur": $38b3840c2329fbcb$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $38b3840c2329fbcb$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $38b3840c2329fbcb$var$units = $38b3840c2329fbcb$var$addCamelCasedVersion($38b3840c2329fbcb$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $38b3840c2329fbcb$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $38b3840c2329fbcb$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $38b3840c2329fbcb$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $38b3840c2329fbcb$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $38b3840c2329fbcb$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $38b3840c2329fbcb$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $38b3840c2329fbcb$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $38b3840c2329fbcb$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $38b3840c2329fbcb$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $38b3840c2329fbcb$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $38b3840c2329fbcb$export$2e2bcd8739ae039 = $38b3840c2329fbcb$var$defaultUnit;

});

parcelRegister("4WKIg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39a0d06683345f76$export$2e2bcd8739ae039; });

var $j9nE2 = parcelRequire("j9nE2");

var $fGHuV = parcelRequire("fGHuV");
/**
 * Add vendor prefix to a property name when needed.
 */ function $39a0d06683345f76$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $j9nE2.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $j9nE2.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $j9nE2.supportedValue)(supportedProp, (0, $fGHuV.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $j9nE2.supportedValue)(prop, (0, $fGHuV.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $39a0d06683345f76$export$2e2bcd8739ae039 = $39a0d06683345f76$var$jssVendorPrefixer;

});
parcelRegister("j9nE2", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $df1132ed9aa39232$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $df1132ed9aa39232$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $df1132ed9aa39232$export$511766124059c277; });

var $6HanM = parcelRequire("6HanM");

var $78mMa = parcelRequire("78mMa");
// Export javascript style and css style vendor prefixes.
var $df1132ed9aa39232$var$js = "";
var $df1132ed9aa39232$var$css = "";
var $df1132ed9aa39232$var$vendor = "";
var $df1132ed9aa39232$var$browser = "";
var $df1132ed9aa39232$var$isTouch = (0, $6HanM.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $6HanM.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $df1132ed9aa39232$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $df1132ed9aa39232$var$_document$createEleme = document.createElement("p"), $df1132ed9aa39232$var$style = $df1132ed9aa39232$var$_document$createEleme.style;
    var $df1132ed9aa39232$var$testProp = "Transform";
    for(var $df1132ed9aa39232$var$key in $df1132ed9aa39232$var$jsCssMap)if ($df1132ed9aa39232$var$key + $df1132ed9aa39232$var$testProp in $df1132ed9aa39232$var$style) {
        $df1132ed9aa39232$var$js = $df1132ed9aa39232$var$key;
        $df1132ed9aa39232$var$css = $df1132ed9aa39232$var$jsCssMap[$df1132ed9aa39232$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($df1132ed9aa39232$var$js === "Webkit" && "msHyphens" in $df1132ed9aa39232$var$style) {
        $df1132ed9aa39232$var$js = "ms";
        $df1132ed9aa39232$var$css = $df1132ed9aa39232$var$jsCssMap.ms;
        $df1132ed9aa39232$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($df1132ed9aa39232$var$js === "Webkit" && "-apple-trailing-word" in $df1132ed9aa39232$var$style) $df1132ed9aa39232$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $df1132ed9aa39232$export$82e9f45cca5ba907 = {
    js: $df1132ed9aa39232$var$js,
    css: $df1132ed9aa39232$var$css,
    vendor: $df1132ed9aa39232$var$vendor,
    browser: $df1132ed9aa39232$var$browser,
    isTouch: $df1132ed9aa39232$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $df1132ed9aa39232$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $df1132ed9aa39232$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $df1132ed9aa39232$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $df1132ed9aa39232$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Webkit") return $df1132ed9aa39232$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $df1132ed9aa39232$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $df1132ed9aa39232$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $df1132ed9aa39232$var$camelize(str) {
    return str.replace($df1132ed9aa39232$var$regExp, $df1132ed9aa39232$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $df1132ed9aa39232$var$pascalize(str) {
    return $df1132ed9aa39232$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $df1132ed9aa39232$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($df1132ed9aa39232$var$camelize(longhand) in style) return prop;
            if ($df1132ed9aa39232$export$82e9f45cca5ba907.js + $df1132ed9aa39232$var$pascalize(longhand) in style) return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $df1132ed9aa39232$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.vendor === "apple" && !$df1132ed9aa39232$export$82e9f45cca5ba907.isTouch) return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $df1132ed9aa39232$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $df1132ed9aa39232$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $df1132ed9aa39232$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Webkit" || $df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms" && $df1132ed9aa39232$export$82e9f45cca5ba907.browser !== "edge") return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $df1132ed9aa39232$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Moz" || $df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms" || $df1132ed9aa39232$export$82e9f45cca5ba907.vendor === "apple") return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $df1132ed9aa39232$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $df1132ed9aa39232$var$pascalize(prop);
            return jsProp in style ? $df1132ed9aa39232$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $df1132ed9aa39232$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $df1132ed9aa39232$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $df1132ed9aa39232$export$82e9f45cca5ba907.js + $df1132ed9aa39232$var$pascalize(newProp) in style ? $df1132ed9aa39232$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $df1132ed9aa39232$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $df1132ed9aa39232$var$camelize(prop) in style ? prop : false;
    }
};
var $df1132ed9aa39232$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $df1132ed9aa39232$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js + pascalized in style) return $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $df1132ed9aa39232$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms") return "" + $df1132ed9aa39232$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $df1132ed9aa39232$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($df1132ed9aa39232$export$82e9f45cca5ba907.js === "ms") return $df1132ed9aa39232$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $df1132ed9aa39232$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $df1132ed9aa39232$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $df1132ed9aa39232$var$propMap[prop];
        if (!newProp) return false;
        return $df1132ed9aa39232$export$82e9f45cca5ba907.js + $df1132ed9aa39232$var$pascalize(newProp) in style ? $df1132ed9aa39232$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $df1132ed9aa39232$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $df1132ed9aa39232$var$propKeys = Object.keys($df1132ed9aa39232$var$propMap$1);
var $df1132ed9aa39232$var$prefixCss = function prefixCss(p) {
    return $df1132ed9aa39232$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $df1132ed9aa39232$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($df1132ed9aa39232$var$propKeys.indexOf(prop) > -1) {
            var newProp = $df1132ed9aa39232$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $df1132ed9aa39232$export$82e9f45cca5ba907.js + $df1132ed9aa39232$var$pascalize(newProp) in style ? $df1132ed9aa39232$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($df1132ed9aa39232$export$82e9f45cca5ba907.js + $df1132ed9aa39232$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($df1132ed9aa39232$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $df1132ed9aa39232$var$plugins = [
    $df1132ed9aa39232$var$appearence,
    $df1132ed9aa39232$var$colorAdjust,
    $df1132ed9aa39232$var$mask,
    $df1132ed9aa39232$var$textOrientation,
    $df1132ed9aa39232$var$transform,
    $df1132ed9aa39232$var$transition,
    $df1132ed9aa39232$var$writingMode,
    $df1132ed9aa39232$var$userSelect,
    $df1132ed9aa39232$var$breakPropsOld,
    $df1132ed9aa39232$var$inlineLogicalOld,
    $df1132ed9aa39232$var$unprefixed,
    $df1132ed9aa39232$var$prefixed,
    $df1132ed9aa39232$var$scrollSnap,
    $df1132ed9aa39232$var$overscrollBehavior,
    $df1132ed9aa39232$var$flex2012,
    $df1132ed9aa39232$var$flex2009
];
var $df1132ed9aa39232$var$propertyDetectors = $df1132ed9aa39232$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $df1132ed9aa39232$var$noPrefill = $df1132ed9aa39232$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $78mMa.default)(p.noPrefill));
    return a;
}, []);
var $df1132ed9aa39232$var$el;
var $df1132ed9aa39232$var$cache = {};
if (0, $6HanM.default) {
    $df1132ed9aa39232$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $df1132ed9aa39232$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $df1132ed9aa39232$var$key$1 in $df1132ed9aa39232$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($df1132ed9aa39232$var$key$1)) $df1132ed9aa39232$var$cache[$df1132ed9aa39232$var$computed[$df1132ed9aa39232$var$key$1]] = $df1132ed9aa39232$var$computed[$df1132ed9aa39232$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $df1132ed9aa39232$var$noPrefill.forEach(function(x) {
        return delete $df1132ed9aa39232$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $df1132ed9aa39232$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$df1132ed9aa39232$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($df1132ed9aa39232$var$cache[prop] != null) return $df1132ed9aa39232$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $df1132ed9aa39232$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $df1132ed9aa39232$var$propertyDetectors.length; i++){
        $df1132ed9aa39232$var$cache[prop] = $df1132ed9aa39232$var$propertyDetectors[i](prop, $df1132ed9aa39232$var$el.style, options); // Break loop, if value found.
        if ($df1132ed9aa39232$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $df1132ed9aa39232$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $df1132ed9aa39232$var$cache[prop];
}
var $df1132ed9aa39232$var$cache$1 = {};
var $df1132ed9aa39232$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $df1132ed9aa39232$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $df1132ed9aa39232$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $df1132ed9aa39232$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $df1132ed9aa39232$export$ce097f82c2e4551a(p1) : ", " + $df1132ed9aa39232$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $6HanM.default) $df1132ed9aa39232$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $df1132ed9aa39232$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$df1132ed9aa39232$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($df1132ed9aa39232$var$cache$1[cacheKey] != null) return $df1132ed9aa39232$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $df1132ed9aa39232$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $df1132ed9aa39232$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($df1132ed9aa39232$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($df1132ed9aa39232$var$transPropsRegExp, $df1132ed9aa39232$var$prefixTransitionCallback);
    else if ($df1132ed9aa39232$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $df1132ed9aa39232$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $df1132ed9aa39232$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $df1132ed9aa39232$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($df1132ed9aa39232$var$el$1.style[property] === "") {
            $df1132ed9aa39232$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $df1132ed9aa39232$var$el$1.style[property] = ""; // Write current value to cache.
    $df1132ed9aa39232$var$cache$1[cacheKey] = prefixedValue;
    return $df1132ed9aa39232$var$cache$1[cacheKey];
}

});
parcelRegister("78mMa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $531af28d3ac36668$export$2e2bcd8739ae039; });

var $1cONq = parcelRequire("1cONq");

var $ipJ3o = parcelRequire("ipJ3o");

var $lQb46 = parcelRequire("lQb46");

var $lp0hG = parcelRequire("lp0hG");
function $531af28d3ac36668$export$2e2bcd8739ae039(arr) {
    return (0, $1cONq.default)(arr) || (0, $ipJ3o.default)(arr) || (0, $lQb46.default)(arr) || (0, $lp0hG.default)();
}

});
parcelRegister("1cONq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e0e5084d8f1c2cf$export$2e2bcd8739ae039; });

var $ithFY = parcelRequire("ithFY");
function $0e0e5084d8f1c2cf$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $ithFY.default)(arr);
}

});
parcelRegister("ithFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d728a57dc063ca0f$export$2e2bcd8739ae039; });
function $d728a57dc063ca0f$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("ipJ3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67d82881484e2bd$export$2e2bcd8739ae039; });
function $d67d82881484e2bd$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("lQb46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $041a6fa38a37d9ea$export$2e2bcd8739ae039; });

var $ithFY = parcelRequire("ithFY");
function $041a6fa38a37d9ea$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $ithFY.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $ithFY.default)(o, minLen);
}

});

parcelRegister("lp0hG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f94c27302e9e0028$export$2e2bcd8739ae039; });
function $f94c27302e9e0028$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("fWEP2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9bbf0360de825ab$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $b9bbf0360de825ab$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $b9bbf0360de825ab$export$2e2bcd8739ae039 = $b9bbf0360de825ab$var$jssPropsSort;

});



parcelRegister("3WDhO", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $2df543527781f568$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $2df543527781f568$var$indexCounter = -1000000000;
function $2df543527781f568$export$a2647aa13413c947() {
    $2df543527781f568$var$indexCounter += 1;
    return $2df543527781f568$var$indexCounter;
}

});

parcelRegister("2dgeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c9642f204f73f1$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");
parcelRequire("6TQKm");

var $4PjiG = parcelRequire("4PjiG");

function $19c9642f204f73f1$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $8JsGL.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $4PjiG.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("4PjiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383ae57741c32961$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $6TQKm = parcelRequire("6TQKm");
function $383ae57741c32961$export$53b83ca8eaab0383(item) {
    return item && (0, $6TQKm.default)(item) === "object" && item.constructor === Object;
}
function $383ae57741c32961$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $8JsGL.default)({}, target) : target;
    if ($383ae57741c32961$export$53b83ca8eaab0383(target) && $383ae57741c32961$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($383ae57741c32961$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $383ae57741c32961$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("isuHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d702a7aaf5d7c14c$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $d702a7aaf5d7c14c$var$noopTheme = {};
var $d702a7aaf5d7c14c$export$2e2bcd8739ae039 = $d702a7aaf5d7c14c$var$noopTheme;

});


parcelRegister("7K7iU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a327eb22fe41e96$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $5a327eb22fe41e96$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("1M7cg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14afdb48a1e291ee$export$2e2bcd8739ae039; });

var $dQI1p = parcelRequire("dQI1p");
var $14afdb48a1e291ee$var$defaultTheme = (0, $dQI1p.default)();
var $14afdb48a1e291ee$export$2e2bcd8739ae039 = $14afdb48a1e291ee$var$defaultTheme;

});
parcelRegister("dQI1p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a15247801429aa1f$export$2e2bcd8739ae039; });
parcelRequire("hl9SO");

var $S2OIO = parcelRequire("S2OIO");

var $4PjiG = parcelRequire("4PjiG");

var $9JSBv = parcelRequire("9JSBv");

var $hViu8 = parcelRequire("hViu8");

var $1DZd5 = parcelRequire("1DZd5");

var $j6wQ0 = parcelRequire("j6wQ0");

var $9ssUm = parcelRequire("9ssUm");

var $dKwEw = parcelRequire("dKwEw");

var $2QKlP = parcelRequire("2QKlP");

var $fHk6u = parcelRequire("fHk6u");

var $gXiHA = parcelRequire("gXiHA");
function $a15247801429aa1f$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $S2OIO.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $1DZd5.default)(paletteInput);
    var breakpoints = (0, $9JSBv.default)(breakpointsInput);
    var spacing = (0, $2QKlP.default)(spacingInput);
    var muiTheme = (0, $4PjiG.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $hViu8.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $9ssUm.default),
        typography: (0, $j6wQ0.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $dKwEw.default),
        transitions: (0, $fHk6u.default),
        zIndex: (0, $gXiHA.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $4PjiG.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $a15247801429aa1f$var$warnedOnce = false;
function $a15247801429aa1f$export$c469355549431d9b() {
    return $a15247801429aa1f$var$createTheme.apply(void 0, arguments);
}
var $a15247801429aa1f$export$2e2bcd8739ae039 = $a15247801429aa1f$var$createTheme;

});
parcelRegister("hl9SO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9fc10638884d261$export$2e2bcd8739ae039; });

var $hi1AZ = parcelRequire("hi1AZ");
function $c9fc10638884d261$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $hi1AZ.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("9JSBv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7172ac3d1b5400d1$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");
var $7172ac3d1b5400d1$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $7172ac3d1b5400d1$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $S2OIO.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $7172ac3d1b5400d1$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$7172ac3d1b5400d1$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $7172ac3d1b5400d1$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $7172ac3d1b5400d1$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $7172ac3d1b5400d1$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$7172ac3d1b5400d1$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$7172ac3d1b5400d1$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $8JsGL.default)({
        keys: $7172ac3d1b5400d1$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("hViu8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c6194e25c28569$export$2e2bcd8739ae039; });

var $hl9SO = parcelRequire("hl9SO");

var $8JsGL = parcelRequire("8JsGL");
function $d0c6194e25c28569$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $8JsGL.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $8JsGL.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $hl9SO.default)({}, breakpoints.up("sm"), (0, $8JsGL.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $hl9SO.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $hl9SO.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("1DZd5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1328ea044188e4b4$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $4PjiG = parcelRequire("4PjiG");
var $l58xH = parcelRequire("l58xH");

var $bvjrA = parcelRequire("bvjrA");

var $3f225 = parcelRequire("3f225");

var $hegEM = parcelRequire("hegEM");

var $jOeSA = parcelRequire("jOeSA");

var $9HD00 = parcelRequire("9HD00");

var $zaRlE = parcelRequire("zaRlE");

var $cbNhd = parcelRequire("cbNhd");

var $krKBC = parcelRequire("krKBC");

var $a71XF = parcelRequire("a71XF");
var $1328ea044188e4b4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $bvjrA.default).white,
        default: (0, $3f225.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $1328ea044188e4b4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $bvjrA.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $3f225.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $bvjrA.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $1328ea044188e4b4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $a71XF.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $a71XF.darken)(intent.main, tonalOffsetDark);
    }
}
function $1328ea044188e4b4$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $hegEM.default)[300],
        main: (0, $hegEM.default)[500],
        dark: (0, $hegEM.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $jOeSA.default).A200,
        main: (0, $jOeSA.default).A400,
        dark: (0, $jOeSA.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $9HD00.default)[300],
        main: (0, $9HD00.default)[500],
        dark: (0, $9HD00.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $zaRlE.default)[300],
        main: (0, $zaRlE.default)[500],
        dark: (0, $zaRlE.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $cbNhd.default)[300],
        main: (0, $cbNhd.default)[500],
        dark: (0, $cbNhd.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $krKBC.default)[300],
        main: (0, $krKBC.default)[500],
        dark: (0, $krKBC.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $S2OIO.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $a71XF.getContrastRatio)(background, $1328ea044188e4b4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $1328ea044188e4b4$export$55ce6f3a06c59543.text.primary : $1328ea044188e4b4$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $8JsGL.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $l58xH.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $l58xH.default)(5, JSON.stringify(color.main)));
        $1328ea044188e4b4$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $1328ea044188e4b4$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $1328ea044188e4b4$export$55ce6f3a06c59543,
        light: $1328ea044188e4b4$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $4PjiG.default)((0, $8JsGL.default)({
        // A collection of common colors.
        common: (0, $bvjrA.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $3f225.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("l58xH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f590b0fcc8ce372f$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $f590b0fcc8ce372f$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("bvjrA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8601ac1e45c872a1$export$2e2bcd8739ae039; });
var $8601ac1e45c872a1$var$common = {
    black: "#000",
    white: "#fff"
};
var $8601ac1e45c872a1$export$2e2bcd8739ae039 = $8601ac1e45c872a1$var$common;

});

parcelRegister("3f225", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25c45979a6344894$export$2e2bcd8739ae039; });
var $25c45979a6344894$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $25c45979a6344894$export$2e2bcd8739ae039 = $25c45979a6344894$var$grey;

});

parcelRegister("hegEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8b0aa28aacc9507$export$2e2bcd8739ae039; });
var $c8b0aa28aacc9507$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $c8b0aa28aacc9507$export$2e2bcd8739ae039 = $c8b0aa28aacc9507$var$indigo;

});

parcelRegister("jOeSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6be3a95543c04a4$export$2e2bcd8739ae039; });
var $e6be3a95543c04a4$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $e6be3a95543c04a4$export$2e2bcd8739ae039 = $e6be3a95543c04a4$var$pink;

});

parcelRegister("9HD00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7106619daf9cdcc1$export$2e2bcd8739ae039; });
var $7106619daf9cdcc1$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $7106619daf9cdcc1$export$2e2bcd8739ae039 = $7106619daf9cdcc1$var$red;

});

parcelRegister("zaRlE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $069bb175d6f7a033$export$2e2bcd8739ae039; });
var $069bb175d6f7a033$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $069bb175d6f7a033$export$2e2bcd8739ae039 = $069bb175d6f7a033$var$orange;

});

parcelRegister("cbNhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dfcbc72c7fa0dd8$export$2e2bcd8739ae039; });
var $8dfcbc72c7fa0dd8$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $8dfcbc72c7fa0dd8$export$2e2bcd8739ae039 = $8dfcbc72c7fa0dd8$var$blue;

});

parcelRegister("krKBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee2a7b2bde2d91c7$export$2e2bcd8739ae039; });
var $ee2a7b2bde2d91c7$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ee2a7b2bde2d91c7$export$2e2bcd8739ae039 = $ee2a7b2bde2d91c7$var$green;

});

parcelRegister("a71XF", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $75cc1455462be5de$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $75cc1455462be5de$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $75cc1455462be5de$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $75cc1455462be5de$export$c0816ed86df316af; });
$parcel$export(module.exports, "alpha", function () { return $75cc1455462be5de$export$58f0f39f63f3cf42; });

var $l58xH = parcelRequire("l58xH");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $75cc1455462be5de$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $75cc1455462be5de$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $75cc1455462be5de$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $75cc1455462be5de$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $75cc1455462be5de$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $75cc1455462be5de$var$intToHex(n);
    }).join(""));
}
function $75cc1455462be5de$export$29fb7152bd3f781a(color) {
    color = $75cc1455462be5de$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $75cc1455462be5de$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $75cc1455462be5de$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $75cc1455462be5de$export$677b39864803984e($75cc1455462be5de$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $l58xH.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $75cc1455462be5de$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $75cc1455462be5de$export$d061e26956a60b0a(foreground, background) {
    var lumA = $75cc1455462be5de$export$c852d90bf7403b62(foreground);
    var lumB = $75cc1455462be5de$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $75cc1455462be5de$export$c852d90bf7403b62(color) {
    color = $75cc1455462be5de$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $75cc1455462be5de$export$677b39864803984e($75cc1455462be5de$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $75cc1455462be5de$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $75cc1455462be5de$export$c852d90bf7403b62(color) > 0.5 ? $75cc1455462be5de$export$4b073707ff63303(color, coefficient) : $75cc1455462be5de$export$c0816ed86df316af(color, coefficient);
}
var $75cc1455462be5de$var$warnedOnce = false;
function $75cc1455462be5de$export$cbea29d068a2e18f(color, value) {
    return $75cc1455462be5de$export$58f0f39f63f3cf42(color, value);
}
function $75cc1455462be5de$export$58f0f39f63f3cf42(color, value) {
    color = $75cc1455462be5de$export$677b39864803984e(color);
    value = $75cc1455462be5de$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $75cc1455462be5de$export$211a73f2b8c10ce4(color);
}
function $75cc1455462be5de$export$4b073707ff63303(color, coefficient) {
    color = $75cc1455462be5de$export$677b39864803984e(color);
    coefficient = $75cc1455462be5de$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $75cc1455462be5de$export$211a73f2b8c10ce4(color);
}
function $75cc1455462be5de$export$c0816ed86df316af(color, coefficient) {
    color = $75cc1455462be5de$export$677b39864803984e(color);
    coefficient = $75cc1455462be5de$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $75cc1455462be5de$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("j6wQ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de880cc87fe7a6c3$export$2e2bcd8739ae039; });

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $4PjiG = parcelRequire("4PjiG");
function $de880cc87fe7a6c3$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $de880cc87fe7a6c3$var$warnedOnce = false;
function $de880cc87fe7a6c3$var$roundWithDeprecationWarning(value) {
    return $de880cc87fe7a6c3$var$round(value);
}
var $de880cc87fe7a6c3$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $de880cc87fe7a6c3$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $de880cc87fe7a6c3$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $de880cc87fe7a6c3$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $S2OIO.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $8JsGL.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $de880cc87fe7a6c3$var$defaultFontFamily ? {
            letterSpacing: "".concat($de880cc87fe7a6c3$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $de880cc87fe7a6c3$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $de880cc87fe7a6c3$var$caseAllCaps)
    };
    return (0, $4PjiG.default)((0, $8JsGL.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $de880cc87fe7a6c3$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("9ssUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e2d2723e95769c0$export$2e2bcd8739ae039; });
var $6e2d2723e95769c0$var$shadowKeyUmbraOpacity = 0.2;
var $6e2d2723e95769c0$var$shadowKeyPenumbraOpacity = 0.14;
var $6e2d2723e95769c0$var$shadowAmbientShadowOpacity = 0.12;
function $6e2d2723e95769c0$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($6e2d2723e95769c0$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($6e2d2723e95769c0$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($6e2d2723e95769c0$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $6e2d2723e95769c0$var$shadows = [
    "none",
    $6e2d2723e95769c0$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $6e2d2723e95769c0$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $6e2d2723e95769c0$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $6e2d2723e95769c0$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $6e2d2723e95769c0$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $6e2d2723e95769c0$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $6e2d2723e95769c0$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $6e2d2723e95769c0$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $6e2d2723e95769c0$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $6e2d2723e95769c0$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $6e2d2723e95769c0$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $6e2d2723e95769c0$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $6e2d2723e95769c0$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $6e2d2723e95769c0$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $6e2d2723e95769c0$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $6e2d2723e95769c0$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $6e2d2723e95769c0$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $6e2d2723e95769c0$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $6e2d2723e95769c0$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $6e2d2723e95769c0$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $6e2d2723e95769c0$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $6e2d2723e95769c0$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $6e2d2723e95769c0$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $6e2d2723e95769c0$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $6e2d2723e95769c0$export$2e2bcd8739ae039 = $6e2d2723e95769c0$var$shadows;

});

parcelRegister("dKwEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a028e662ef16ac48$export$2e2bcd8739ae039; });
var $a028e662ef16ac48$var$shape = {
    borderRadius: 4
};
var $a028e662ef16ac48$export$2e2bcd8739ae039 = $a028e662ef16ac48$var$shape;

});

parcelRegister("2QKlP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2134646ee7b21dec$export$2e2bcd8739ae039; });

var $8vuAB = parcelRequire("8vuAB");
var $2134646ee7b21dec$var$warnOnce;
function $2134646ee7b21dec$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $8vuAB.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8vuAB", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $6318f262c9b6e18a$export$1def6f833384e3d1; });
$parcel$export(module.exports, "default", function () { return $6318f262c9b6e18a$export$2e2bcd8739ae039; });

var $kxLdw = parcelRequire("kxLdw");


var $eY8rZ = parcelRequire("eY8rZ");

var $j5QR6 = parcelRequire("j5QR6");

var $hjc6I = parcelRequire("hjc6I");
var $6318f262c9b6e18a$var$properties = {
    m: "margin",
    p: "padding"
};
var $6318f262c9b6e18a$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $6318f262c9b6e18a$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $6318f262c9b6e18a$var$getCssProperties = (0, $hjc6I.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($6318f262c9b6e18a$var$aliases[prop]) prop = $6318f262c9b6e18a$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $kxLdw.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $6318f262c9b6e18a$var$properties[a];
    var direction = $6318f262c9b6e18a$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $6318f262c9b6e18a$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $6318f262c9b6e18a$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $6318f262c9b6e18a$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $6318f262c9b6e18a$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $6318f262c9b6e18a$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $6318f262c9b6e18a$var$spacing(props) {
    var theme = props.theme;
    var transformer = $6318f262c9b6e18a$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($6318f262c9b6e18a$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $6318f262c9b6e18a$var$getCssProperties(prop);
        var styleFromPropValue = $6318f262c9b6e18a$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $eY8rZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $j5QR6.default), {});
}
$6318f262c9b6e18a$var$spacing.propTypes = {};
$6318f262c9b6e18a$var$spacing.filterProps = $6318f262c9b6e18a$var$spacingKeys;
var $6318f262c9b6e18a$export$2e2bcd8739ae039 = $6318f262c9b6e18a$var$spacing;

});
parcelRegister("kxLdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef4b840fc04f6ade$export$2e2bcd8739ae039; });

var $kMCwM = parcelRequire("kMCwM");

var $bdOHi = parcelRequire("bdOHi");

var $lQb46 = parcelRequire("lQb46");

var $fjGYj = parcelRequire("fjGYj");
function $ef4b840fc04f6ade$export$2e2bcd8739ae039(arr, i) {
    return (0, $kMCwM.default)(arr) || (0, $bdOHi.default)(arr, i) || (0, $lQb46.default)(arr, i) || (0, $fjGYj.default)();
}

});
parcelRegister("kMCwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2162d29e0b60ac8$export$2e2bcd8739ae039; });
function $f2162d29e0b60ac8$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("bdOHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82b83c097d1fb25b$export$2e2bcd8739ae039; });
function $82b83c097d1fb25b$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("fjGYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b269f6ad74adeff2$export$2e2bcd8739ae039; });
function $b269f6ad74adeff2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eY8rZ", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $ae5d395b3a2c55f0$export$88347efdb2e19abd; });

var $78mMa = parcelRequire("78mMa");

var $8JsGL = parcelRequire("8JsGL");

var $6TQKm = parcelRequire("6TQKm");


var $j5QR6 = parcelRequire("j5QR6");
// For instance with the first breakpoint xs: [xs, sm[.
var $ae5d395b3a2c55f0$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $ae5d395b3a2c55f0$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($ae5d395b3a2c55f0$var$values[key], "px)");
    }
};
function $ae5d395b3a2c55f0$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $ae5d395b3a2c55f0$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $6TQKm.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $ae5d395b3a2c55f0$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $ae5d395b3a2c55f0$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $ae5d395b3a2c55f0$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8JsGL.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $j5QR6.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $78mMa.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $ae5d395b3a2c55f0$export$2e2bcd8739ae039 = $ae5d395b3a2c55f0$var$breakpoints;

});
parcelRegister("j5QR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de677bf78df88fcb$export$2e2bcd8739ae039; });

var $4PjiG = parcelRequire("4PjiG");
function $de677bf78df88fcb$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $4PjiG.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $de677bf78df88fcb$export$2e2bcd8739ae039 = $de677bf78df88fcb$var$merge;

});


parcelRegister("hjc6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99d9a413e3b076e$export$2e2bcd8739ae039; });
function $c99d9a413e3b076e$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("fHk6u", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $b6da77546b9fef3d$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $b6da77546b9fef3d$export$2e2bcd8739ae039; });

var $S2OIO = parcelRequire("S2OIO");
var $b6da77546b9fef3d$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $b6da77546b9fef3d$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b6da77546b9fef3d$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $b6da77546b9fef3d$export$2e2bcd8739ae039 = {
    easing: $b6da77546b9fef3d$export$24c5ac7c37452e7d,
    duration: $b6da77546b9fef3d$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $b6da77546b9fef3d$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $b6da77546b9fef3d$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $S2OIO.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $b6da77546b9fef3d$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $b6da77546b9fef3d$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("gXiHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c580a9d5a3d1f2ba$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $c580a9d5a3d1f2ba$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c580a9d5a3d1f2ba$export$2e2bcd8739ae039 = $c580a9d5a3d1f2ba$var$zIndex;

});




parcelRegister("f0yL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aed1d171a90e65f8$export$2e2bcd8739ae039; });

var $l58xH = parcelRequire("l58xH");
function $aed1d171a90e65f8$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $l58xH.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




var $2bbb5df1d77a4f15$exports = {};
"use strict";

$2bbb5df1d77a4f15$exports = (parcelRequire("hRi0x"));



var $5KQk5 = parcelRequire("5KQk5");
var $e2b5c52bb63103a5$exports = {};
"use strict";
function $e2b5c52bb63103a5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e2b5c52bb63103a5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e2b5c52bb63103a5$var$checkDCE();

$e2b5c52bb63103a5$exports = (parcelRequire("aM9lk"));





var $5KQk5 = parcelRequire("5KQk5");


var $5KQk5 = parcelRequire("5KQk5");

var $hl9SO = parcelRequire("hl9SO");


var $eY8rZ = parcelRequire("eY8rZ");
function $9ac1c45c40bf79e3$var$getPath(obj, path) {
    if (!path || typeof path !== "string") return null;
    return path.split(".").reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $9ac1c45c40bf79e3$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $9ac1c45c40bf79e3$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $9ac1c45c40bf79e3$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $hl9SO.default)({}, cssProperty, value);
        };
        return (0, $eY8rZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9ac1c45c40bf79e3$export$2e2bcd8739ae039 = $9ac1c45c40bf79e3$var$style;


parcelRequire("8JsGL");

var $j5QR6 = parcelRequire("j5QR6");
function $473e1eca410e79a6$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $j5QR6.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $473e1eca410e79a6$export$2e2bcd8739ae039 = $473e1eca410e79a6$var$compose;


function $43944009366f689e$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return "".concat(value, "px solid");
}
var $43944009366f689e$export$1edee58a52776cd9 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $43944009366f689e$var$getBorder
});
var $43944009366f689e$export$f9a7b6bd24892946 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $43944009366f689e$var$getBorder
});
var $43944009366f689e$export$5abca33e6be905d2 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $43944009366f689e$var$getBorder
});
var $43944009366f689e$export$e2ce9f12a980a822 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $43944009366f689e$var$getBorder
});
var $43944009366f689e$export$47658cca1a909427 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $43944009366f689e$var$getBorder
});
var $43944009366f689e$export$e7fb0694ba2404fc = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
var $43944009366f689e$export$7a57f79000377ca2 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "borderRadius",
    themeKey: "shape"
});
var $43944009366f689e$var$borders = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($43944009366f689e$export$1edee58a52776cd9, $43944009366f689e$export$f9a7b6bd24892946, $43944009366f689e$export$5abca33e6be905d2, $43944009366f689e$export$e2ce9f12a980a822, $43944009366f689e$export$47658cca1a909427, $43944009366f689e$export$e7fb0694ba2404fc, $43944009366f689e$export$7a57f79000377ca2);
var $43944009366f689e$export$2e2bcd8739ae039 = $43944009366f689e$var$borders;



var $b49a28320edfbb74$export$95a5c40fb210fe3e = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "displayPrint",
    cssProperty: false,
    transform: function transform(value) {
        return {
            "@media print": {
                display: value
            }
        };
    }
});
var $b49a28320edfbb74$export$e5efd59aba9975ad = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "display"
});
var $b49a28320edfbb74$export$f6530fb6e67e00bd = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "overflow"
});
var $b49a28320edfbb74$export$f00f69a6f0e8c5b6 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "textOverflow"
});
var $b49a28320edfbb74$export$91fa9ac3f4021ce4 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "visibility"
});
var $b49a28320edfbb74$export$9ef81298ca34ad41 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "whiteSpace"
});
var $b49a28320edfbb74$export$2e2bcd8739ae039 = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($b49a28320edfbb74$export$95a5c40fb210fe3e, $b49a28320edfbb74$export$e5efd59aba9975ad, $b49a28320edfbb74$export$f6530fb6e67e00bd, $b49a28320edfbb74$export$f00f69a6f0e8c5b6, $b49a28320edfbb74$export$91fa9ac3f4021ce4, $b49a28320edfbb74$export$9ef81298ca34ad41);



var $66f71ac85a98dce2$export$d2ad290394bbc49d = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flexBasis"
});
var $66f71ac85a98dce2$export$84c3c16c9ed6c908 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flexDirection"
});
var $66f71ac85a98dce2$export$9a4bcd01f5c204bc = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flexWrap"
});
var $66f71ac85a98dce2$export$8dea3061ba53bfd1 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "justifyContent"
});
var $66f71ac85a98dce2$export$898d9006406726bd = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "alignItems"
});
var $66f71ac85a98dce2$export$38c32c6918694134 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "alignContent"
});
var $66f71ac85a98dce2$export$aaaeab0fac9a3ccb = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "order"
});
var $66f71ac85a98dce2$export$97691fbb80847c19 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flex"
});
var $66f71ac85a98dce2$export$36c65c169152373d = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flexGrow"
});
var $66f71ac85a98dce2$export$2670ac60b02109d2 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "flexShrink"
});
var $66f71ac85a98dce2$export$4545dd3632cb520b = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "alignSelf"
});
var $66f71ac85a98dce2$export$55e6b7a7f0eaa3ff = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "justifyItems"
});
var $66f71ac85a98dce2$export$d012640ac9a6446f = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "justifySelf"
});
var $66f71ac85a98dce2$var$flexbox = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($66f71ac85a98dce2$export$d2ad290394bbc49d, $66f71ac85a98dce2$export$84c3c16c9ed6c908, $66f71ac85a98dce2$export$9a4bcd01f5c204bc, $66f71ac85a98dce2$export$8dea3061ba53bfd1, $66f71ac85a98dce2$export$898d9006406726bd, $66f71ac85a98dce2$export$38c32c6918694134, $66f71ac85a98dce2$export$aaaeab0fac9a3ccb, $66f71ac85a98dce2$export$97691fbb80847c19, $66f71ac85a98dce2$export$36c65c169152373d, $66f71ac85a98dce2$export$2670ac60b02109d2, $66f71ac85a98dce2$export$4545dd3632cb520b, $66f71ac85a98dce2$export$55e6b7a7f0eaa3ff, $66f71ac85a98dce2$export$d012640ac9a6446f);
var $66f71ac85a98dce2$export$2e2bcd8739ae039 = $66f71ac85a98dce2$var$flexbox;



var $d8dd05f5f61c464c$export$62ffeaf1cd78b2a6 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridGap"
});
var $d8dd05f5f61c464c$export$d6171c086ca0de0 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridColumnGap"
});
var $d8dd05f5f61c464c$export$8bb113508eaa54d = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridRowGap"
});
var $d8dd05f5f61c464c$export$baf44164ca3a34e8 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
var $d8dd05f5f61c464c$export$8f7213a1cd01e832 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
var $d8dd05f5f61c464c$export$b0e0abbc49ba668 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
var $d8dd05f5f61c464c$export$bcd8b929d4b4142 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
var $d8dd05f5f61c464c$export$e5039a674e14c828 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
var $d8dd05f5f61c464c$export$42bd9088661ffb03 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
var $d8dd05f5f61c464c$export$920682ae05b999bc = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
var $d8dd05f5f61c464c$export$1b88fbdd482fd33a = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
var $d8dd05f5f61c464c$export$bdb486e40d52d26f = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
var $d8dd05f5f61c464c$var$grid = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($d8dd05f5f61c464c$export$62ffeaf1cd78b2a6, $d8dd05f5f61c464c$export$d6171c086ca0de0, $d8dd05f5f61c464c$export$8bb113508eaa54d, $d8dd05f5f61c464c$export$baf44164ca3a34e8, $d8dd05f5f61c464c$export$8f7213a1cd01e832, $d8dd05f5f61c464c$export$b0e0abbc49ba668, $d8dd05f5f61c464c$export$bcd8b929d4b4142, $d8dd05f5f61c464c$export$e5039a674e14c828, $d8dd05f5f61c464c$export$42bd9088661ffb03, $d8dd05f5f61c464c$export$920682ae05b999bc, $d8dd05f5f61c464c$export$1b88fbdd482fd33a, $d8dd05f5f61c464c$export$bdb486e40d52d26f);
var $d8dd05f5f61c464c$export$2e2bcd8739ae039 = $d8dd05f5f61c464c$var$grid;



var $8744d17a9ad2a149$export$35e9368ef982300f = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette"
});
var $8744d17a9ad2a149$export$2506f56c10355b33 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
var $8744d17a9ad2a149$var$palette = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($8744d17a9ad2a149$export$35e9368ef982300f, $8744d17a9ad2a149$export$2506f56c10355b33);
var $8744d17a9ad2a149$export$2e2bcd8739ae039 = $8744d17a9ad2a149$var$palette;



var $77b4aac810dc5ffe$export$5880b8b5730aff45 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "position"
});
var $77b4aac810dc5ffe$export$56446adcecbeec34 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "zIndex",
    themeKey: "zIndex"
});
var $77b4aac810dc5ffe$export$1e95b668f3b82d = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "top"
});
var $77b4aac810dc5ffe$export$79ffe56a765070d2 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "right"
});
var $77b4aac810dc5ffe$export$40e543e69a8b3fbb = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "bottom"
});
var $77b4aac810dc5ffe$export$eabcd2c8791e7bf4 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "left"
});
var $77b4aac810dc5ffe$export$2e2bcd8739ae039 = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($77b4aac810dc5ffe$export$5880b8b5730aff45, $77b4aac810dc5ffe$export$56446adcecbeec34, $77b4aac810dc5ffe$export$1e95b668f3b82d, $77b4aac810dc5ffe$export$79ffe56a765070d2, $77b4aac810dc5ffe$export$40e543e69a8b3fbb, $77b4aac810dc5ffe$export$eabcd2c8791e7bf4);


var $fa2726c4aee226cd$var$boxShadow = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $fa2726c4aee226cd$export$2e2bcd8739ae039 = $fa2726c4aee226cd$var$boxShadow;



function $7666ea749addf979$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $7666ea749addf979$export$7e3df82ee760448c = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$488fda99655ff65a = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "maxWidth",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$ee148fbbe8357dd2 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$ac607276a8fe9f0a = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$dc0d8bd0b94f8570 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$a43cf604e12f3b17 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$ffed9f14fb65e276 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$905076ed6620e671 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $7666ea749addf979$var$transform
});
var $7666ea749addf979$export$6ccc93f785106a58 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
var $7666ea749addf979$var$sizing = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($7666ea749addf979$export$7e3df82ee760448c, $7666ea749addf979$export$488fda99655ff65a, $7666ea749addf979$export$ee148fbbe8357dd2, $7666ea749addf979$export$ac607276a8fe9f0a, $7666ea749addf979$export$dc0d8bd0b94f8570, $7666ea749addf979$export$a43cf604e12f3b17, $7666ea749addf979$export$6ccc93f785106a58);
var $7666ea749addf979$export$2e2bcd8739ae039 = $7666ea749addf979$var$sizing;


var $8vuAB = parcelRequire("8vuAB");
var $78mMa = parcelRequire("78mMa");

var $8JsGL = parcelRequire("8JsGL");



var $j5QR6 = parcelRequire("j5QR6");
function $73f294fe98f3d77a$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $73f294fe98f3d77a$var$warnedOnce = false;
function $73f294fe98f3d77a$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $8JsGL.default)({}, (0, $j5QR6.default)(output, styleFunction((0, $8JsGL.default)({
            theme: props.theme
        }, props.css))), $73f294fe98f3d77a$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $8JsGL.default)({}, (0, $j5QR6.default)(output, styleFunction((0, $8JsGL.default)({
            theme: props.theme
        }, props.sx))), $73f294fe98f3d77a$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "css",
        "sx"
    ].concat((0, $78mMa.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $73f294fe98f3d77a$export$dbf350e5966cf602(styleFunction) {
    return $73f294fe98f3d77a$var$styleFunctionSx(styleFunction);
}
var $73f294fe98f3d77a$export$2e2bcd8739ae039 = $73f294fe98f3d77a$var$styleFunctionSx;



var $9c9cf292c3ecb2b2$export$a5975749f0374264 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "fontFamily",
    themeKey: "typography"
});
var $9c9cf292c3ecb2b2$export$85e3c3ca0c6fb93 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "fontSize",
    themeKey: "typography"
});
var $9c9cf292c3ecb2b2$export$a827189a08c5a3a3 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "fontStyle",
    themeKey: "typography"
});
var $9c9cf292c3ecb2b2$export$bc0b29e67df3229e = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "fontWeight",
    themeKey: "typography"
});
var $9c9cf292c3ecb2b2$export$3eb52878e4502ad1 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "letterSpacing"
});
var $9c9cf292c3ecb2b2$export$c9b91427b594e14 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "lineHeight"
});
var $9c9cf292c3ecb2b2$export$a87999391cd10ae9 = (0, $9ac1c45c40bf79e3$export$2e2bcd8739ae039)({
    prop: "textAlign"
});
var $9c9cf292c3ecb2b2$var$typography = (0, $473e1eca410e79a6$export$2e2bcd8739ae039)($9c9cf292c3ecb2b2$export$a5975749f0374264, $9c9cf292c3ecb2b2$export$85e3c3ca0c6fb93, $9c9cf292c3ecb2b2$export$a827189a08c5a3a3, $9c9cf292c3ecb2b2$export$bc0b29e67df3229e, $9c9cf292c3ecb2b2$export$3eb52878e4502ad1, $9c9cf292c3ecb2b2$export$c9b91427b594e14, $9c9cf292c3ecb2b2$export$a87999391cd10ae9);
var $9c9cf292c3ecb2b2$export$2e2bcd8739ae039 = $9c9cf292c3ecb2b2$var$typography;



var $8JsGL = parcelRequire("8JsGL");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");

var $6479q = parcelRequire("6479q");



var $dPh4j = parcelRequire("dPh4j");

var $jeCqG = parcelRequire("jeCqG");
function $c2c327273b59dc48$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $c2c327273b59dc48$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $S2OIO.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === "function" ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $8JsGL.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $jeCqG.default)(stylesOrCreator, (0, $8JsGL.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $S2OIO.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $6479q.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $c2c327273b59dc48$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).cloneElement(children, (0, $8JsGL.default)({
                className: (0, $6479q.default)(children.props.className, className)
            }, spread));
            if (typeof children === "function") return children((0, $8JsGL.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement(FinalComponent, (0, $8JsGL.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($dPh4j)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}



var $1M7cg = parcelRequire("1M7cg");
var $765e7d386fafcb57$var$styled = function styled(Component) {
    var componentCreator = (0, $c2c327273b59dc48$export$2e2bcd8739ae039)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $8JsGL.default)({
            defaultTheme: (0, $1M7cg.default)
        }, options));
    };
};
var $765e7d386fafcb57$export$2e2bcd8739ae039 = $765e7d386fafcb57$var$styled;


var $a2b48df6c47c4d4e$export$8b4cd039ebcc4f7b = (0, $73f294fe98f3d77a$export$2e2bcd8739ae039)((0, $473e1eca410e79a6$export$2e2bcd8739ae039)((0, $43944009366f689e$export$2e2bcd8739ae039), (0, $b49a28320edfbb74$export$2e2bcd8739ae039), (0, $66f71ac85a98dce2$export$2e2bcd8739ae039), (0, $d8dd05f5f61c464c$export$2e2bcd8739ae039), (0, $77b4aac810dc5ffe$export$2e2bcd8739ae039), (0, $8744d17a9ad2a149$export$2e2bcd8739ae039), (0, $fa2726c4aee226cd$export$2e2bcd8739ae039), (0, $7666ea749addf979$export$2e2bcd8739ae039), (0, $8vuAB.default), (0, $9c9cf292c3ecb2b2$export$2e2bcd8739ae039)));
/**
 * @ignore - do not document.
 */ var $a2b48df6c47c4d4e$var$Box = (0, $765e7d386fafcb57$export$2e2bcd8739ae039)("div")($a2b48df6c47c4d4e$export$8b4cd039ebcc4f7b, {
    name: "MuiBox"
});
var $a2b48df6c47c4d4e$export$2e2bcd8739ae039 = $a2b48df6c47c4d4e$var$Box;


var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $a71XF = parcelRequire("a71XF");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");



var $6479q = parcelRequire("6479q");


var $5KQk5 = parcelRequire("5KQk5");
// TODO v5: consider to make it private
function $24091f3ce5aeac5d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $5KQk5.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $24091f3ce5aeac5d$export$2e2bcd8739ae039)(refA, refValue);
            (0, $24091f3ce5aeac5d$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $5KQk5 = parcelRequire("5KQk5");
var $46d218e63f6df27d$var$useEnhancedEffect = typeof window !== "undefined" ? $5KQk5.useLayoutEffect : $5KQk5.useEffect;
function $46d218e63f6df27d$export$2e2bcd8739ae039(fn) {
    var ref = $5KQk5.useRef(fn);
    $46d218e63f6df27d$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $5KQk5.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




var $3VtpS = parcelRequire("3VtpS");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $5KQk5 = parcelRequire("5KQk5");

var $f98315cbbd304e7b$var$hadKeyboardEvent = true;
var $f98315cbbd304e7b$var$hadFocusVisibleRecently = false;
var $f98315cbbd304e7b$var$hadFocusVisibleRecentlyTimeout = null;
var $f98315cbbd304e7b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $f98315cbbd304e7b$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $f98315cbbd304e7b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $f98315cbbd304e7b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $f98315cbbd304e7b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $f98315cbbd304e7b$var$handlePointerDown() {
    $f98315cbbd304e7b$var$hadKeyboardEvent = false;
}
function $f98315cbbd304e7b$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($f98315cbbd304e7b$var$hadFocusVisibleRecently) $f98315cbbd304e7b$var$hadKeyboardEvent = true;
    }
}
function $f98315cbbd304e7b$var$prepare(doc) {
    doc.addEventListener("keydown", $f98315cbbd304e7b$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $f98315cbbd304e7b$var$handleVisibilityChange, true);
}
function $f98315cbbd304e7b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $f98315cbbd304e7b$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $f98315cbbd304e7b$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $f98315cbbd304e7b$var$handleVisibilityChange, true);
}
function $f98315cbbd304e7b$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $f98315cbbd304e7b$var$hadKeyboardEvent || $f98315cbbd304e7b$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $f98315cbbd304e7b$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $f98315cbbd304e7b$var$hadFocusVisibleRecently = true;
    window.clearTimeout($f98315cbbd304e7b$var$hadFocusVisibleRecentlyTimeout);
    $f98315cbbd304e7b$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $f98315cbbd304e7b$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $f98315cbbd304e7b$export$2e2bcd8739ae039() {
    var ref = $5KQk5.useCallback(function(instance) {
        var node = $e2b5c52bb63103a5$exports.findDOMNode(instance);
        if (node != null) $f98315cbbd304e7b$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $f98315cbbd304e7b$var$isFocusVisible,
        onBlurVisible: $f98315cbbd304e7b$var$handleBlurVisible,
        ref: ref
    };
}



var $8JsGL = parcelRequire("8JsGL");

var $78mMa = parcelRequire("78mMa");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $4gGez = parcelRequire("4gGez");

var $8JsGL = parcelRequire("8JsGL");

var $drIlR = parcelRequire("drIlR");

var $5WgVA = parcelRequire("5WgVA");


var $5KQk5 = parcelRequire("5KQk5");

var $5KQk5 = parcelRequire("5KQk5");
var $8e8fc7200a3822e0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createContext(null);



var $5KQk5 = parcelRequire("5KQk5");
function $34059e5433752462$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $5KQk5.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $5KQk5.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $34059e5433752462$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $34059e5433752462$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $34059e5433752462$export$fa71e2345c31d7a2(props, onExited) {
    return $34059e5433752462$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $5KQk5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $34059e5433752462$var$getProp(child, "appear", props),
            enter: $34059e5433752462$var$getProp(child, "enter", props),
            exit: $34059e5433752462$var$getProp(child, "exit", props)
        });
    });
}
function $34059e5433752462$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $34059e5433752462$export$bbc8a025727ea824(nextProps.children);
    var children = $34059e5433752462$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $5KQk5.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $5KQk5.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $5KQk5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $34059e5433752462$var$getProp(child, "exit", nextProps),
            enter: $34059e5433752462$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $5KQk5.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $5KQk5.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $5KQk5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $34059e5433752462$var$getProp(child, "exit", nextProps),
            enter: $34059e5433752462$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $0ccb88b636fdc8e4$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $0ccb88b636fdc8e4$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $0ccb88b636fdc8e4$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $5WgVA.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $drIlR.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $34059e5433752462$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $34059e5433752462$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $34059e5433752462$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8JsGL.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4gGez.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $0ccb88b636fdc8e4$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement((0, $8e8fc7200a3822e0$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement((0, $8e8fc7200a3822e0$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).Component);
$0ccb88b636fdc8e4$var$TransitionGroup.propTypes = {};
$0ccb88b636fdc8e4$var$TransitionGroup.defaultProps = $0ccb88b636fdc8e4$var$defaultProps;
var $0ccb88b636fdc8e4$export$2e2bcd8739ae039 = $0ccb88b636fdc8e4$var$TransitionGroup;



var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $9b16b026d4156ed2$var$useEnhancedEffect = typeof window === "undefined" ? $5KQk5.useEffect : $5KQk5.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $9b16b026d4156ed2$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $5KQk5.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $6479q.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $6479q.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $9b16b026d4156ed2$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $5KQk5.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $5KQk5.createElement("span", {
        className: childClassName
    }));
}
var $9b16b026d4156ed2$export$2e2bcd8739ae039 = $9b16b026d4156ed2$var$Ripple;


var $5fab0e5838e7948e$var$DURATION = 550;
var $5fab0e5838e7948e$export$95d0c9356b2231a3 = 80;
var $5fab0e5838e7948e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($5fab0e5838e7948e$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($5fab0e5838e7948e$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $5fab0e5838e7948e$var$TouchRipple = /*#__PURE__*/ $5KQk5.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $S2OIO.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $5KQk5.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $5KQk5.useRef(0);
    var rippleCallback = $5KQk5.useRef(null);
    $5KQk5.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $5KQk5.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $5KQk5.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $5KQk5.useRef(null);
    var container = $5KQk5.useRef(null);
    $5KQk5.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $5KQk5.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $78mMa.default)(oldRipples), [
                /*#__PURE__*/ $5KQk5.createElement((0, $9b16b026d4156ed2$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $5fab0e5838e7948e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $5KQk5.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $5fab0e5838e7948e$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $5KQk5.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $5KQk5.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $5KQk5.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $5KQk5.createElement("span", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $5KQk5.createElement((0, $0ccb88b636fdc8e4$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $5fab0e5838e7948e$export$2e2bcd8739ae039 = (0, $3VtpS.default)($5fab0e5838e7948e$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $5KQk5.memo($5fab0e5838e7948e$var$TouchRipple));


var $b84a8edbcc74a2d5$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $b84a8edbcc74a2d5$var$ButtonBase = /*#__PURE__*/ $5KQk5.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $S2OIO.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $5KQk5.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $e2b5c52bb63103a5$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $5KQk5.useRef(null);
    var _React$useState = $5KQk5.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $f98315cbbd304e7b$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $5KQk5.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $5KQk5.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $5KQk5.useRef(false);
    var handleKeyDown = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $5KQk5.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $5KQk5.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $5KQk5.createElement(ComponentProp, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $5KQk5.createElement((0, $5fab0e5838e7948e$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $b84a8edbcc74a2d5$export$2e2bcd8739ae039 = (0, $3VtpS.default)($b84a8edbcc74a2d5$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($b84a8edbcc74a2d5$var$ButtonBase);



var $f0yL6 = parcelRequire("f0yL6");
var $64a3ea796db72b22$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $a71XF.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $a71XF.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $a71XF.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $a71XF.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $a71XF.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $a71XF.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $a71XF.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $64a3ea796db72b22$var$Button = /*#__PURE__*/ $5KQk5.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $5KQk5.createElement("span", {
        className: (0, $6479q.default)(classes.startIcon, classes["iconSize".concat((0, $f0yL6.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $5KQk5.createElement("span", {
        className: (0, $6479q.default)(classes.endIcon, classes["iconSize".concat((0, $f0yL6.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $5KQk5.createElement((0, $b84a8edbcc74a2d5$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $f0yL6.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $f0yL6.default)(size))],
            classes["size".concat((0, $f0yL6.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $6479q.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $5KQk5.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $64a3ea796db72b22$export$2e2bcd8739ae039 = (0, $3VtpS.default)($64a3ea796db72b22$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($64a3ea796db72b22$var$Button);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $8JsGL = parcelRequire("8JsGL");

var $kxLdw = parcelRequire("kxLdw");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $5KQk5 = parcelRequire("5KQk5");
function $7f281b404a381908$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $5KQk5.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $5KQk5.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $5KQk5.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}



var $5KQk5 = parcelRequire("5KQk5");

var $5KQk5 = parcelRequire("5KQk5");
/**
 * @ignore - internal component.
 */ var $5ab65735480eac70$var$FormControlContext = $5KQk5.createContext();
function $5ab65735480eac70$export$62ecd8ad1bbe1a18() {
    return $5KQk5.useContext($5ab65735480eac70$var$FormControlContext);
}
var $5ab65735480eac70$export$2e2bcd8739ae039 = $5ab65735480eac70$var$FormControlContext;


function $48c8af55c97bfee8$export$2e2bcd8739ae039() {
    return $5KQk5.useContext((0, $5ab65735480eac70$export$2e2bcd8739ae039));
}



var $3VtpS = parcelRequire("3VtpS");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");

var $a71XF = parcelRequire("a71XF");


var $f0yL6 = parcelRequire("f0yL6");
var $2716d8fe3b58de60$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $a71XF.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $a71XF.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $a71XF.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $2716d8fe3b58de60$var$IconButton = /*#__PURE__*/ $5KQk5.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $S2OIO.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $b84a8edbcc74a2d5$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, color !== "default" && classes["color".concat((0, $f0yL6.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $f0yL6.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.createElement("span", {
        className: classes.label
    }, children));
});
var $2716d8fe3b58de60$export$2e2bcd8739ae039 = (0, $3VtpS.default)($2716d8fe3b58de60$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($2716d8fe3b58de60$var$IconButton);


var $5a9c8b65bb61c596$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: "inherit",
        position: "absolute",
        opacity: 0,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $5a9c8b65bb61c596$var$SwitchBase = /*#__PURE__*/ $5KQk5.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $S2OIO.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $7f281b404a381908$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    }), _useControlled2 = (0, $kxLdw.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === "checkbox" || type === "radio";
    return /*#__PURE__*/ $5KQk5.createElement((0, $2716d8fe3b58de60$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        component: "span",
        className: (0, $6479q.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.createElement("input", (0, $8JsGL.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $5a9c8b65bb61c596$export$2e2bcd8739ae039 = (0, $3VtpS.default)($5a9c8b65bb61c596$export$9dd6ff9ea0189349, {
    name: "PrivateSwitchBase"
})($5a9c8b65bb61c596$var$SwitchBase);



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $d20aa10908e16892$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $b0ab6d85c1290278$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");



var $a71XF = parcelRequire("a71XF");

var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $0d862ba5ceb9de62$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $f0yL6 = parcelRequire("f0yL6");

var $3VtpS = parcelRequire("3VtpS");
var $44aa916fa0ed7c8d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $a71XF.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $a71XF.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $44aa916fa0ed7c8d$var$defaultCheckedIcon = /*#__PURE__*/ $5KQk5.createElement((0, $b0ab6d85c1290278$export$2e2bcd8739ae039), null);
var $44aa916fa0ed7c8d$var$defaultIcon = /*#__PURE__*/ $5KQk5.createElement((0, $d20aa10908e16892$export$2e2bcd8739ae039), null);
var $44aa916fa0ed7c8d$var$defaultIndeterminateIcon = /*#__PURE__*/ $5KQk5.createElement((0, $0d862ba5ceb9de62$export$2e2bcd8739ae039), null);
var $44aa916fa0ed7c8d$var$Checkbox = /*#__PURE__*/ $5KQk5.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $44aa916fa0ed7c8d$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $44aa916fa0ed7c8d$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $44aa916fa0ed7c8d$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $S2OIO.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $5KQk5.createElement((0, $5a9c8b65bb61c596$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        type: "checkbox",
        classes: {
            root: (0, $6479q.default)(classes.root, classes["color".concat((0, $f0yL6.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $8JsGL.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $5KQk5.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $5KQk5.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $44aa916fa0ed7c8d$export$2e2bcd8739ae039 = (0, $3VtpS.default)($44aa916fa0ed7c8d$export$9dd6ff9ea0189349, {
    name: "MuiCheckbox"
})($44aa916fa0ed7c8d$var$Checkbox);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $hl9SO = parcelRequire("hl9SO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $f0yL6 = parcelRequire("f0yL6");
var $fbeaa9276e0ae0d4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $hl9SO.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            display: "block"
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `disableGutters={true}`. */ disableGutters: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /* Styles applied to the root element if `fixed={true}`. */ fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: value
            };
            return acc;
        }, {}),
        /* Styles applied to the root element if `maxWidth="xs"`. */ maxWidthXs: (0, $hl9SO.default)({}, theme.breakpoints.up("xs"), {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }),
        /* Styles applied to the root element if `maxWidth="sm"`. */ maxWidthSm: (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), {
            maxWidth: theme.breakpoints.values.sm
        }),
        /* Styles applied to the root element if `maxWidth="md"`. */ maxWidthMd: (0, $hl9SO.default)({}, theme.breakpoints.up("md"), {
            maxWidth: theme.breakpoints.values.md
        }),
        /* Styles applied to the root element if `maxWidth="lg"`. */ maxWidthLg: (0, $hl9SO.default)({}, theme.breakpoints.up("lg"), {
            maxWidth: theme.breakpoints.values.lg
        }),
        /* Styles applied to the root element if `maxWidth="xl"`. */ maxWidthXl: (0, $hl9SO.default)({}, theme.breakpoints.up("xl"), {
            maxWidth: theme.breakpoints.values.xl
        })
    };
};
var $fbeaa9276e0ae0d4$var$Container = /*#__PURE__*/ $5KQk5.forwardRef(function Container(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "lg" : _props$maxWidth, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "fixed",
        "maxWidth"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, $f0yL6.default)(String(maxWidth)))]),
        ref: ref
    }, other));
});
var $fbeaa9276e0ae0d4$export$2e2bcd8739ae039 = (0, $3VtpS.default)($fbeaa9276e0ae0d4$export$9dd6ff9ea0189349, {
    name: "MuiContainer"
})($fbeaa9276e0ae0d4$var$Container);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $55f33bfc76d27e8b$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $55f33bfc76d27e8b$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($55f33bfc76d27e8b$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $55f33bfc76d27e8b$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $55f33bfc76d27e8b$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $3VtpS = parcelRequire("3VtpS");

var $f0yL6 = parcelRequire("f0yL6");

var $5KQk5 = parcelRequire("5KQk5");
function $3b05a7d7a92017fb$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $5KQk5.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}



var $58a2c7b423f74ed4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $58a2c7b423f74ed4$var$FormControl = /*#__PURE__*/ $5KQk5.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $5KQk5.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $5KQk5.Children.forEach(children, function(child) {
            if (!(0, $3b05a7d7a92017fb$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $3b05a7d7a92017fb$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $55f33bfc76d27e8b$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $5KQk5.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $5KQk5.Children.forEach(children, function(child) {
            if (!(0, $3b05a7d7a92017fb$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $55f33bfc76d27e8b$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $5KQk5.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $5KQk5.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $5KQk5.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $5KQk5.createElement((0, $5ab65735480eac70$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $f0yL6.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $58a2c7b423f74ed4$export$2e2bcd8739ae039 = (0, $3VtpS.default)($58a2c7b423f74ed4$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($58a2c7b423f74ed4$var$FormControl);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $3VtpS = parcelRequire("3VtpS");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $f0yL6 = parcelRequire("f0yL6");
var $80fc70a062206702$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $80fc70a062206702$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $80fc70a062206702$var$Typography = /*#__PURE__*/ $5KQk5.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $80fc70a062206702$var$defaultVariantMapping : _props$variantMapping, other = (0, $S2OIO.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $80fc70a062206702$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $f0yL6.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $f0yL6.default)(align))], display !== "initial" && classes["display".concat((0, $f0yL6.default)(display))]),
        ref: ref
    }, other));
});
var $80fc70a062206702$export$2e2bcd8739ae039 = (0, $3VtpS.default)($80fc70a062206702$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($80fc70a062206702$var$Typography);



var $f0yL6 = parcelRequire("f0yL6");
var $793c2db34da332e0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            // For correct alignment with the text.
            verticalAlign: "middle",
            WebkitTapHighlightColor: "transparent",
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            "&$disabled": {
                cursor: "default"
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: "row-reverse",
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: "column-reverse",
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: "column",
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $793c2db34da332e0$var$FormControlLabel = /*#__PURE__*/ $5KQk5.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "end" : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $S2OIO.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach(function(key) {
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $5KQk5.createElement("label", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, labelPlacement !== "end" && classes["labelPlacement".concat((0, $f0yL6.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.cloneElement(control, controlProps), /*#__PURE__*/ $5KQk5.createElement((0, $80fc70a062206702$export$2e2bcd8739ae039), {
        component: "span",
        className: (0, $6479q.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $793c2db34da332e0$export$2e2bcd8739ae039 = (0, $3VtpS.default)($793c2db34da332e0$export$9dd6ff9ea0189349, {
    name: "MuiFormControlLabel"
})($793c2db34da332e0$var$FormControlLabel);


var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");
function $aba7025d1adf99eb$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}




var $f0yL6 = parcelRequire("f0yL6");

var $3VtpS = parcelRequire("3VtpS");
var $70f68d037df466c0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $70f68d037df466c0$var$FormLabel = /*#__PURE__*/ $5KQk5.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes["color".concat((0, $f0yL6.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $5KQk5.createElement("span", {
        "aria-hidden": true,
        className: (0, $6479q.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", "*"));
});
var $70f68d037df466c0$export$2e2bcd8739ae039 = (0, $3VtpS.default)($70f68d037df466c0$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($70f68d037df466c0$var$FormLabel);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $1c799df68195d5c8$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $4f5d4a29e3e41ce0$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $3VtpS = parcelRequire("3VtpS");
var $06c4b787b8a98bd3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: "relative",
            display: "flex",
            "&$checked $layer": {
                transform: "scale(1)",
                transition: theme.transitions.create("transform", {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                })
            }
        },
        layer: {
            left: 0,
            position: "absolute",
            transform: "scale(0)",
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.shortest
            })
        },
        checked: {}
    };
};
/**
 * @ignore - internal component.
 */ function $06c4b787b8a98bd3$var$RadioButtonIcon(props) {
    var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
    return /*#__PURE__*/ $5KQk5.createElement("div", {
        className: (0, $6479q.default)(classes.root, checked && classes.checked)
    }, /*#__PURE__*/ $5KQk5.createElement((0, $1c799df68195d5c8$export$2e2bcd8739ae039), {
        fontSize: fontSize
    }), /*#__PURE__*/ $5KQk5.createElement((0, $4f5d4a29e3e41ce0$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        className: classes.layer
    }));
}
var $06c4b787b8a98bd3$export$2e2bcd8739ae039 = (0, $3VtpS.default)($06c4b787b8a98bd3$export$9dd6ff9ea0189349, {
    name: "PrivateRadioButtonIcon"
})($06c4b787b8a98bd3$var$RadioButtonIcon);



var $a71XF = parcelRequire("a71XF");

var $f0yL6 = parcelRequire("f0yL6");
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $07c413e4fbf7ef18$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}



var $3VtpS = parcelRequire("3VtpS");

var $5KQk5 = parcelRequire("5KQk5");

var $5KQk5 = parcelRequire("5KQk5");
/**
 * @ignore - internal component.
 */ var $24b372c9b05379fa$var$RadioGroupContext = $5KQk5.createContext();
var $24b372c9b05379fa$export$2e2bcd8739ae039 = $24b372c9b05379fa$var$RadioGroupContext;


function $660c9540933750bd$export$2e2bcd8739ae039() {
    return $5KQk5.useContext((0, $24b372c9b05379fa$export$2e2bcd8739ae039));
}


var $dbbfd7c2f33795ef$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $a71XF.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $a71XF.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $dbbfd7c2f33795ef$var$defaultCheckedIcon = /*#__PURE__*/ $5KQk5.createElement((0, $06c4b787b8a98bd3$export$2e2bcd8739ae039), {
    checked: true
});
var $dbbfd7c2f33795ef$var$defaultIcon = /*#__PURE__*/ $5KQk5.createElement((0, $06c4b787b8a98bd3$export$2e2bcd8739ae039), null);
var $dbbfd7c2f33795ef$var$Radio = /*#__PURE__*/ $5KQk5.forwardRef(function Radio(props, ref) {
    var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $S2OIO.default)(props, [
        "checked",
        "classes",
        "color",
        "name",
        "onChange",
        "size"
    ]);
    var radioGroup = (0, $660c9540933750bd$export$2e2bcd8739ae039)();
    var checked = checkedProp;
    var onChange = (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = radioGroup.value === props.value;
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ $5KQk5.createElement((0, $5a9c8b65bb61c596$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        color: color,
        type: "radio",
        icon: /*#__PURE__*/ $5KQk5.cloneElement($dbbfd7c2f33795ef$var$defaultIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        checkedIcon: /*#__PURE__*/ $5KQk5.cloneElement($dbbfd7c2f33795ef$var$defaultCheckedIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        classes: {
            root: (0, $6479q.default)(classes.root, classes["color".concat((0, $f0yL6.default)(color))]),
            checked: classes.checked,
            disabled: classes.disabled
        },
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $dbbfd7c2f33795ef$export$2e2bcd8739ae039 = (0, $3VtpS.default)($dbbfd7c2f33795ef$export$9dd6ff9ea0189349, {
    name: "MuiRadio"
})($dbbfd7c2f33795ef$var$Radio);


var $8JsGL = parcelRequire("8JsGL");

var $kxLdw = parcelRequire("kxLdw");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");
var $bc0607b637176b09$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    },
    /* Styles applied to the root element if `row={true}`. */ row: {
        flexDirection: "row"
    }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var $bc0607b637176b09$var$FormGroup = /*#__PURE__*/ $5KQk5.forwardRef(function FormGroup(props, ref) {
    var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "row"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, row && classes.row),
        ref: ref
    }, other));
});
var $bc0607b637176b09$export$2e2bcd8739ae039 = (0, $3VtpS.default)($bc0607b637176b09$export$9dd6ff9ea0189349, {
    name: "MuiFormGroup"
})($bc0607b637176b09$var$FormGroup);






var $5KQk5 = parcelRequire("5KQk5");
function $3a416b7c3480e582$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $5KQk5.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $5KQk5.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}


var $2bac35a08d106473$var$RadioGroup = /*#__PURE__*/ $5KQk5.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0, $S2OIO.default)(props, [
        "actions",
        "children",
        "name",
        "value",
        "onChange"
    ]);
    var rootRef = $5KQk5.useRef(null);
    var _useControlled = (0, $7f281b404a381908$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: props.defaultValue,
        name: "RadioGroup"
    }), _useControlled2 = (0, $kxLdw.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    $5KQk5.useImperativeHandle(actions, function() {
        return {
            focus: function focus() {
                var input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        };
    }, []);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(ref, rootRef);
    var handleChange = function handleChange(event) {
        setValue(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    var name = (0, $3a416b7c3480e582$export$2e2bcd8739ae039)(nameProp);
    return /*#__PURE__*/ $5KQk5.createElement((0, $24b372c9b05379fa$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        }
    }, /*#__PURE__*/ $5KQk5.createElement((0, $bc0607b637176b09$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        role: "radiogroup",
        ref: handleRef
    }, other), children));
});
var $2bac35a08d106473$export$2e2bcd8739ae039 = $2bac35a08d106473$var$RadioGroup;


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $l58xH = parcelRequire("l58xH");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $3VtpS = parcelRequire("3VtpS");

var $f0yL6 = parcelRequire("f0yL6");


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5624519409c0f154$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}




function $dba4f5fa73422340$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $dba4f5fa73422340$var$useEnhancedEffect = typeof window !== "undefined" ? $5KQk5.useLayoutEffect : $5KQk5.useEffect;
var $dba4f5fa73422340$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $dba4f5fa73422340$var$TextareaAutosize = /*#__PURE__*/ $5KQk5.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $S2OIO.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $5KQk5.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $5KQk5.useRef(null);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $5KQk5.useRef(null);
    var renders = $5KQk5.useRef(0);
    var _React$useState = $5KQk5.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $5KQk5.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $dba4f5fa73422340$var$getStyleValue(computedStyle, "padding-bottom") + $dba4f5fa73422340$var$getStyleValue(computedStyle, "padding-top");
        var border = $dba4f5fa73422340$var$getStyleValue(computedStyle, "border-bottom-width") + $dba4f5fa73422340$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $5KQk5.useEffect(function() {
        var handleResize = (0, $5624519409c0f154$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $dba4f5fa73422340$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $5KQk5.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, /*#__PURE__*/ $5KQk5.createElement("textarea", (0, $8JsGL.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $8JsGL.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $5KQk5.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $8JsGL.default)({}, $dba4f5fa73422340$var$styles.shadow, style)
    }));
});
var $dba4f5fa73422340$export$2e2bcd8739ae039 = $dba4f5fa73422340$var$TextareaAutosize;



var $ae83e031d53326c8$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $ae83e031d53326c8$var$useEnhancedEffect = typeof window === "undefined" ? $5KQk5.useEffect : $5KQk5.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $ae83e031d53326c8$var$InputBase = /*#__PURE__*/ $5KQk5.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $S2OIO.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $5KQk5.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $5KQk5.useRef();
    var handleInputRefWarning = $5KQk5.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $5KQk5.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $5ab65735480eac70$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $5KQk5.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $5KQk5.useCallback(function(obj) {
        if ((0, $55f33bfc76d27e8b$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $ae83e031d53326c8$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $l58xH.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $5KQk5.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $8JsGL.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $8JsGL.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $8JsGL.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $dba4f5fa73422340$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $8JsGL.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $5KQk5.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes["color".concat((0, $f0yL6.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $5KQk5.createElement((0, $5ab65735480eac70$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $5KQk5.createElement(InputComponent, (0, $8JsGL.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $6479q.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $8JsGL.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $ae83e031d53326c8$export$2e2bcd8739ae039 = (0, $3VtpS.default)($ae83e031d53326c8$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($ae83e031d53326c8$var$InputBase);



var $3VtpS = parcelRequire("3VtpS");
var $132549aa38a3f9ad$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $132549aa38a3f9ad$var$Input = /*#__PURE__*/ $5KQk5.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $S2OIO.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $ae83e031d53326c8$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        classes: (0, $8JsGL.default)({}, classes, {
            root: (0, $6479q.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$132549aa38a3f9ad$var$Input.muiName = "Input";
var $132549aa38a3f9ad$export$2e2bcd8739ae039 = (0, $3VtpS.default)($132549aa38a3f9ad$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($132549aa38a3f9ad$var$Input);



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $3VtpS = parcelRequire("3VtpS");
var $1b17cec78ac8e57d$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $1b17cec78ac8e57d$var$FilledInput = /*#__PURE__*/ $5KQk5.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $S2OIO.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $ae83e031d53326c8$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        classes: (0, $8JsGL.default)({}, classes, {
            root: (0, $6479q.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$1b17cec78ac8e57d$var$FilledInput.muiName = "Input";
var $1b17cec78ac8e57d$export$2e2bcd8739ae039 = (0, $3VtpS.default)($1b17cec78ac8e57d$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($1b17cec78ac8e57d$var$FilledInput);



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $hl9SO = parcelRequire("hl9SO");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $eV3HM = parcelRequire("eV3HM");
parcelRequire("5KQk5");

var $1M7cg = parcelRequire("1M7cg");
function $bf5ea42c7517b22e$export$2e2bcd8739ae039() {
    var theme = (0, $eV3HM.default)() || (0, $1M7cg.default);
    return theme;
}



var $f0yL6 = parcelRequire("f0yL6");
var $ad95dc60e39bd9cf$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $ad95dc60e39bd9cf$var$NotchedOutline = /*#__PURE__*/ $5KQk5.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $bf5ea42c7517b22e$export$2e2bcd8739ae039)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $5KQk5.createElement("fieldset", (0, $8JsGL.default)({
        "aria-hidden": true,
        className: (0, $6479q.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $5KQk5.createElement("legend", {
        className: (0, $6479q.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $5KQk5.createElement("span", null, label) : /*#__PURE__*/ $5KQk5.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $5KQk5.createElement("fieldset", (0, $8JsGL.default)({
        "aria-hidden": true,
        style: (0, $8JsGL.default)((0, $hl9SO.default)({}, "padding".concat((0, $f0yL6.default)(align)), 8), style),
        className: (0, $6479q.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $5KQk5.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $ad95dc60e39bd9cf$export$2e2bcd8739ae039 = (0, $3VtpS.default)($ad95dc60e39bd9cf$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($ad95dc60e39bd9cf$var$NotchedOutline);



var $3VtpS = parcelRequire("3VtpS");
var $b7b9749bda8e5ef1$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $b7b9749bda8e5ef1$var$OutlinedInput = /*#__PURE__*/ $5KQk5.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $S2OIO.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $ae83e031d53326c8$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $5KQk5.createElement((0, $ad95dc60e39bd9cf$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $8JsGL.default)({}, classes, {
            root: (0, $6479q.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$b7b9749bda8e5ef1$var$OutlinedInput.muiName = "Input";
var $b7b9749bda8e5ef1$export$2e2bcd8739ae039 = (0, $3VtpS.default)($b7b9749bda8e5ef1$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($b7b9749bda8e5ef1$var$OutlinedInput);



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $3VtpS = parcelRequire("3VtpS");

var $f39ca3930236f22f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $f39ca3930236f22f$var$InputLabel = /*#__PURE__*/ $5KQk5.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $5KQk5.createElement((0, $70f68d037df466c0$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        "data-shrink": shrink,
        className: (0, $6479q.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $f39ca3930236f22f$export$2e2bcd8739ae039 = (0, $3VtpS.default)($f39ca3930236f22f$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($f39ca3930236f22f$var$InputLabel);




var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");



var $3VtpS = parcelRequire("3VtpS");
var $0a160a3e36f3cd4f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $0a160a3e36f3cd4f$var$FormHelperText = /*#__PURE__*/ $5KQk5.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $5KQk5.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $0a160a3e36f3cd4f$export$2e2bcd8739ae039 = (0, $3VtpS.default)($0a160a3e36f3cd4f$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($0a160a3e36f3cd4f$var$FormHelperText);



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $iCPvQ = parcelRequire("iCPvQ");

var $8JsGL = parcelRequire("8JsGL");

var $kxLdw = parcelRequire("kxLdw");

var $S2OIO = parcelRequire("S2OIO");

var $6TQKm = parcelRequire("6TQKm");

var $l58xH = parcelRequire("l58xH");

var $5KQk5 = parcelRequire("5KQk5");
parcelRequire("jSuLF");


var $6479q = parcelRequire("6479q");
function $fbfd3bf73dda8687$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $f0yL6 = parcelRequire("f0yL6");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");
parcelRequire("jSuLF");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");





var $6479q = parcelRequire("6479q");


function $16203abcfc0353de$export$2e2bcd8739ae039(node) {
    var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}





var $3VtpS = parcelRequire("3VtpS");

var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");



var $7K7iU = parcelRequire("7K7iU");
var $eV3HM = parcelRequire("eV3HM");




var $5KQk5 = parcelRequire("5KQk5");






function $824f524ed4902303$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $e2b5c52bb63103a5$exports.findDOMNode(container);
}
var $824f524ed4902303$var$useEnhancedEffect = typeof window !== "undefined" ? $5KQk5.useLayoutEffect : $5KQk5.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $824f524ed4902303$var$Portal = /*#__PURE__*/ $5KQk5.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $5KQk5.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(/*#__PURE__*/ $5KQk5.isValidElement(children) ? children.ref : null, ref);
    $824f524ed4902303$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($824f524ed4902303$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $824f524ed4902303$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $24091f3ce5aeac5d$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $24091f3ce5aeac5d$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $824f524ed4902303$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $5KQk5.isValidElement(children)) return /*#__PURE__*/ $5KQk5.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $e2b5c52bb63103a5$exports.createPortal(children, mountNode) : mountNode;
});
var $824f524ed4902303$export$2e2bcd8739ae039 = $824f524ed4902303$var$Portal;






var $gXiHA = parcelRequire("gXiHA");
function $c40eb7b404f4c3d1$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $9k0e1 = parcelRequire("9k0e1");

var $78mMa = parcelRequire("78mMa");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $3695673d1c01a954$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $ab214f79e140d0f0$var$isOverflowing(container) {
    var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $16203abcfc0353de$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $ab214f79e140d0f0$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $ab214f79e140d0f0$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $ab214f79e140d0f0$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $78mMa.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $ab214f79e140d0f0$export$e1bd0c6150f13d96(node, show);
    });
}
function $ab214f79e140d0f0$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $ab214f79e140d0f0$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($ab214f79e140d0f0$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $3695673d1c01a954$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($ab214f79e140d0f0$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($ab214f79e140d0f0$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $ab214f79e140d0f0$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $ab214f79e140d0f0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $c40eb7b404f4c3d1$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $9k0e1.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $ab214f79e140d0f0$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $ab214f79e140d0f0$var$getHiddenSiblings(container);
                $ab214f79e140d0f0$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $ab214f79e140d0f0$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $ab214f79e140d0f0$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $ab214f79e140d0f0$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $ab214f79e140d0f0$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $ab214f79e140d0f0$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $ab214f79e140d0f0$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $ab214f79e140d0f0$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $5KQk5 = parcelRequire("5KQk5");





/**
 * Utility component that locks focus inside the component.
 */ function $6a15f49e4ed1200b$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $5KQk5.useRef();
    var sentinelStart = $5KQk5.useRef(null);
    var sentinelEnd = $5KQk5.useRef(null);
    var nodeToRestore = $5KQk5.useRef();
    var rootRef = $5KQk5.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $5KQk5.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $5KQk5.useRef();
    $5KQk5.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $5KQk5.useEffect(function() {
        if (!open) return;
        var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, /*#__PURE__*/ $5KQk5.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $5KQk5.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $5KQk5.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $6a15f49e4ed1200b$export$2e2bcd8739ae039 = $6a15f49e4ed1200b$var$Unstable_TrapFocus;



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");

var $4813a762a92ba07c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $4813a762a92ba07c$var$SimpleBackdrop = /*#__PURE__*/ $5KQk5.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $S2OIO.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $8JsGL.default)({}, $4813a762a92ba07c$export$9dd6ff9ea0189349.root, invisible ? $4813a762a92ba07c$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $4813a762a92ba07c$export$2e2bcd8739ae039 = $4813a762a92ba07c$var$SimpleBackdrop;


function $72667c9a1b938243$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $e2b5c52bb63103a5$exports.findDOMNode(container);
}
function $72667c9a1b938243$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $72667c9a1b938243$var$defaultManager = new (0, $ab214f79e140d0f0$export$2e2bcd8739ae039)();
var $72667c9a1b938243$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $72667c9a1b938243$var$Modal = /*#__PURE__*/ $5KQk5.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $eV3HM.default)();
    var props = (0, $7K7iU.default)({
        name: "MuiModal",
        props: (0, $8JsGL.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $4813a762a92ba07c$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $72667c9a1b938243$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $S2OIO.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $5KQk5.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $5KQk5.useRef({});
    var mountNodeRef = $5KQk5.useRef(null);
    var modalRef = $5KQk5.useRef(null);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $72667c9a1b938243$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $72667c9a1b938243$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $5KQk5.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $ab214f79e140d0f0$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $5KQk5.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $5KQk5.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $5KQk5.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $72667c9a1b938243$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $gXiHA.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $5KQk5.createElement((0, $824f524ed4902303$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $8JsGL.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $5KQk5.createElement(BackdropComponent, (0, $8JsGL.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $5KQk5.createElement((0, $6a15f49e4ed1200b$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $5KQk5.cloneElement(children, childProps))));
});
var $72667c9a1b938243$export$2e2bcd8739ae039 = $72667c9a1b938243$var$Modal;



var $8JsGL = parcelRequire("8JsGL");

var $kxLdw = parcelRequire("kxLdw");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $4gGez = parcelRequire("4gGez");

var $5WgVA = parcelRequire("5WgVA");


var $5KQk5 = parcelRequire("5KQk5");

var $6839c3d82d639de9$export$2e2bcd8739ae039 = {
    disabled: false
};




var $f62f4396d044d26a$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $10708326225ef393$export$bb38bb9a1161268 = "unmounted";
var $10708326225ef393$export$84cbff306f539230 = "exited";
var $10708326225ef393$export$df38205c966be359 = "entering";
var $10708326225ef393$export$78e9e6e3e014d60a = "entered";
var $10708326225ef393$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $10708326225ef393$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $5WgVA.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $10708326225ef393$export$84cbff306f539230;
                _this.appearStatus = $10708326225ef393$export$df38205c966be359;
            } else initialStatus = $10708326225ef393$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $10708326225ef393$export$bb38bb9a1161268;
        else initialStatus = $10708326225ef393$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $10708326225ef393$export$bb38bb9a1161268) return {
            status: $10708326225ef393$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $10708326225ef393$export$df38205c966be359 && status !== $10708326225ef393$export$78e9e6e3e014d60a) nextStatus = $10708326225ef393$export$df38205c966be359;
            } else if (status === $10708326225ef393$export$df38205c966be359 || status === $10708326225ef393$export$78e9e6e3e014d60a) nextStatus = $10708326225ef393$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $10708326225ef393$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e2b5c52bb63103a5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f62f4396d044d26a$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $10708326225ef393$export$84cbff306f539230) this.setState({
            status: $10708326225ef393$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e2b5c52bb63103a5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $6839c3d82d639de9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $10708326225ef393$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $10708326225ef393$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $10708326225ef393$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e2b5c52bb63103a5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $6839c3d82d639de9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $10708326225ef393$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $10708326225ef393$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $10708326225ef393$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e2b5c52bb63103a5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $10708326225ef393$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4gGez.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement((0, $8e8fc7200a3822e0$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).Component);
$10708326225ef393$var$Transition.contextType = (0, $8e8fc7200a3822e0$export$2e2bcd8739ae039);
$10708326225ef393$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $10708326225ef393$var$noop() {}
$10708326225ef393$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $10708326225ef393$var$noop,
    onEntering: $10708326225ef393$var$noop,
    onEntered: $10708326225ef393$var$noop,
    onExit: $10708326225ef393$var$noop,
    onExiting: $10708326225ef393$var$noop,
    onExited: $10708326225ef393$var$noop
};
$10708326225ef393$var$Transition.UNMOUNTED = $10708326225ef393$export$bb38bb9a1161268;
$10708326225ef393$var$Transition.EXITED = $10708326225ef393$export$84cbff306f539230;
$10708326225ef393$var$Transition.ENTERING = $10708326225ef393$export$df38205c966be359;
$10708326225ef393$var$Transition.ENTERED = $10708326225ef393$export$78e9e6e3e014d60a;
$10708326225ef393$var$Transition.EXITING = $10708326225ef393$export$4aacc83d4d59139f;
var $10708326225ef393$export$2e2bcd8739ae039 = $10708326225ef393$var$Transition;



var $04cab240530707a0$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $04cab240530707a0$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $2b412461af9d23b9$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $2b412461af9d23b9$var$styles = {
    entering: {
        opacity: 1,
        transform: $2b412461af9d23b9$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $2b412461af9d23b9$var$Grow = /*#__PURE__*/ $5KQk5.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $10708326225ef393$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $S2OIO.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $5KQk5.useRef();
    var autoTimeout = $5KQk5.useRef();
    var theme = (0, $bf5ea42c7517b22e$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $5KQk5.useRef(null);
    var foreignRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $kxLdw.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $04cab240530707a0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $04cab240530707a0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $04cab240530707a0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $2b412461af9d23b9$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $5KQk5.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $5KQk5.createElement(TransitionComponent, (0, $8JsGL.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $5KQk5.cloneElement(children, (0, $8JsGL.default)({
            style: (0, $8JsGL.default)({
                opacity: 0,
                transform: $2b412461af9d23b9$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $2b412461af9d23b9$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$2b412461af9d23b9$var$Grow.muiSupportAuto = true;
var $2b412461af9d23b9$export$2e2bcd8739ae039 = $2b412461af9d23b9$var$Grow;



var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");
var $fb5be71a198f5535$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $8JsGL.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $fb5be71a198f5535$var$Paper = /*#__PURE__*/ $5KQk5.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $fb5be71a198f5535$export$2e2bcd8739ae039 = (0, $3VtpS.default)($fb5be71a198f5535$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($fb5be71a198f5535$var$Paper);


function $d6cae312473af6de$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $d6cae312473af6de$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $d6cae312473af6de$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $d6cae312473af6de$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $d6cae312473af6de$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $d6cae312473af6de$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $d6cae312473af6de$var$Popover = /*#__PURE__*/ $5KQk5.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $2b412461af9d23b9$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $S2OIO.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $5KQk5.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $5KQk5.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $d6cae312473af6de$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $d6cae312473af6de$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $d6cae312473af6de$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $5KQk5.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $d6cae312473af6de$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $5KQk5.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $d6cae312473af6de$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $d6cae312473af6de$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $5KQk5.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $d6cae312473af6de$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $16203abcfc0353de$export$2e2bcd8739ae039)($d6cae312473af6de$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $d6cae312473af6de$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $5KQk5.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $5KQk5.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
    }, []);
    $5KQk5.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $5KQk5.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $5KQk5.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $5624519409c0f154$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)($d6cae312473af6de$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $5KQk5.createElement((0, $72667c9a1b938243$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $6479q.default)(classes.root, className)
    }, other), /*#__PURE__*/ $5KQk5.createElement(TransitionComponent, (0, $8JsGL.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $5KQk5.createElement((0, $fb5be71a198f5535$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $6479q.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $d6cae312473af6de$export$2e2bcd8739ae039 = (0, $3VtpS.default)($d6cae312473af6de$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($d6cae312473af6de$var$Popover);



var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");
parcelRequire("jSuLF");




var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $5KQk5 = parcelRequire("5KQk5");
/**
 * @ignore - internal component.
 */ var $13bbc16e6ee68fca$var$ListContext = $5KQk5.createContext({});
var $13bbc16e6ee68fca$export$2e2bcd8739ae039 = $13bbc16e6ee68fca$var$ListContext;


var $6ebfc43305549397$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $6ebfc43305549397$var$List = /*#__PURE__*/ $5KQk5.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $5KQk5.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $13bbc16e6ee68fca$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $6ebfc43305549397$export$2e2bcd8739ae039 = (0, $3VtpS.default)($6ebfc43305549397$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($6ebfc43305549397$var$List);




function $6c7de748959e55a9$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $6c7de748959e55a9$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $6c7de748959e55a9$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $6c7de748959e55a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$6c7de748959e55a9$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $6c7de748959e55a9$var$useEnhancedEffect = typeof window === "undefined" ? $5KQk5.useEffect : $5KQk5.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $6c7de748959e55a9$var$MenuList = /*#__PURE__*/ $5KQk5.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $S2OIO.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $5KQk5.useRef(null);
    var textCriteriaRef = $5KQk5.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $6c7de748959e55a9$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $5KQk5.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $3695673d1c01a954$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $6c7de748959e55a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6c7de748959e55a9$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $6c7de748959e55a9$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6c7de748959e55a9$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $6c7de748959e55a9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6c7de748959e55a9$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $6c7de748959e55a9$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6c7de748959e55a9$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $6c7de748959e55a9$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $6c7de748959e55a9$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $6c7de748959e55a9$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $5KQk5.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $5KQk5.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $5KQk5.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $5KQk5.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $5KQk5.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $5KQk5.createElement((0, $6ebfc43305549397$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $6c7de748959e55a9$export$2e2bcd8739ae039 = $6c7de748959e55a9$var$MenuList;






var $ea869918397bd36b$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $ea869918397bd36b$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $ea869918397bd36b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $ea869918397bd36b$var$Menu = /*#__PURE__*/ $5KQk5.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $S2OIO.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $S2OIO.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $bf5ea42c7517b22e$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $5KQk5.useRef(null);
    var contentAnchorRef = $5KQk5.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $5KQk5.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $5KQk5.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $5KQk5.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $5KQk5.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
                (0, $24091f3ce5aeac5d$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $5KQk5.createElement((0, $d6cae312473af6de$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $8JsGL.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === "rtl" ? $ea869918397bd36b$var$RTL_ORIGIN : $ea869918397bd36b$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $ea869918397bd36b$var$RTL_ORIGIN : $ea869918397bd36b$var$LTR_ORIGIN,
        PaperProps: (0, $8JsGL.default)({}, PaperProps, {
            classes: (0, $8JsGL.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $5KQk5.createElement((0, $6c7de748959e55a9$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $6479q.default)(classes.list, MenuListProps.className)
    }), items));
});
var $ea869918397bd36b$export$2e2bcd8739ae039 = (0, $3VtpS.default)($ea869918397bd36b$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($ea869918397bd36b$var$Menu);





function $72dcf9bc5bd9515a$var$areEqualValues(a, b) {
    if ((0, $6TQKm.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $72dcf9bc5bd9515a$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $72dcf9bc5bd9515a$var$SelectInput = /*#__PURE__*/ $5KQk5.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $7f281b404a381908$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $kxLdw.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $5KQk5.useRef(null);
    var _React$useState = $5KQk5.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $5KQk5.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $5KQk5.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $5KQk5.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(ref, inputRefProp);
    $5KQk5.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $5KQk5.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $5KQk5.useEffect(function() {
        if (displayNode) {
            var label = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $5KQk5.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $55f33bfc76d27e8b$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $5KQk5.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $l58xH.default)(2));
            selected = value.some(function(v) {
                return $72dcf9bc5bd9515a$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $72dcf9bc5bd9515a$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $5KQk5.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $72dcf9bc5bd9515a$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $5KQk5.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $5KQk5.createElement("input", (0, $8JsGL.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $5KQk5.createElement(IconComponent, {
        className: (0, $6479q.default)(classes.icon, classes["icon".concat((0, $f0yL6.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $5KQk5.createElement((0, $ea869918397bd36b$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $8JsGL.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $8JsGL.default)({}, MenuProps.PaperProps, {
            style: (0, $8JsGL.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $72dcf9bc5bd9515a$export$2e2bcd8739ae039 = $72dcf9bc5bd9515a$var$SelectInput;





var $3VtpS = parcelRequire("3VtpS");

var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $5ed17ac72636bb47$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");




var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $f0yL6 = parcelRequire("f0yL6");
/**
 * @ignore - internal component.
 */ var $26c14dafe63a3f32$var$NativeSelectInput = /*#__PURE__*/ $5KQk5.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, /*#__PURE__*/ $5KQk5.createElement("select", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $5KQk5.createElement(IconComponent, {
        className: (0, $6479q.default)(classes.icon, classes["icon".concat((0, $f0yL6.default)(variant))], disabled && classes.disabled)
    }));
});
var $26c14dafe63a3f32$export$2e2bcd8739ae039 = $26c14dafe63a3f32$var$NativeSelectInput;



var $3VtpS = parcelRequire("3VtpS");




var $2a59d29a7fc5ecd3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $2a59d29a7fc5ecd3$var$defaultInput = /*#__PURE__*/ $5KQk5.createElement((0, $132549aa38a3f9ad$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $2a59d29a7fc5ecd3$var$NativeSelect = /*#__PURE__*/ $5KQk5.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $5ed17ac72636bb47$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $2a59d29a7fc5ecd3$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $5KQk5.cloneElement(input, (0, $8JsGL.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $26c14dafe63a3f32$export$2e2bcd8739ae039),
        inputProps: (0, $8JsGL.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$2a59d29a7fc5ecd3$var$NativeSelect.muiName = "Select";
var $2a59d29a7fc5ecd3$export$2e2bcd8739ae039 = (0, $3VtpS.default)($2a59d29a7fc5ecd3$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($2a59d29a7fc5ecd3$var$NativeSelect);





var $826e91e893e02a40$export$9dd6ff9ea0189349 = (0, $2a59d29a7fc5ecd3$export$9dd6ff9ea0189349);
var $826e91e893e02a40$var$_ref = /*#__PURE__*/ $5KQk5.createElement((0, $132549aa38a3f9ad$export$2e2bcd8739ae039), null);
var $826e91e893e02a40$var$_ref2 = /*#__PURE__*/ $5KQk5.createElement((0, $1b17cec78ac8e57d$export$2e2bcd8739ae039), null);
var $826e91e893e02a40$var$Select = /*#__PURE__*/ $5KQk5.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $5ed17ac72636bb47$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $26c14dafe63a3f32$export$2e2bcd8739ae039) : (0, $72dcf9bc5bd9515a$export$2e2bcd8739ae039);
    var muiFormControl = (0, $48c8af55c97bfee8$export$2e2bcd8739ae039)();
    var fcs = (0, $aba7025d1adf99eb$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $826e91e893e02a40$var$_ref,
        outlined: /*#__PURE__*/ $5KQk5.createElement((0, $b7b9749bda8e5ef1$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $826e91e893e02a40$var$_ref2
    })[variant];
    return /*#__PURE__*/ $5KQk5.cloneElement(InputComponent, (0, $8JsGL.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $8JsGL.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $8JsGL.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $iCPvQ.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$826e91e893e02a40$var$Select.muiName = "Select";
var $826e91e893e02a40$export$2e2bcd8739ae039 = (0, $3VtpS.default)($826e91e893e02a40$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($826e91e893e02a40$var$Select);



var $3VtpS = parcelRequire("3VtpS");
var $02413e5e812e18c5$var$variantComponent = {
    standard: (0, $132549aa38a3f9ad$export$2e2bcd8739ae039),
    filled: (0, $1b17cec78ac8e57d$export$2e2bcd8739ae039),
    outlined: (0, $b7b9749bda8e5ef1$export$2e2bcd8739ae039)
};
var $02413e5e812e18c5$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $02413e5e812e18c5$var$TextField = /*#__PURE__*/ $5KQk5.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $02413e5e812e18c5$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $5KQk5.createElement(InputComponent, (0, $8JsGL.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $5KQk5.createElement((0, $58a2c7b423f74ed4$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $5KQk5.createElement((0, $f39ca3930236f22f$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $5KQk5.createElement((0, $826e91e893e02a40$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $5KQk5.createElement((0, $0a160a3e36f3cd4f$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $02413e5e812e18c5$export$2e2bcd8739ae039 = (0, $3VtpS.default)($02413e5e812e18c5$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($02413e5e812e18c5$var$TextField);



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var $f061e4c7cc96df48$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
}), "Autorenew");


var $c2546d3bb9678472$exports = {};
"use strict";
var $c2546d3bb9678472$var$__createBinding = $c2546d3bb9678472$exports && $c2546d3bb9678472$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c2546d3bb9678472$var$__exportStar = $c2546d3bb9678472$exports && $c2546d3bb9678472$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c2546d3bb9678472$var$__createBinding(exports1, m, p);
};
Object.defineProperty($c2546d3bb9678472$exports, "__esModule", {
    value: true
});

$c2546d3bb9678472$var$__exportStar((parcelRequire("3saO8")), $c2546d3bb9678472$exports);

$c2546d3bb9678472$var$__exportStar((parcelRequire("dtO8f")), $c2546d3bb9678472$exports);

$c2546d3bb9678472$var$__exportStar((parcelRequire("ft5wW")), $c2546d3bb9678472$exports);



const $0cfbfa2381a851c1$var$getRandomSessionId = ()=>{
    const randomWords = (parcelRequire("jY4In"));
    return randomWords({
        exactly: 1,
        wordsPerString: 2,
        separator: "-"
    })[0];
};
function $0cfbfa2381a851c1$export$2e2bcd8739ae039(props) {
    let [session, setSession] = (0, $5KQk5.useState)(props.sessionId || $0cfbfa2381a851c1$var$getRandomSessionId());
    let [userType, setUserType] = (0, $5KQk5.useState)(props.userType);
    let [player, setPlayer] = (0, $5KQk5.useState)(props.player);
    let [team, setTeam] = (0, $5KQk5.useState)(props.teamName);
    let [teamEnabled, setTeamEnabled] = (0, $5KQk5.useState)(player !== team); // if they are the same, we hide the field by default
    let [server, setServer] = (0, $5KQk5.useState)(props.server);
    const isPlayer = userType === $c2546d3bb9678472$exports.GUIUserType.PLAYER;
    const readyToGo = session && userType && (isPlayer && player && (!teamEnabled || teamEnabled && team) || !isPlayer);
    const handleRadioSelect = (e)=>{
        const userType = parseInt(e.target.value);
        setUserType(userType);
        switch(userType){
            case $c2546d3bb9678472$exports.GUIUserType.PLAYER:
                break;
            case $c2546d3bb9678472$exports.GUIUserType.ADMIN:
            case $c2546d3bb9678472$exports.GUIUserType.OBSERVER:
            case $c2546d3bb9678472$exports.GUIUserType.UNDEFINED:
            default:
                setPlayer(undefined);
                setTeam(undefined);
                setTeamEnabled(false);
        }
    };
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $fbeaa9276e0ae0d4$export$2e2bcd8739ae039), {
        maxWidth: "sm",
        style: {
            alignContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                    variant: "h4",
                    color: "primary",
                    align: "center",
                    children: "Jeoparty!"
                })
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    margin: "normal",
                    label: "Game name",
                    variant: "outlined",
                    placeholder: "asdf",
                    value: session,
                    onChange: (e)=>setSession(e.target.value),
                    InputLabelProps: {
                        shrink: !!session
                    },
                    InputProps: {
                        endAdornment: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $2716d8fe3b58de60$export$2e2bcd8739ae039), {
                            "aria-label": "generate",
                            onClick: ()=>setSession($0cfbfa2381a851c1$var$getRandomSessionId),
                            children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $f061e4c7cc96df48$export$2e2bcd8739ae039), {})
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $58a2c7b423f74ed4$export$2e2bcd8739ae039), {
                    component: "fieldset",
                    children: [
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $70f68d037df466c0$export$2e2bcd8739ae039), {
                            component: "legend",
                            children: "Choose your role"
                        }),
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $2bac35a08d106473$export$2e2bcd8739ae039), {
                            "aria-label": "role",
                            name: "role",
                            value: userType,
                            onChange: handleRadioSelect,
                            children: [
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $793c2db34da332e0$export$2e2bcd8739ae039), {
                                    value: $c2546d3bb9678472$exports.GUIUserType.PLAYER,
                                    control: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $dbbfd7c2f33795ef$export$2e2bcd8739ae039), {}),
                                    label: "Play"
                                }),
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $793c2db34da332e0$export$2e2bcd8739ae039), {
                                    value: $c2546d3bb9678472$exports.GUIUserType.OBSERVER,
                                    control: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $dbbfd7c2f33795ef$export$2e2bcd8739ae039), {}),
                                    label: "Watch"
                                }),
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $793c2db34da332e0$export$2e2bcd8739ae039), {
                                    value: $c2546d3bb9678472$exports.GUIUserType.ADMIN,
                                    control: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $dbbfd7c2f33795ef$export$2e2bcd8739ae039), {}),
                                    label: "Admin"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                    fullWidth: true,
                    margin: "normal",
                    label: "Server URL (optional)",
                    variant: "outlined",
                    placeholder: "wss://ws.jeoparty.fun",
                    value: server,
                    onChange: (e)=>setServer(e.target.value),
                    helperText: "Leave blank to use default server"
                })
            }),
            userType === $c2546d3bb9678472$exports.GUIUserType.PLAYER && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: [
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        margin: "normal",
                        label: "Player name",
                        variant: "outlined",
                        placeholder: "Ken Jennings",
                        value: player,
                        onChange: (e)=>setPlayer(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $793c2db34da332e0$export$2e2bcd8739ae039), {
                        control: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $44aa916fa0ed7c8d$export$2e2bcd8739ae039), {
                            checked: teamEnabled,
                            onChange: (e)=>{
                                setTeamEnabled(e.target.checked);
                            // if (e.target.checked === false) {
                            //   setTeam(undefined);
                            // }
                            },
                            name: "checkedB",
                            color: "primary"
                        }),
                        label: "Join a team (optional)"
                    }),
                    teamEnabled && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        margin: "normal",
                        label: "Team name",
                        variant: "outlined",
                        placeholder: "My Awesome Team",
                        value: team,
                        onChange: (e)=>setTeam(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
                paddingTop: 3,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>props.goCallback(session, userType, player, team, server),
                    disabled: !readyToGo,
                    children: "Go!"
                })
            })
        ]
    });
}




var $5KQk5 = parcelRequire("5KQk5");

const $7f247ecbc0ccba65$var$trebekTeam = "___trebekTeam___";
const $7f247ecbc0ccba65$var$trebekPlayer = "___trebekPlayer___";
const $7f247ecbc0ccba65$var$spectatorTeam = "___spectatorTeam___";
const $7f247ecbc0ccba65$var$spectatorPlayer = "___spectatorPlayer___";
class $7f247ecbc0ccba65$export$2e2bcd8739ae039 {
    // eg. sendMessage(new ModifyScoreMessage("game_id", -1000, "isaac"))
    sendMessage(msg) {
        this.socket.send(JSON.stringify(msg));
    }
    constructor(setState, anAdmin, sessionId, teamName, player){
        this.addSocket = (socket)=>{
            this.socket = socket;
        };
        this.onSocketOpen = (event)=>{
            console.log("Successfully opened websocket");
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.TrebekJoinMessage(this.id));
            else // If no team name or player name is known at time of sockets creation
            // this client is joining as a spectator
            if (this.isSpectator()) this.sendMessage(new $c2546d3bb9678472$exports.ContestantSpectate(this.id));
            else this.sendMessage(new $c2546d3bb9678472$exports.ContestantJoin(this.id, this.teamName, this.player));
        };
        this.onSocketMessage = (event, currentClientState)=>{
            // TODO: might not need to pass in state
            // TODO: Add types to the input parameters
            let message = JSON.parse(event.data);
            console.debug("Received event from jeoparty server of type", $c2546d3bb9678472$exports.ServerMessageType[message.type]);
            switch(message.type){
                case $c2546d3bb9678472$exports.ServerMessageType.DAILY_DOUBLE_WAGER:
                    this.updateState(message.newState, currentClientState);
                    break;
                case $c2546d3bb9678472$exports.ServerMessageType.OPEN_BUZZER:
                    this.buzzerOpenTime = Date.now();
                    this.updateState(message.newState, currentClientState);
                    break;
                case $c2546d3bb9678472$exports.ServerMessageType.STATE_UPDATE:
                    this.updateState(message.newState, currentClientState);
                    break;
                case $c2546d3bb9678472$exports.ServerMessageType.GAMES_LIST:
                    this.updateGameList(message.games);
                    break;
                case $c2546d3bb9678472$exports.ServerMessageType.ERROR:
                    console.warn("Error from server: ", message.error);
            }
        };
        this.updateState = (stateUpdate, clientState)=>{
            this.setClientState({
                ...clientState,
                ...stateUpdate
            });
        };
        this.updateGameList = (gameList)=>{
            console.log("Received list of games: " + gameList);
            this.gameList = gameList.reverse();
        };
        this.onSocketError = (event)=>{
            console.error(event);
        };
        this.onSocketClose = (event)=>{
            console.log("Closing connection with jeoparty server");
        };
        this.isSpectator = ()=>{
            return this.player === $7f247ecbc0ccba65$var$spectatorPlayer && this.teamName === $7f247ecbc0ccba65$var$spectatorTeam;
        };
        this.buzz = ()=>{
            const responseTime = Date.now() - this.buzzerOpenTime;
            this.sendMessage(new $c2546d3bb9678472$exports.ContestantBuzzIn(this.id, this.teamName, responseTime));
        };
        this.openBuzzer = ()=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.OpenBuzzer(this.id));
        };
        this.setTeamName = (teamName)=>{
            this.teamName = teamName;
        };
        this.setPlayerName = (playerName)=>{
            this.player = playerName;
        };
        this.contestantRejoin = ()=>{
            this.sendMessage(new $c2546d3bb9678472$exports.ContestantJoin(this.id, this.teamName, this.player));
        };
        this.selectClue = (clueId)=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.SelectClueMessage(this.id, clueId));
        };
        this.closeClue = ()=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.CloseClueMessage(this.id));
        };
        this.modifyScore = (team, delta)=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.ModifyScoreMessage(this.id, delta, team));
        };
        this.setScore = (team, newScore)=>{
            if (this.isAdmin) {
                console.log("setting score for team", team, newScore);
                this.sendMessage(new $c2546d3bb9678472$exports.SetScoreMessage(this.id, newScore, team));
            }
        };
        this.sendWager = (wager)=>{
            this.sendMessage(new $c2546d3bb9678472$exports.ContestantWager(this.id, this.teamName, wager));
        };
        this.closeWagers = ()=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.CloseWagersMessage(this.id));
        };
        this.closeSubmissions = ()=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.CloseSubmissionsMessage(this.id));
        };
        this.sendSubmission = (submission)=>{
            this.sendMessage(new $c2546d3bb9678472$exports.ContestantSubmission(this.id, this.teamName, submission));
            console.log("submitted");
        };
        this.reveal = (team)=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.RevealMessage(this.id, team));
        };
        this.selectGame = (game)=>{
            this.sendMessage(new $c2546d3bb9678472$exports.SelectGameMessage(this.id, game));
            console.log("Chose game ", game);
        };
        this.removeContestant = (teamName)=>{
            if (this.isAdmin) this.sendMessage(new $c2546d3bb9678472$exports.ContestantRemoveMessage(this.id, teamName));
        };
        this.setClientState = setState;
        // register message handler for onmessage in the caller
        this.id = sessionId;
        this.lockedOut = false;
        this.isAdmin = anAdmin;
        this.buzzerOpenTime = 0;
        this.player = player ? player : anAdmin ? $7f247ecbc0ccba65$var$trebekPlayer : $7f247ecbc0ccba65$var$spectatorPlayer;
        this.teamName = teamName ? teamName : anAdmin ? $7f247ecbc0ccba65$var$trebekTeam : $7f247ecbc0ccba65$var$spectatorTeam;
        this.gameList = [];
    }
}




var $5KQk5 = parcelRequire("5KQk5");

function $f41ba44b69a44412$export$2e2bcd8739ae039({ isAdmin: isAdmin, buzzerOpen: buzzerOpen, apiClientBuzz: apiClientBuzz, openBuzzer: openBuzzer, openClue: openClue }) {
    const [isLocked, setLocked] = (0, $5KQk5.useState)(false);
    // const [timeoutID, setTimeoutID] = useRef(null)
    const [timeoutID, setTimeoutID] = (0, $5KQk5.useState)(0);
    const buzzIn = ()=>{
        if (buzzerOpen) {
            if (!isLocked) apiClientBuzz();
        } else lockBuzzer();
    };
    const lockBuzzer = ()=>{
        setLocked(true);
        if (isLocked) window.clearTimeout(timeoutID);
        const to = window.setTimeout(()=>{
            setLocked(false);
        }, 1000); // 1s
        setTimeoutID(to);
        setLocked(true);
    };
    let buzzerColor = "default";
    let buzzerString;
    if (isLocked) {
        buzzerColor = "secondary";
        buzzerString = "Buzz (locked)";
    } else if (buzzerOpen) {
        buzzerColor = "primary";
        buzzerString = "Buzz (open)";
    } else {
        buzzerColor = "default";
        buzzerString = "Buzz";
    }
    // "Buzzer Closed" = Colour1 --> "Buzzer Open" = Colour2 / "Buzzer Locked" = Colour3
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $2bbb5df1d77a4f15$exports.Fragment), {
        children: [
            !isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                variant: "contained",
                color: buzzerColor,
                onMouseDown: buzzIn,
                size: "large",
                fullWidth: true,
                disableRipple: true,
                children: buzzerString
            }),
            isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                variant: "contained",
                color: "primary",
                onClick: openBuzzer,
                disabled: !openClue || buzzerOpen,
                size: "large",
                fullWidth: true,
                disableRipple: true,
                children: buzzerOpen ? "Buzzer" : "Open Buzzer"
            })
        ]
    });
}



parcelRequire("5KQk5");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");
var $80ab4759404597e0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        overflow: "hidden"
    }
};
var $80ab4759404597e0$var$Card = /*#__PURE__*/ $5KQk5.forwardRef(function Card(props, ref) {
    var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "raised"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $fb5be71a198f5535$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className),
        elevation: raised ? 8 : 1,
        ref: ref
    }, other));
});
var $80ab4759404597e0$export$2e2bcd8739ae039 = (0, $3VtpS.default)($80ab4759404597e0$export$9dd6ff9ea0189349, {
    name: "MuiCard"
})($80ab4759404597e0$var$Card);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $b02b304d3cf50157$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            textAlign: "inherit",
            width: "100%",
            "&:hover $focusHighlight": {
                opacity: theme.palette.action.hoverOpacity
            },
            "&$focusVisible $focusHighlight": {
                opacity: 0.12
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */ focusVisible: {},
        /* Styles applied to the overlay that covers the action area when it is keyboard focused. */ focusHighlight: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit",
            opacity: 0,
            backgroundColor: "currentcolor",
            transition: theme.transitions.create("opacity", {
                duration: theme.transitions.duration.short
            })
        }
    };
};
var $b02b304d3cf50157$var$CardActionArea = /*#__PURE__*/ $5KQk5.forwardRef(function CardActionArea(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, focusVisibleClassName = props.focusVisibleClassName, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "focusVisibleClassName"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $b84a8edbcc74a2d5$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className),
        focusVisibleClassName: (0, $6479q.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref
    }, other), children, /*#__PURE__*/ $5KQk5.createElement("span", {
        className: classes.focusHighlight
    }));
});
var $b02b304d3cf50157$export$2e2bcd8739ae039 = (0, $3VtpS.default)($b02b304d3cf50157$export$9dd6ff9ea0189349, {
    name: "MuiCardActionArea"
})($b02b304d3cf50157$var$CardActionArea);


var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");
var $1a9a1c9fa179ada3$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    }
};
var $1a9a1c9fa179ada3$var$CardContent = /*#__PURE__*/ $5KQk5.forwardRef(function CardContent(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className),
        ref: ref
    }, other));
});
var $1a9a1c9fa179ada3$export$2e2bcd8739ae039 = (0, $3VtpS.default)($1a9a1c9fa179ada3$export$9dd6ff9ea0189349, {
    name: "MuiCardContent"
})($1a9a1c9fa179ada3$var$CardContent);


var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");


var $826793a32e582c6b$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $826793a32e582c6b$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $826793a32e582c6b$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $826793a32e582c6b$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $8JsGL.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $826793a32e582c6b$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $826793a32e582c6b$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $826793a32e582c6b$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($826793a32e582c6b$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($826793a32e582c6b$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $826793a32e582c6b$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $826793a32e582c6b$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $8JsGL.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $826793a32e582c6b$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $826793a32e582c6b$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $826793a32e582c6b$var$Grid = /*#__PURE__*/ $5KQk5.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $S2OIO.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $6479q.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        className: className,
        ref: ref
    }, other));
});
var $826793a32e582c6b$var$StyledGrid = (0, $3VtpS.default)($826793a32e582c6b$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($826793a32e582c6b$var$Grid);
var $826793a32e582c6b$var$requireProp;
var $826793a32e582c6b$export$2e2bcd8739ae039 = $826793a32e582c6b$var$StyledGrid;



// TODO: Resize the size of categories since some are too long to fit; make taller
function $c788b9d41797a57c$var$BoardClue({ clue: clue, id: id, selectClue: selectClue }) {
    if (!clue) return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
        item: true,
        xs: 2
    }, id);
    let clueProps = {
        style: {}
    };
    switch(clue.status){
        case $c2546d3bb9678472$exports.Status.UNPLAYED:
            break;
        case $c2546d3bb9678472$exports.Status.INPLAY:
            clueProps.style = {
                background: "#6C6CE0"
            };
            break;
        case $c2546d3bb9678472$exports.Status.PLAYED:
            clueProps.style = {
                background: "#333333"
            };
            break;
    }
    if (selectClue) clueProps = {
        ...clueProps,
        onClick: ()=>selectClue(id)
    };
    const onClickFunction = selectClue ? ()=>selectClue(id) : ()=>{};
    const isDisabled = clue.status === $c2546d3bb9678472$exports.Status.PLAYED;
    const isPrimary = clue.status === $c2546d3bb9678472$exports.Status.INPLAY;
    let color = "primary";
    if (isPrimary) color = undefined;
    return(// todo: better handling of final jeopardy
    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
        item: true,
        xs: 2,
        zeroMinWidth: true,
        children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
            style: {
                padding: 12
            },
            children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $b02b304d3cf50157$export$2e2bcd8739ae039), {
                onClick: onClickFunction,
                disabled: isDisabled,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                    color: color,
                    align: "center",
                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)("strong", {
                        children: !isDisabled ? clue.value || "Final Jeopardy" : "\xa0"
                    })
                })
            })
        })
    }, id));
}
function $c788b9d41797a57c$export$2e2bcd8739ae039({ currentRound: currentRound, selectClue: selectClue }) {
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
        container: true,
        spacing: 1,
        alignItems: "stretch",
        children: [
            currentRound.categories.map((cat)=>/*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 2,
                    style: {
                        marginBottom: 10
                    },
                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
                            style: {
                                padding: 20,
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                align: "center",
                                style: {
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    placeItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)("strong", {
                                    children: cat
                                })
                            })
                        })
                    })
                }, cat)),
            currentRound.clues.map((row, row_number)=>row.map((clue, col_number)=>{
                    const id = 6 * row_number + col_number;
                    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)($c788b9d41797a57c$var$BoardClue, {
                        clue: clue,
                        id: id,
                        selectClue: selectClue
                    }, id);
                }))
        ]
    });
}



parcelRequire("5KQk5");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");
var $5560f57904113854$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        alignItems: "center",
        padding: 8
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        "& > :not(:first-child)": {
            marginLeft: 8
        }
    }
};
var $5560f57904113854$var$CardActions = /*#__PURE__*/ $5KQk5.forwardRef(function CardActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $S2OIO.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $5560f57904113854$export$2e2bcd8739ae039 = (0, $3VtpS.default)($5560f57904113854$export$9dd6ff9ea0189349, {
    name: "MuiCardActions"
})($5560f57904113854$var$CardActions);




var $5KQk5 = parcelRequire("5KQk5");

function $50dfa2fc748f8e05$export$2e2bcd8739ae039({ submitWager: submitWager, validateWager: validateWager }) {
    const [hasSubmitted, setHasSubmitted] = (0, $5KQk5.useState)(false);
    const [wager, setWager] = (0, $5KQk5.useState)(0);
    const [displayWager, setDisplayWager] = (0, $5KQk5.useState)("");
    const updateWagers = (wager)=>{
        setWager(Number(wager));
        setDisplayWager(wager);
    };
    const sendWager = ()=>{
        if (!hasSubmitted) submitWager(wager);
        setHasSubmitted(true);
    };
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                fullWidth: true,
                margin: "normal",
                label: "Wager Amount",
                type: "number",
                variant: "outlined",
                error: validateWager(wager) ? true : false,
                helperText: validateWager(wager),
                value: displayWager,
                onChange: (e)=>updateWagers(e.target.value)
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                variant: "outlined",
                color: "primary",
                onClick: sendWager,
                disabled: validateWager(wager) ? true : false,
                children: "Submit"
            })
        ]
    });
}



function $797661d28c0bacc5$export$2e2bcd8739ae039({ isAdmin: isAdmin, currentClue: currentClue, closeClue: closeClue, controlsBoard: controlsBoard, currentScore: currentScore, submitWager: sendWagerFunc, dailyDoubleWager: dailyDoubleWager, buzzedInTeam: buzzedInTeam, modifyScore: modifyScore, teamInControl: teamInControl }) {
    let checkDailyDoubleWagerFunc = (wager)=>{
        const maxWager = Math.max(currentScore, currentClue.value);
        if (wager > maxWager) return "Maximum wager is " + maxWager.toString();
        else if (wager <= 0) return "You must wager some money.";
    };
    // Probably fine to have this be local state, but if a person refreshes
    // the page they will be able to submit again. With the input likely ignored
    const clueValue = currentClue.dailyDouble ? dailyDoubleWager : currentClue.value;
    const team = currentClue.dailyDouble ? teamInControl : buzzedInTeam;
    const canShowQuestion = isAdmin || !currentClue.dailyDouble || currentClue.dailyDouble && dailyDoubleWager !== $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER;
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
                children: [
                    currentClue.dailyDouble && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        variant: "h5",
                        children: "Daily Double!"
                    }),
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                        gutterBottom: true,
                        variant: "h5",
                        color: "primary",
                        children: [
                            currentClue.value,
                            " points"
                        ]
                    }),
                    controlsBoard && currentClue.dailyDouble && dailyDoubleWager === $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $50dfa2fc748f8e05$export$2e2bcd8739ae039), {
                        submitWager: sendWagerFunc,
                        validateWager: checkDailyDoubleWagerFunc
                    }),
                    canShowQuestion && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                        variant: "body1",
                        component: "p",
                        children: [
                            currentClue.media && "Media clue:",
                            " ",
                            currentClue.question
                        ]
                    }),
                    isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                        variant: "body2",
                        component: "p",
                        color: "textSecondary",
                        children: [
                            "Answer: ",
                            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)("em", {
                                children: currentClue.answer
                            })
                        ]
                    })
                ]
            }),
            isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $5560f57904113854$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                        color: "secondary",
                        onClick: ()=>modifyScore(team, -clueValue),
                        disabled: team === "" || clueValue === $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER,
                        children: "Incorrect"
                    }),
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: ()=>modifyScore(team, clueValue),
                        disabled: team === "" || clueValue === $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER,
                        children: "Correct"
                    }),
                    /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                        onClick: closeClue,
                        style: {
                            marginLeft: "auto"
                        },
                        disabled: currentClue.dailyDouble,
                        children: "Close"
                    })
                ]
            })
        ]
    });
}




var $5KQk5 = parcelRequire("5KQk5");

var $8JsGL = parcelRequire("8JsGL");

var $kxLdw = parcelRequire("kxLdw");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");

var $6479q = parcelRequire("6479q");




var $3VtpS = parcelRequire("3VtpS");

var $fHk6u = parcelRequire("fHk6u");




var $0612e7853ce39c72$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: "hidden",
            transition: theme.transitions.create("height")
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: "auto",
            overflow: "visible"
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: "hidden"
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: "flex"
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: "100%"
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $0612e7853ce39c72$var$Collapse = /*#__PURE__*/ $5KQk5.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? "0px" : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $fHk6u.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $10708326225ef393$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $S2OIO.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $bf5ea42c7517b22e$export$2e2bcd8739ae039)();
    var timer = $5KQk5.useRef();
    var wrapperRef = $5KQk5.useRef(null);
    var autoTransitionDuration = $5KQk5.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === "number" ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $5KQk5.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $5KQk5.useRef(null);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $kxLdw.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $04cab240530707a0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $04cab240530707a0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === "auto") {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $5KQk5.createElement(TransitionComponent, (0, $8JsGL.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
            className: (0, $6479q.default)(classes.root, classes.container, className, {
                "entered": classes.entered,
                "exited": !inProp && collapsedSize === "0px" && classes.hidden
            }[state]),
            style: (0, $8JsGL.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $5KQk5.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $5KQk5.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$0612e7853ce39c72$var$Collapse.muiSupportAuto = true;
var $0612e7853ce39c72$export$2e2bcd8739ae039 = (0, $3VtpS.default)($0612e7853ce39c72$export$9dd6ff9ea0189349, {
    name: "MuiCollapse"
})($0612e7853ce39c72$var$Collapse);



var $8JsGL = parcelRequire("8JsGL");

var $jeCqG = parcelRequire("jeCqG");

var $1M7cg = parcelRequire("1M7cg");
function $6a23732b67f2ab3c$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $jeCqG.default)(stylesOrCreator, (0, $8JsGL.default)({
        defaultTheme: (0, $1M7cg.default)
    }, options));
}
var $6a23732b67f2ab3c$export$2e2bcd8739ae039 = $6a23732b67f2ab3c$var$makeStyles;



var $hegEM = parcelRequire("hegEM");
var $zaRlE = parcelRequire("zaRlE");

const $b7c3594b7dfc2588$var$useStyles = (0, $6a23732b67f2ab3c$export$2e2bcd8739ae039)(()=>({
        buzzedInCard: {
            border: "2px solid",
            borderColor: (0, $zaRlE.default)[500],
            borderRadius: 6
        },
        inControlCard: {
            border: "2px solid",
            borderColor: (0, $hegEM.default)[400],
            borderRadius: 6
        },
        card: {}
    }));
function $b7c3594b7dfc2588$export$2e2bcd8739ae039({ contestants: contestants, currentClue: currentClue, modifyScore: modifyScore, setScore: setScore, removeContestant: removeContestant, isAdmin: isAdmin, buzzedInTeam: buzzedInTeam, myTeam: myTeam, teamInControl: teamInControl }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useState(false);
    const styles = $b7c3594b7dfc2588$var$useStyles();
    if (!contestants) return null;
    const teamNames = Object.keys(contestants);
    const handleExpandClick = ()=>{
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $2bbb5df1d77a4f15$exports.Fragment), {
        children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                teamNames.map((name)=>{
                    const team = contestants[name];
                    const players = team.players;
                    let style = styles.card;
                    if (name === teamInControl) style = styles.inControlCard;
                    if (name === buzzedInTeam) style = styles.buzzedInCard;
                    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 6,
                        sm: 4,
                        md: 2,
                        children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
                            className: style,
                            id: name,
                            children: [
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                            variant: "h6",
                                            color: "primary",
                                            children: name
                                        }),
                                        players.length > 1 && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                            variant: "h6",
                                            children: players.join(", ")
                                        }),
                                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                team.score,
                                                " points"
                                            ]
                                        }),
                                        team.dailyDoubleWager !== $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)("p", {
                                            children: [
                                                "Wager ",
                                                team.dailyDoubleWager
                                            ]
                                        }),
                                        team.buzzInTime !== $c2546d3bb9678472$exports.NO_BUZZ_IN_TIME && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)("p", {
                                            children: [
                                                "Buzz in ",
                                                team.buzzInTime / 1000,
                                                "s"
                                            ]
                                        })
                                    ]
                                }),
                                isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $0612e7853ce39c72$export$2e2bcd8739ae039), {
                                    in: expanded,
                                    timeout: "auto",
                                    unmountOnExit: true,
                                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                                                id: "text-input-id",
                                                label: "Score",
                                                variant: "outlined",
                                                onChange: (e)=>{
                                                    if (e.target.value) setScore(name, Number(e.target.value));
                                                }
                                            }),
                                            isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                                                onClick: ()=>removeContestant(name),
                                                children: "Remove"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, name)
                    }, name);
                }),
                isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                        onClick: handleExpandClick,
                        "aria-expanded": expanded,
                        "aria-label": "edit contestants",
                        children: "Edit"
                    })
                })
            ]
        })
    });
}



parcelRequire("5KQk5");





var $5KQk5 = parcelRequire("5KQk5");

var $S2OIO = parcelRequire("S2OIO");

var $hl9SO = parcelRequire("hl9SO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $fHk6u = parcelRequire("fHk6u");

var $5KQk5 = parcelRequire("5KQk5");






function $fa32f54a753e3edc$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $fa32f54a753e3edc$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $fa32f54a753e3edc$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
    var movedRef = $5KQk5.useRef(false);
    var nodeRef = $5KQk5.useRef(null);
    var activatedRef = $5KQk5.useRef(false);
    var syntheticEventRef = $5KQk5.useRef(false);
    $5KQk5.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $5KQk5.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $fa32f54a753e3edc$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $5KQk5.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $fa32f54a753e3edc$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $5KQk5.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $fa32f54a753e3edc$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $fbfd3bf73dda8687$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, /*#__PURE__*/ $5KQk5.cloneElement(children, childrenProps));
}
var $fa32f54a753e3edc$export$2e2bcd8739ae039 = $fa32f54a753e3edc$var$ClickAwayListener;




var $f0yL6 = parcelRequire("f0yL6");




var $S2OIO = parcelRequire("S2OIO");

var $hl9SO = parcelRequire("hl9SO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");


var $a71XF = parcelRequire("a71XF");
var $43e3ff4b216fa8ee$export$9dd6ff9ea0189349 = function styles(theme) {
    var emphasis = theme.palette.type === "light" ? 0.8 : 0.98;
    var backgroundColor = (0, $a71XF.emphasize)(theme.palette.background.default, emphasis);
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({}, theme.typography.body2, (0, $hl9SO.default)({
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1
        }, theme.breakpoints.up("sm"), {
            flexGrow: "initial",
            minWidth: 288
        })),
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $43e3ff4b216fa8ee$var$SnackbarContent = /*#__PURE__*/ $5KQk5.forwardRef(function SnackbarContent(props, ref) {
    var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, other = (0, $S2OIO.default)(props, [
        "action",
        "classes",
        "className",
        "message",
        "role"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $fb5be71a198f5535$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $6479q.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.message
    }, message), action ? /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.action
    }, action) : null);
});
var $43e3ff4b216fa8ee$export$2e2bcd8739ae039 = (0, $3VtpS.default)($43e3ff4b216fa8ee$export$9dd6ff9ea0189349, {
    name: "MuiSnackbarContent"
})($43e3ff4b216fa8ee$var$SnackbarContent);


var $5fc51b83b223c9ba$export$9dd6ff9ea0189349 = function styles(theme) {
    var top1 = {
        top: 8
    };
    var bottom1 = {
        bottom: 8
    };
    var right = {
        justifyContent: "flex-end"
    };
    var left = {
        justifyContent: "flex-start"
    };
    var top3 = {
        top: 24
    };
    var bottom3 = {
        bottom: 24
    };
    var right3 = {
        right: 24
    };
    var left3 = {
        left: 24
    };
    var center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return {
        /* Styles applied to the root element. */ root: {
            zIndex: theme.zIndex.snackbar,
            position: "fixed",
            display: "flex",
            left: 8,
            right: 8,
            justifyContent: "center",
            alignItems: "center"
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */ anchorOriginTopCenter: (0, $8JsGL.default)({}, top1, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({}, top3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */ anchorOriginBottomCenter: (0, $8JsGL.default)({}, bottom1, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({}, bottom3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */ anchorOriginTopRight: (0, $8JsGL.default)({}, top1, right, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({
            left: "auto"
        }, top3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */ anchorOriginBottomRight: (0, $8JsGL.default)({}, bottom1, right, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({
            left: "auto"
        }, bottom3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */ anchorOriginTopLeft: (0, $8JsGL.default)({}, top1, left, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({
            right: "auto"
        }, top3, left3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */ anchorOriginBottomLeft: (0, $8JsGL.default)({}, bottom1, left, (0, $hl9SO.default)({}, theme.breakpoints.up("sm"), (0, $8JsGL.default)({
            right: "auto"
        }, bottom3, left3)))
    };
};
var $5fc51b83b223c9ba$var$Snackbar = /*#__PURE__*/ $5KQk5.forwardRef(function Snackbar(props, ref) {
    var action = props.action, _props$anchorOrigin = props.anchorOrigin;
    _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "bottom",
        horizontal: "center"
    } : _props$anchorOrigin;
    var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $2b412461af9d23b9$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
        enter: (0, $fHk6u.duration).enteringScreen,
        exit: (0, $fHk6u.duration).leavingScreen
    } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0, $S2OIO.default)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "classes",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var timerAutoHide = $5KQk5.useRef();
    var _React$useState = $5KQk5.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var handleClose = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = (0, $46d218e63f6df27d$export$2e2bcd8739ae039)(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $5KQk5.useEffect(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    var handleResume = $5KQk5.useCallback(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, "clickaway");
    };
    var handleExited = function handleExited() {
        setExited(true);
    };
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    $5KQk5.useEffect(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ $5KQk5.createElement((0, $fa32f54a753e3edc$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), /*#__PURE__*/ $5KQk5.createElement("div", (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, classes["anchorOrigin".concat((0, $f0yL6.default)(vertical)).concat((0, $f0yL6.default)(horizontal))], className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), /*#__PURE__*/ $5KQk5.createElement(TransitionComponent, (0, $8JsGL.default)({
        appear: true,
        in: open,
        onEnter: (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(handleEnter, onEnter),
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, $07c413e4fbf7ef18$export$2e2bcd8739ae039)(handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === "top" ? "down" : "up"
    }, TransitionProps), children || /*#__PURE__*/ $5KQk5.createElement((0, $43e3ff4b216fa8ee$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        message: message,
        action: action
    }, ContentProps)))));
});
var $5fc51b83b223c9ba$export$2e2bcd8739ae039 = (0, $3VtpS.default)($5fc51b83b223c9ba$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiSnackbar"
})($5fc51b83b223c9ba$var$Snackbar);



var $S2OIO = parcelRequire("S2OIO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $a71XF = parcelRequire("a71XF");
var $3VtpS = parcelRequire("3VtpS");


var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $3b6ea3ee7fde7e6b$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $793a5762b5a51b7b$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $2bc3f1908a60c038$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $d9b0c94770810fc3$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");



var $5KQk5 = parcelRequire("5KQk5");

var $6pM8C = parcelRequire("6pM8C");
var /**
 * @ignore - internal component.
 */ $b7edb4183fe2e8cf$export$2e2bcd8739ae039 = (0, $6pM8C.default)(/*#__PURE__*/ $5KQk5.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");




var $f0yL6 = parcelRequire("f0yL6");
var $1ff01b97b1210f32$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = theme.palette.type === "light" ? (0, $a71XF.darken) : (0, $a71XF.lighten);
    var getBackgroundColor = theme.palette.type === "light" ? (0, $a71XF.lighten) : (0, $a71XF.darken);
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({}, theme.typography.body2, {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "transparent",
            display: "flex",
            padding: "6px 16px"
        }),
        /* Styles applied to the root element if `variant="standard"` and `color="success"`. */ standardSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="info"`. */ standardInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */ standardWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="error"`. */ standardError: {
            color: getColor(theme.palette.error.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */ outlinedSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            border: "1px solid ".concat(theme.palette.success.main),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */ outlinedInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            border: "1px solid ".concat(theme.palette.info.main),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */ outlinedWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            border: "1px solid ".concat(theme.palette.warning.main),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */ outlinedError: {
            color: getColor(theme.palette.error.main, 0.6),
            border: "1px solid ".concat(theme.palette.error.main),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="filled"` and `color="success"`. */ filledSuccess: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.success.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="info"`. */ filledInfo: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.info.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */ filledWarning: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.warning.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="error"`. */ filledError: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.error.main
        },
        /* Styles applied to the icon wrapper element. */ icon: {
            marginRight: 12,
            padding: "7px 0",
            display: "flex",
            fontSize: 22,
            opacity: 0.9
        },
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $1ff01b97b1210f32$var$defaultIconMapping = {
    success: /*#__PURE__*/ $5KQk5.createElement((0, $3b6ea3ee7fde7e6b$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ $5KQk5.createElement((0, $793a5762b5a51b7b$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ $5KQk5.createElement((0, $2bc3f1908a60c038$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ $5KQk5.createElement((0, $d9b0c94770810fc3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
var $1ff01b97b1210f32$var$_ref = /*#__PURE__*/ $5KQk5.createElement((0, $b7edb4183fe2e8cf$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $1ff01b97b1210f32$var$Alert = /*#__PURE__*/ $5KQk5.forwardRef(function Alert(props, ref) {
    var action = props.action, children = props.children, classes = props.classes, className = props.className, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? "Close" : _props$closeText, color = props.color, icon = props.icon, _props$iconMapping = props.iconMapping, iconMapping = _props$iconMapping === void 0 ? $1ff01b97b1210f32$var$defaultIconMapping : _props$iconMapping, onClose = props.onClose, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, _props$severity = props.severity, severity = _props$severity === void 0 ? "success" : _props$severity, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $S2OIO.default)(props, [
        "action",
        "children",
        "classes",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "variant"
    ]);
    return /*#__PURE__*/ $5KQk5.createElement((0, $fb5be71a198f5535$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        role: role,
        square: true,
        elevation: 0,
        className: (0, $6479q.default)(classes.root, classes["".concat(variant).concat((0, $f0yL6.default)(color || severity))], className),
        ref: ref
    }, other), icon !== false ? /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.icon
    }, icon || iconMapping[severity] || $1ff01b97b1210f32$var$defaultIconMapping[severity]) : null, /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.message
    }, children), action != null ? /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.action
    }, action) : null, action == null && onClose ? /*#__PURE__*/ $5KQk5.createElement("div", {
        className: classes.action
    }, /*#__PURE__*/ $5KQk5.createElement((0, $2716d8fe3b58de60$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
    }, $1ff01b97b1210f32$var$_ref)) : null);
});
var $1ff01b97b1210f32$export$2e2bcd8739ae039 = (0, $3VtpS.default)($1ff01b97b1210f32$export$9dd6ff9ea0189349, {
    name: "MuiAlert"
})($1ff01b97b1210f32$var$Alert);


function $91b25be51f9234dc$var$Alert(props) {
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $1ff01b97b1210f32$export$2e2bcd8739ae039), {
        elevation: 6,
        variant: "filled",
        ...props
    });
}
function $91b25be51f9234dc$export$2e2bcd8739ae039({ submit: submit }) {
    const [submission, setSubmission] = (0, $5KQk5.useState)("");
    const [snackbarOpen, setSnackbarOpen] = (0, $5KQk5.useState)(false);
    const onClickHandler = ()=>{
        submit(submission);
        setSnackbarOpen(true);
    };
    const handleClose = (event, reason)=>{
        if (reason === "clickaway") return;
        setSnackbarOpen(false);
    };
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $a2b48df6c47c4d4e$export$2e2bcd8739ae039), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $02413e5e812e18c5$export$2e2bcd8739ae039), {
                fullWidth: true,
                margin: "normal",
                label: "Final Jeopardy Answer",
                variant: "outlined",
                placeholder: "Enter answer",
                value: submission,
                onChange: (e)=>setSubmission(e.target.value)
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                variant: "outlined",
                color: "primary",
                onClick: onClickHandler,
                children: "Submit"
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $5fc51b83b223c9ba$export$2e2bcd8739ae039), {
                open: snackbarOpen,
                autoHideDuration: 1500,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)($91b25be51f9234dc$var$Alert, {
                    onClose: handleClose,
                    severity: "info",
                    children: "Submitted"
                })
            })
        ]
    });
}


function $18187e8a3ebbd690$export$2e2bcd8739ae039({ finalJeopardyBoard: finalJeopardyBoard, team: team, isAdmin: isAdmin, isSpectator: isSpectator, submitWager: submitWager, submitFinal: submitFinal, currentScore: currentScore, wagersOpen: wagersOpen, closeWagers: closeWagers, closeSubmissions: closeSubmissions, submissionsOpen: submissionsOpen }) {
    // TOOD: Better error handling when there are no contestants
    let checkFinalJeopardyWager = (wager)=>{
        if (wager > currentScore) return "Maximum wager is " + currentScore;
        else if (wager < 0) return "You must wager some money.";
    };
    const canShowAnswer = !wagersOpen && isAdmin; // TODO reveal if all contestants answers are revealed
    // TODO: Consider centering submit/wager diaglogue on form
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                    variant: "h6",
                    color: "primary",
                    children: finalJeopardyBoard.categories[0]
                }),
                !wagersOpen && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                    variant: "subtitle1",
                    children: finalJeopardyBoard.clues[0][0].question
                }),
                canShowAnswer && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                    variant: "subtitle1",
                    color: "textSecondary",
                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)("em", {
                        children: finalJeopardyBoard.clues[0][0].answer
                    })
                }),
                !isAdmin && !isSpectator && team && team.finalJeopardyWager === $c2546d3bb9678472$exports.NO_FINAL_JEOPARDY_WAGER && wagersOpen && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $50dfa2fc748f8e05$export$2e2bcd8739ae039), {
                    submitWager: submitWager,
                    validateWager: checkFinalJeopardyWager
                }),
                !isAdmin && !isSpectator && team && submissionsOpen && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $91b25be51f9234dc$export$2e2bcd8739ae039), {
                    submit: submitFinal
                }),
                isAdmin && wagersOpen && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: closeWagers,
                    children: "Close Wagering Period"
                }),
                isAdmin && !wagersOpen && submissionsOpen && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: closeSubmissions,
                    children: "Close Submission Period"
                })
            ]
        })
    });
}



parcelRequire("5KQk5");


function $b86c8350f2b8ffcf$export$2e2bcd8739ae039({ contestants: contestants, modifyScore: modifyScore, isAdmin: isAdmin, reveal: reveal, submissionsOpen: submissionsOpen, wageringOpen: wageringOpen }) {
    if (!contestants) return null;
    const teamNames = Object.keys(contestants);
    // Sort by score in ascending order
    teamNames.sort((t1, t2)=>{
        return contestants[t1].score - contestants[t2].score;
    });
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: teamNames.map((name)=>{
            var _contestants_name, _contestants_name1;
            let wager = contestants[name].finalJeopardyWager;
            let answer = contestants[name].submission;
            const revealed = contestants[name].revealed;
            answer = answer !== $c2546d3bb9678472$exports.NO_FINAL_JEOPARDY_SUBMISSION ? answer : "No answer";
            wager = wager !== $c2546d3bb9678472$exports.NO_FINAL_JEOPARDY_WAGER ? wager : 0;
            return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                sm: 4,
                md: 2,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80ab4759404597e0$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $1a9a1c9fa179ada3$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                    variant: "h6",
                                    color: "primary",
                                    children: name
                                }),
                                isAdmin && !revealed && ((_contestants_name = contestants[name]) === null || _contestants_name === void 0 ? void 0 : _contestants_name.finalJeopardyWager) !== $c2546d3bb9678472$exports.NO_FINAL_JEOPARDY_WAGER && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                    children: "Wager submitted"
                                }),
                                isAdmin && !revealed && ((_contestants_name1 = contestants[name]) === null || _contestants_name1 === void 0 ? void 0 : _contestants_name1.submission) !== $c2546d3bb9678472$exports.NO_FINAL_JEOPARDY_SUBMISSION && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                    children: "Answer submitted"
                                }),
                                revealed && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    children: [
                                        " Answer: ",
                                        answer,
                                        " "
                                    ]
                                }),
                                revealed && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                                    variant: "body1",
                                    children: [
                                        " Wager: ",
                                        wager
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $5560f57904113854$export$2e2bcd8739ae039), {
                            children: [
                                isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: ()=>reveal(name),
                                    disabled: submissionsOpen || wageringOpen,
                                    children: "Reveal"
                                }),
                                isAdmin && revealed && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $2bbb5df1d77a4f15$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                                            color: "secondary",
                                            onClick: ()=>modifyScore(name, -wager),
                                            children: "Incorrect"
                                        }),
                                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $64a3ea796db72b22$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            onClick: ()=>modifyScore(name, wager),
                                            children: "Correct"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, name)
            }, name);
        })
    });
}




var $5KQk5 = parcelRequire("5KQk5");

var $4ceec8ef8f3ad2f0$exports = {};
"use strict";
var $895a75047e046f6b$exports = {};
function $895a75047e046f6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$895a75047e046f6b$exports = $895a75047e046f6b$var$_interopRequireDefault, $895a75047e046f6b$exports.__esModule = true, $895a75047e046f6b$exports["default"] = $895a75047e046f6b$exports;


var $fa8e7a56bc3d36b4$exports = {};
var $c83c039f952ac704$exports = {};
function $c83c039f952ac704$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c83c039f952ac704$exports = $c83c039f952ac704$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c83c039f952ac704$exports.__esModule = true, $c83c039f952ac704$exports["default"] = $c83c039f952ac704$exports, $c83c039f952ac704$var$_typeof(o);
}
$c83c039f952ac704$exports = $c83c039f952ac704$var$_typeof, $c83c039f952ac704$exports.__esModule = true, $c83c039f952ac704$exports["default"] = $c83c039f952ac704$exports;


var $fa8e7a56bc3d36b4$var$_typeof = $c83c039f952ac704$exports.default;
function $fa8e7a56bc3d36b4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fa8e7a56bc3d36b4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fa8e7a56bc3d36b4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $fa8e7a56bc3d36b4$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $fa8e7a56bc3d36b4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
$fa8e7a56bc3d36b4$exports = $fa8e7a56bc3d36b4$var$_interopRequireWildcard, $fa8e7a56bc3d36b4$exports.__esModule = true, $fa8e7a56bc3d36b4$exports["default"] = $fa8e7a56bc3d36b4$exports;


Object.defineProperty($4ceec8ef8f3ad2f0$exports, "__esModule", {
    value: true
});
$4ceec8ef8f3ad2f0$exports.default = void 0;

var $4ceec8ef8f3ad2f0$var$React = $fa8e7a56bc3d36b4$exports((parcelRequire("5KQk5")));

var $4ceec8ef8f3ad2f0$var$_createSvgIcon = $895a75047e046f6b$exports((parcelRequire("7bqxg")));
var $4ceec8ef8f3ad2f0$var$_default = (0, $4ceec8ef8f3ad2f0$var$_createSvgIcon.default)(/*#__PURE__*/ $4ceec8ef8f3ad2f0$var$React.createElement("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
}), "Share");
$4ceec8ef8f3ad2f0$exports.default = $4ceec8ef8f3ad2f0$var$_default;



function $724a37c65d0fa7d5$var$Alert(props) {
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $1ff01b97b1210f32$export$2e2bcd8739ae039), {
        elevation: 6,
        variant: "filled",
        ...props
    });
}
function $724a37c65d0fa7d5$export$2e2bcd8739ae039({ shareableLink: shareableLink }) {
    const [open, setOpen] = (0, $5KQk5.useState)(false);
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleClose = (event, reason)=>{
        if (reason === "clickaway") return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $2bbb5df1d77a4f15$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $2716d8fe3b58de60$export$2e2bcd8739ae039), {
                "aria-label": "share",
                size: "small",
                onClick: ()=>{
                    navigator.clipboard.writeText(shareableLink);
                    handleClick();
                },
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ceec8ef8f3ad2f0$exports))), {})
            }),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $5fc51b83b223c9ba$export$2e2bcd8739ae039), {
                open: open,
                autoHideDuration: 3000,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)($724a37c65d0fa7d5$var$Alert, {
                    onClose: handleClose,
                    severity: "info",
                    children: "Link copied!"
                })
            })
        ]
    });
}



var $S2OIO = parcelRequire("S2OIO");

var $hl9SO = parcelRequire("hl9SO");

var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");

var $3VtpS = parcelRequire("3VtpS");

var $8JsGL = parcelRequire("8JsGL");

var $S2OIO = parcelRequire("S2OIO");

var $5KQk5 = parcelRequire("5KQk5");


var $6479q = parcelRequire("6479q");


var $3VtpS = parcelRequire("3VtpS");





var $b1a7581438b1ab10$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $b1a7581438b1ab10$var$useEnhancedEffect = typeof window === "undefined" ? $5KQk5.useEffect : $5KQk5.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $b1a7581438b1ab10$var$ListItem = /*#__PURE__*/ $5KQk5.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $S2OIO.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $S2OIO.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $5KQk5.useContext((0, $13bbc16e6ee68fca$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $5KQk5.useRef(null);
    $b1a7581438b1ab10$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $5KQk5.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $3b05a7d7a92017fb$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $5KQk5.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $e2b5c52bb63103a5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $5eb8f8fdb9f4db9c$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $8JsGL.default)({
        className: (0, $6479q.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $6479q.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $b84a8edbcc74a2d5$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $5KQk5.createElement((0, $13bbc16e6ee68fca$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $5KQk5.createElement(ContainerComponent, (0, $8JsGL.default)({
            className: (0, $6479q.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $5KQk5.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $5KQk5.createElement((0, $13bbc16e6ee68fca$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $5KQk5.createElement(Component, (0, $8JsGL.default)({
        ref: handleRef
    }, componentProps), children));
});
var $b1a7581438b1ab10$export$2e2bcd8739ae039 = (0, $3VtpS.default)($b1a7581438b1ab10$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($b1a7581438b1ab10$var$ListItem);


var $d9a92c7bd4789de6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8JsGL.default)({}, theme.typography.body1, (0, $hl9SO.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $8JsGL.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $d9a92c7bd4789de6$var$MenuItem = /*#__PURE__*/ $5KQk5.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $S2OIO.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $5KQk5.createElement((0, $b1a7581438b1ab10$export$2e2bcd8739ae039), (0, $8JsGL.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $8JsGL.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $6479q.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $d9a92c7bd4789de6$export$2e2bcd8739ae039 = (0, $3VtpS.default)($d9a92c7bd4789de6$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($d9a92c7bd4789de6$var$MenuItem);



const $aecf3a98ff2273e9$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
class $aecf3a98ff2273e9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).Component {
    // Similar to componentDidMount and componentDidUpdate:
    // Runs when a user first loads page
    componentDidMount() {
        let socket;
        if (this.props.serverUrl) // Use custom server URL if provided
        socket = new WebSocket(this.props.serverUrl);
        else if ($aecf3a98ff2273e9$var$isLocalhost) socket = new WebSocket("ws://localhost:8080");
        else socket = new WebSocket("wss://ws.jeoparty.fun/ws");
        this.apiClient.addSocket(socket);
        // This could be moved to the constructor
        // if (!this.apiClient.isAdmin) {
        //   this.apiClient.setTeamName(this.props.match.params.teamName)
        // }
        socket.onopen = this.apiClient.onSocketOpen;
        socket.onmessage = (event)=>{
            console.debug("got message");
            this.apiClient.onSocketMessage(event, this.state);
        };
        socket.onerror = this.apiClient.onSocketError;
        socket.onclose = this.apiClient.onSocketClose;
    }
    componentDidUpdate(prevProps) {
        if (this.props.teamName && prevProps.teamName !== this.props.teamName) {
            console.debug("did update");
            this.apiClient.setTeamName(this.props.teamName);
            if (this.props.player) this.apiClient.setPlayerName(this.props.player);
            this.apiClient.contestantRejoin();
        }
    }
    render() {
        const isAdmin = this.apiClient.isAdmin;
        const isSpectator = this.apiClient.isSpectator();
        let currentRound;
        if (this.state.currentRound !== undefined) switch(this.state.currentRound){
            case $c2546d3bb9678472$exports.Round.SINGLE:
                currentRound = this.state.singleJeopardy;
                break;
            case $c2546d3bb9678472$exports.Round.DOUBLE:
                currentRound = this.state.doubleJeopardy;
                break;
            case $c2546d3bb9678472$exports.Round.FINAL:
                currentRound = this.state.finalJeopardy;
                break;
            case $c2546d3bb9678472$exports.Round.DONE:
                break;
        }
        let cq = this.state.currentQuestion;
        let currentClue;
        if (currentRound && cq !== undefined && cq !== $c2546d3bb9678472$exports.NO_QUESTION) {
            const row = Math.floor(cq / 6);
            const col = cq % 6;
            currentClue = currentRound.clues[row][col];
        }
        let selectClue;
        if (isAdmin && !currentClue) selectClue = this.apiClient.selectClue;
        let roundName;
        switch(this.state.currentRound){
            case $c2546d3bb9678472$exports.Round.SINGLE:
                roundName = "Jeoparty!";
                break;
            case $c2546d3bb9678472$exports.Round.DOUBLE:
                roundName = "Double Jeoparty!";
                break;
            case $c2546d3bb9678472$exports.Round.FINAL:
                roundName = "FINAL JEOPARTY!!!";
                break;
            default:
                roundName = "";
        }
        let shareableLink = window.location.origin + "/" + this.props.sessionId;
        // sanity checks
        if (isAdmin !== (this.props.userType === $c2546d3bb9678472$exports.GUIUserType.ADMIN)) {
            console.error("admin state mismatch");
            return "error";
        }
        if (this.props.userType === $c2546d3bb9678472$exports.GUIUserType.PLAYER && (!this.props.teamName || !this.props.player)) {
            console.error("team or player should be defined");
            return "error";
        }
        return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
            container: true,
            spacing: 4,
            children: [
                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                            variant: "h4",
                            component: "h1",
                            color: "primary",
                            children: roundName
                        }),
                        !isAdmin && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            color: "textSecondary",
                            children: [
                                this.state.airdate,
                                "\xa0",
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $724a37c65d0fa7d5$export$2e2bcd8739ae039), {
                                    shareableLink: shareableLink
                                })
                            ]
                        }),
                        isAdmin && this.apiClient.gameList.length > 0 && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $2bbb5df1d77a4f15$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $58a2c7b423f74ed4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826e91e893e02a40$export$2e2bcd8739ae039), {
                                        value: this.state.airdate,
                                        variant: "outlined",
                                        onChange: (e)=>this.apiClient.selectGame(e.target.value),
                                        children: this.apiClient.gameList.map((item)=>/*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $d9a92c7bd4789de6$export$2e2bcd8739ae039), {
                                                value: item,
                                                children: item
                                            }, item))
                                    })
                                }),
                                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $724a37c65d0fa7d5$export$2e2bcd8739ae039), {
                                    shareableLink: shareableLink
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    md: 8,
                    xs: 12,
                    children: [
                        currentRound !== undefined && this.state.currentRound !== $c2546d3bb9678472$exports.Round.FINAL && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $c788b9d41797a57c$export$2e2bcd8739ae039), {
                            currentRound: currentRound,
                            selectClue: selectClue
                        }),
                        currentRound !== undefined && this.state.currentRound === $c2546d3bb9678472$exports.Round.FINAL && this.state.contestants && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $18187e8a3ebbd690$export$2e2bcd8739ae039), {
                            finalJeopardyBoard: currentRound,
                            team: this.state.contestants[this.props.teamName || ""],
                            submitWager: this.apiClient.sendWager,
                            submitFinal: this.apiClient.sendSubmission,
                            isAdmin: isAdmin,
                            isSpectator: isSpectator,
                            closeWagers: this.apiClient.closeWagers,
                            closeSubmissions: this.apiClient.closeSubmissions,
                            wagersOpen: this.state.finalJeopardyWagersOpen || false,
                            submissionsOpen: this.state.submissionsOpen || false,
                            currentScore: this.state.contestants && !isAdmin && !isSpectator ? this.state.contestants[this.apiClient.teamName].score : 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    md: 4,
                    xs: 12,
                    children: [
                        !this.apiClient.isSpectator() && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $f41ba44b69a44412$export$2e2bcd8739ae039), {
                            isAdmin: isAdmin,
                            buzzerOpen: this.state.buzzerOpen ? this.state.buzzerOpen : false,
                            openClue: !!currentClue,
                            apiClientBuzz: this.apiClient.buzz,
                            openBuzzer: this.apiClient.openBuzzer
                        }),
                        currentClue !== undefined && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $797661d28c0bacc5$export$2e2bcd8739ae039), {
                            currentClue: currentClue,
                            isAdmin: isAdmin,
                            buzzedInTeam: this.state.buzzedInTeam ? this.state.buzzedInTeam : "",
                            teamInControl: this.state.teamInControl ? this.state.teamInControl : "",
                            modifyScore: this.apiClient.modifyScore,
                            dailyDoubleWager: this.state.dailyDoubleWager ? this.state.dailyDoubleWager : $c2546d3bb9678472$exports.NO_DAILY_DOUBLE_WAGER,
                            closeClue: this.apiClient.closeClue,
                            controlsBoard: this.apiClient.teamName === this.state.teamInControl,
                            currentScore: this.state.contestants && !isAdmin && !isSpectator ? this.state.contestants[this.apiClient.teamName].score : 0,
                            submitWager: this.apiClient.sendWager
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $b7c3594b7dfc2588$export$2e2bcd8739ae039), {
                        contestants: this.state.contestants,
                        currentClue: currentClue,
                        isAdmin: isAdmin,
                        modifyScore: this.apiClient.modifyScore,
                        setScore: this.apiClient.setScore,
                        removeContestant: this.apiClient.removeContestant,
                        buzzedInTeam: this.state.buzzedInTeam,
                        myTeam: this.props.teamName,
                        teamInControl: this.state.teamInControl
                    })
                }),
                currentRound !== undefined && this.state.currentRound === $c2546d3bb9678472$exports.Round.FINAL && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $826793a32e582c6b$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: [
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $80fc70a062206702$export$2e2bcd8739ae039), {
                            variant: "h5",
                            children: "Final Jeopardy Answers"
                        }),
                        /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $b86c8350f2b8ffcf$export$2e2bcd8739ae039), {
                            contestants: this.state.contestants,
                            modifyScore: this.apiClient.modifyScore,
                            isAdmin: isAdmin,
                            reveal: this.apiClient.reveal,
                            wageringOpen: this.state.finalJeopardyWagersOpen || false,
                            submissionsOpen: this.state.submissionsOpen || false
                        })
                    ]
                })
            ]
        });
    }
    // TODO: Because of routing memory leak introduced by callback to this.setState in apiClient
    //       Follow the below link to fix it
    //       https://www.robinwieruch.de/react-warning-cant-call-setstate-on-an-unmounted-component
    constructor(props){
        super(props);
        this.state = {};
        let anAdmin = props.userType === $c2546d3bb9678472$exports.GUIUserType.ADMIN;
        this.apiClient = new (0, $7f247ecbc0ccba65$export$2e2bcd8739ae039)(this.setState.bind(this), anAdmin, props.sessionId, props.teamName, props.player);
    }
}



var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");


var $3VtpS = parcelRequire("3VtpS");

var $7ba205b73ca38336$export$c0bb0b647f701bb5 = {
    WebkitFontSmoothing: "antialiased",
    // Antialiasing.
    MozOsxFontSmoothing: "grayscale",
    // Antialiasing.
    // Change from `box-sizing: content-box` so that `width`
    // is not affected by `padding` or `border`.
    boxSizing: "border-box"
};
var $7ba205b73ca38336$export$32180ef41b15b513 = function body(theme) {
    return (0, $8JsGL.default)({
        color: theme.palette.text.primary
    }, theme.typography.body2, {
        backgroundColor: theme.palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: theme.palette.common.white
        }
    });
};
var $7ba205b73ca38336$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        "@global": {
            html: $7ba205b73ca38336$export$c0bb0b647f701bb5,
            "*, *::before, *::after": {
                boxSizing: "inherit"
            },
            "strong, b": {
                fontWeight: theme.typography.fontWeightBold
            },
            body: (0, $8JsGL.default)({
                margin: 0
            }, $7ba205b73ca38336$export$32180ef41b15b513(theme), {
                // Add support for document.body.requestFullScreen().
                // Other elements, if background transparent, are not supported.
                "&::backdrop": {
                    backgroundColor: theme.palette.background.default
                }
            })
        }
    };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $7ba205b73ca38336$var$CssBaseline(props) {
    /* eslint-disable no-unused-vars */ var _props$children = props.children, children = _props$children === void 0 ? null : _props$children, classes = props.classes;
    /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $5KQk5.createElement($5KQk5.Fragment, null, children);
}
var $7ba205b73ca38336$export$2e2bcd8739ae039 = (0, $3VtpS.default)($7ba205b73ca38336$export$9dd6ff9ea0189349, {
    name: "MuiCssBaseline"
})($7ba205b73ca38336$var$CssBaseline);



var $dQI1p = parcelRequire("dQI1p");
var $8JsGL = parcelRequire("8JsGL");

var $5KQk5 = parcelRequire("5KQk5");



var $1RDt7 = parcelRequire("1RDt7");

var $eV3HM = parcelRequire("eV3HM");

var $150Me = parcelRequire("150Me");
function $22cdfe877408d2ef$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8JsGL.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $22cdfe877408d2ef$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $eV3HM.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $22cdfe877408d2ef$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $150Me.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).createElement((0, $1RDt7.default).Provider, {
        value: theme
    }, children);
}
var $22cdfe877408d2ef$export$2e2bcd8739ae039 = $22cdfe877408d2ef$var$ThemeProvider;



var $cbNhd = parcelRequire("cbNhd");
var $hegEM = parcelRequire("hegEM");
var $zaRlE = parcelRequire("zaRlE");

// https://material-ui.com/customization/theming/
// https://material.io/resources/color/
const $06e98cb2cbbf760f$var$muiTheme = (0, $dQI1p.default)({
    palette: {
        type: "dark",
        primary: {
            main: (0, $zaRlE.default)[500]
        },
        secondary: {
            main: (0, $cbNhd.default)[400]
        },
        info: {
            main: (0, $hegEM.default)[800]
        },
        background: {
            paper: "#343970"
        }
    },
    props: {
        MuiTypography: {
            variantMapping: {
                h4: "h1",
                h5: "h2",
                h6: "h3"
            }
        }
    },
    typography: {
        fontSize: 15,
        fontFamily: "Public Sans"
    }
});
function $06e98cb2cbbf760f$var$parseURL(url) {
    const urlPath = url.pathname;
    const urlParams = url.searchParams;
    const splitURL = urlPath.split("/");
    const session = splitURL[1];
    let userType = $c2546d3bb9678472$exports.GUIUserType.UNDEFINED;
    let player = undefined;
    let team = undefined;
    let server = undefined;
    if (session !== "") // parse team and player params
    switch(splitURL[2]){
        case "admin":
            userType = $c2546d3bb9678472$exports.GUIUserType.ADMIN;
            break;
        case "play":
            // parse out team and player names
            userType = $c2546d3bb9678472$exports.GUIUserType.PLAYER;
            player = urlParams.get("player") || undefined;
            team = urlParams.get("team") || player;
            break;
        case "watch":
            userType = $c2546d3bb9678472$exports.GUIUserType.OBSERVER;
            break;
    }
    // parse server URL parameter
    server = urlParams.get("server") || undefined;
    return {
        session: session,
        userType: userType,
        player: player,
        team: team,
        server: server
    };
}
function $06e98cb2cbbf760f$var$updateURL(session, userType, player, team, server) {
    const url = new URL(window.location.toString());
    url.pathname = "/" + session;
    switch(userType){
        case $c2546d3bb9678472$exports.GUIUserType.ADMIN:
            url.pathname += "/admin";
            break;
        case $c2546d3bb9678472$exports.GUIUserType.PLAYER:
            url.pathname += "/play";
            break;
        case $c2546d3bb9678472$exports.GUIUserType.OBSERVER:
            url.pathname += "/watch";
            break;
    }
    if (player) url.searchParams.set("player", player);
    if (team) url.searchParams.set("team", team);
    if (server) url.searchParams.set("server", server);
    const historyState = {
        session: session,
        userType: userType,
        player: player,
        team: team,
        server: server
    };
    console.log("pushing history state with new url", url.toString(), "and state object", historyState);
    window.history.pushState(historyState, "", url.toString());
}
function $06e98cb2cbbf760f$export$2e2bcd8739ae039() {
    const parsedURL = $06e98cb2cbbf760f$var$parseURL(new URL(window.location.toString()));
    // define state
    const [session, setSession] = (0, $5KQk5.useState)(parsedURL.session);
    const [userType, setUserType] = (0, $5KQk5.useState)(parsedURL.userType);
    const [player, setPlayer] = (0, $5KQk5.useState)(parsedURL.player);
    const [team, setTeam] = (0, $5KQk5.useState)(parsedURL.team || parsedURL.player); // behavior with no team is undefined, so we fallback on player name
    const [server, setServer] = (0, $5KQk5.useState)(parsedURL.server);
    (0, $5KQk5.useEffect)(()=>{
        // needed if user goes back or forward
        window.addEventListener("popstate", (event)=>{
            console.log("window popstate at location: " + document.location);
            if (event.state) {
                // use state that we earlier provided to history.pushState earlier if it exists
                console.log("popstate state: " + JSON.stringify(event.state));
                setSession(event.state.session);
                setUserType(event.state.userType);
                setPlayer(event.state.player);
                setTeam(event.state.team || event.state.player);
                setServer(event.state.server);
            } else {
                // otherwise parse the url again
                const parsedURL = $06e98cb2cbbf760f$var$parseURL(new URL(window.location.toString()));
                setSession(parsedURL.session);
                setUserType(parsedURL.userType);
                setPlayer(parsedURL.player);
                setTeam(parsedURL.team || parsedURL.player);
                setServer(parsedURL.server);
            }
        });
    });
    const updateAndGo = (sessionArg, userTypeArg, playerArg, teamArg, serverArg)=>{
        setSession(sessionArg);
        setUserType(userTypeArg);
        setPlayer(playerArg);
        setTeam(teamArg || playerArg); // behavior with no team is undefined, so we fallback on player name
        setServer(serverArg);
        $06e98cb2cbbf760f$var$updateURL(sessionArg, userTypeArg, playerArg, teamArg, serverArg);
    };
    const readyToPlay = session && session !== "" && userType && (userType === $c2546d3bb9678472$exports.GUIUserType.PLAYER && player && team || userType === $c2546d3bb9678472$exports.GUIUserType.ADMIN || userType === $c2546d3bb9678472$exports.GUIUserType.OBSERVER);
    return /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $22cdfe877408d2ef$export$2e2bcd8739ae039), {
        theme: $06e98cb2cbbf760f$var$muiTheme,
        children: [
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $7ba205b73ca38336$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsxs)((0, $fbeaa9276e0ae0d4$export$2e2bcd8739ae039), {
                maxWidth: "xl",
                style: {
                    padding: 20
                },
                children: [
                    !readyToPlay && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $0cfbfa2381a851c1$export$2e2bcd8739ae039), {
                        sessionId: session,
                        userType: userType,
                        player: player,
                        teamName: team,
                        server: server,
                        goCallback: updateAndGo
                    }),
                    readyToPlay && /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $aecf3a98ff2273e9$export$2e2bcd8739ae039), {
                        sessionId: session,
                        userType: userType,
                        player: player,
                        teamName: team,
                        serverUrl: server
                    })
                ]
            })
        ]
    });
}


(0, (/*@__PURE__*/$parcel$interopDefault($e2b5c52bb63103a5$exports))).render(/*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5KQk5))).StrictMode, {
    children: /*#__PURE__*/ (0, $2bbb5df1d77a4f15$exports.jsx)((0, $06e98cb2cbbf760f$export$2e2bcd8739ae039), {})
}), document.getElementById("root"));


//# sourceMappingURL=index.599946cf.js.map
